window.FNOL_COMPONENT_VERSION = "0.8.75";
import React, { createContext, useContext, useCallback, useState, forwardRef, useEffect, useRef, Fragment } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { UiIcon, Span, Heading, Link, ProgressStepper, SpotIcon, CheckboxGroup, Button, Card, Spinner, Metric, Modal as Modal$2, theme as theme$1, Select, Item, TextInput as TextInput$2, ComboBox, Hr, Alert, Tooltip, RadioGroup, Textarea, Radio, DesignSystemProvider } from '@icg360/design-system';
import { useFormikContext, Field, ErrorMessage, FieldArray, Form, Formik } from 'formik';
import { castDraft, enableES5 } from 'immer';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import classNames from 'classnames';
import { format, addDays } from 'date-fns';
import SVG from 'react-inlinesvg';
import dateFnsFormat from 'date-fns/format';
import StringMask from 'string-mask';
import { parse } from 'querystring';
import { useDropzone } from 'react-dropzone';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';
import dateFnsParse from 'date-fns/parse';
import dompurify from 'dompurify';
import Mustache from 'mustache';
import debounce from 'lodash/debounce';
import { useImmerReducer } from 'use-immer';
import { Transition, Dialog } from '@headlessui/react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var primaryTheme = {
    breakpoints: {
        small: '480px',
        medium: '768px',
        large: '1024px',
        xlarge: '1200px',
        xxlarge: '1800px',
    },
    border: {
        accent: '#949300',
        active: '#EFEBF4',
        danger: '#BF2324',
        interactive: '#134e4a',
        neutralDark: '#C4C4C4',
        neutralLight: '#E7E7E7',
        success: '#417718',
        warning: '#FF8200',
    },
    fill: {
        accent: '#949300',
        active: '#EFEBF4',
        canvas: '#F6F6F6',
        danger: '#BF2324',
        dangerLight: '#FFF8F8',
        interactive: '#134e4a',
        quiet: '#747474',
        success: '#417718',
        successLight: '#FAFFF6',
        surface: '#FFFFFF',
        warning: '#FF8200',
        warningLight: '#FFFAF4',
    },
    hairline: {
        default: '#E7E7E7',
    },
    text: {
        danger: '#BF2324',
        default: '#191919',
        interactive: '#134e4a',
        inverse: '#FFFFFF',
        quiet: '#707372',
    },
    fonts: {
        // values mapped to match keystone-ui/stylesheets/base/_fonts.scss
        // except for default
        book: "\n          font-family: \"PostGrotesk\";\n          font-weight: normal;\n          font-style: normal;\n        ",
        bold: "\n          font-family: \"PostGrotesk\";\n          font-weight: bold;\n          font-style: normal;\n        ",
        default: "\n          font-family: \"PostGrotesk\";\n          font-weight: 400;\n          font-style: normal;\n          ",
        light: "\n          font-family: \"PostGrotesk\";\n          font-weight: 300;\n          font-style: normal;\n        ",
        medium: "\n          font-family: \"PostGrotesk\";\n          font-weight: 500;\n          font-style: normal;\n        ",
        thin: "\n          font-family: \"PostGrotesk\";\n          font-weight: 100;\n          font-style: normal;\n        ",
    },
};

var theme = __assign(__assign({}, primaryTheme), { fill: {
        accent: '#949300',
        active: '#EFEBF4',
        canvas: '#F3F2F1',
        danger: '#BF2324',
        dangerLight: '#FFF8F8',
        interactive: '#134e4a',
        quiet: '#747474',
        success: '#417718',
        successLight: '#FAFFF6',
        surface: '#FFFFFF',
        warning: '#FF8200',
        warningLight: '#FFFAF4',
    }, breakpoints: {
        small: '375px',
        medium: '576px',
        large: '992px',
        xlarge: '1200px',
        xxlarge: '1800px',
    }, colors: {
        blue: '#265FC5',
        interactiveDarkened: '#EEF6FC',
        grayHaze: 'rgba(62, 64, 63, 0.9)',
        'text.default': 'rgb(25, 25, 25)',
    }, border: __assign(__assign({}, primaryTheme.border), { neutralLight: "#E2E8F0", neutralDark: "#94A3B8" }), fonts: __assign(__assign({}, primaryTheme.fonts), { 
        // values mapped to match keystone-ui/stylesheets/base/_fonts.scss
        // except for default
        book: "\n          font-family: \"Roboto\";\n          font-weight: normal;\n          font-style: normal;\n        ", bold: "\n          font-family: \"Roboto\";\n          font-weight: bold;\n          font-style: normal;\n        ", default: "\n          font-family: \"Roboto\";\n          font-weight: 400;\n          font-style: normal;\n          ", light: "\n          font-family: \"Roboto\";\n          font-weight: 300;\n          font-style: normal;\n        ", medium: "\n          font-family: \"Roboto\";\n          font-weight: 500;\n          font-style: normal;\n        ", thin: "\n          font-family: \"Roboto\";\n          font-weight: 100;\n          font-style: normal;\n        " }) });
css(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0897072);\n  padding: 40px;\n"], ["\n  background: ", ";\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0897072);\n  padding: 40px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
});
var wrapper = css(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  margin: 0 auto;\n"], ["\n  margin: 0 auto;\n"])));
css(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  box-shadow: inset 0px 0px 1px ", ";\n  border: 1px solid ", ";\n  border-radius: 0px;\n  line-height: 21px;\n  height: 38px;\n  width: 228px;\n  left: 1px;\n  top: 1px;\n  padding-left: 11px;\n  ", ";\n  font-size: 14px;\n  margin: 0;\n  color: ", ";\n\n  ::placeholder {\n    color: #afafaf;\n  }\n"], ["\n  box-shadow: inset 0px 0px 1px ", ";\n  border: 1px solid ", ";\n  border-radius: 0px;\n  line-height: 21px;\n  height: 38px;\n  width: 228px;\n  left: 1px;\n  top: 1px;\n  padding-left: 11px;\n  ", ";\n  font-size: 14px;\n  margin: 0;\n  color: ", ";\n\n  ::placeholder {\n    color: #afafaf;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.border.neutralLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.border.neutralLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.book;
}, function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
});
({
    versionFooter: {
        display: 'block',
        position: 'relative',
        width: '66%',
        extend: "\n      ".concat(theme.fonts.thin, ";\n    "),
    },
});
var templateObject_1$G, templateObject_2$u, templateObject_3$j;

var Content$2 = styled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  ", ";\n  background: ", ";\n  width: 90%;\n  text-align: center;\n  position: absolute;\n  top: 10px;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  margin: 30px auto 30px auto;\n  padding: 10px;\n\n  div {\n    position: absolute;\n    top: 40%;\n    left: 10px;\n    right: 10px;\n    margin: auto;\n  }\n\n  h3 {\n    ", ";\n    margin-top: 0px;\n    margin-bottom: 16px;\n    font-size: 24px;\n    line-height: 30px;\n    color: ", ";\n  }\n\n  p {\n    ", ";\n    margin-top: 8px;\n    margin-bottom: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    color: #000000;\n  }\n\n  a {\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    border: none;\n    background-color: transparent;\n    color: ", ";\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  ", ";\n  background: ", ";\n  width: 90%;\n  text-align: center;\n  position: absolute;\n  top: 10px;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  margin: 30px auto 30px auto;\n  padding: 10px;\n\n  div {\n    position: absolute;\n    top: 40%;\n    left: 10px;\n    right: 10px;\n    margin: auto;\n  }\n\n  h3 {\n    ", ";\n    margin-top: 0px;\n    margin-bottom: 16px;\n    font-size: 24px;\n    line-height: 30px;\n    color: ", ";\n  }\n\n  p {\n    ", ";\n    margin-top: 8px;\n    margin-bottom: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    color: #000000;\n  }\n\n  a {\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    border: none;\n    background-color: transparent;\n    color: ", ";\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.text.interactive;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.text.interactive;
});
var FormLoadError = function (_a) {
    var onReturnClick = _a.onReturnClick;
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Content$2, null,
            React.createElement("div", null,
                React.createElement("h3", null, "Form was unable to load."),
                React.createElement("p", null, "Please try again later."),
                React.createElement("br", null),
                React.createElement("a", { onClick: onReturnClick }, "Exit")))));
};
var templateObject_1$F;

var BlockType;
(function (BlockType) {
    BlockType["Address"] = "Address";
    BlockType["Bool"] = "Bool";
    BlockType["Date"] = "Date";
    BlockType["Group"] = "Group";
    BlockType["Message"] = "Message";
    BlockType["Query"] = "Query";
    BlockType["Repeat"] = "Repeat";
    BlockType["Section"] = "Section";
    BlockType["Select"] = "Select";
    BlockType["Sidebar"] = "Sidebar";
    BlockType["Step"] = "Step";
    BlockType["Text"] = "Text";
    BlockType["Time"] = "Time";
    BlockType["Deductibles"] = "Deductibles";
    BlockType["HasDrafts"] = "HasDrafts";
    BlockType["Mitigation"] = "Mitigation";
    BlockType["MitigationDecline"] = "MitigationDecline";
    BlockType["MitigationDeclineReason"] = "MitigationDeclineReason";
})(BlockType || (BlockType = {}));
var BlockQueryType;
(function (BlockQueryType) {
    BlockQueryType["CatastropheList"] = "CatastropheList";
    BlockQueryType["DuplicateClaim"] = "DuplicateClaim";
    BlockQueryType["Eligibility"] = "Eligibility";
    BlockQueryType["WindHail"] = "WindHail";
    BlockQueryType["FileUpload"] = "FileUpload";
    BlockQueryType["PolicyTerm"] = "PolicyTerm";
    BlockQueryType["CarrierCheck"] = "CarrierCheck";
})(BlockQueryType || (BlockQueryType = {}));

var RuleOperator;
(function (RuleOperator) {
    RuleOperator["Equal"] = "Equal";
    RuleOperator["NotEqual"] = "NotEqual";
    RuleOperator["GreaterThan"] = "GreaterThan";
    RuleOperator["LessThan"] = "GreaterThan";
    RuleOperator["OneOf"] = "OneOf";
})(RuleOperator || (RuleOperator = {}));
var RuleGroupOperator;
(function (RuleGroupOperator) {
    RuleGroupOperator["And"] = "And";
    RuleGroupOperator["Or"] = "Or";
})(RuleGroupOperator || (RuleGroupOperator = {}));

var AnalyticsEventNames;
(function (AnalyticsEventNames) {
    AnalyticsEventNames["PageLoaded"] = "Form Page Loaded";
    AnalyticsEventNames["ClickFormNav"] = "Form Nav Clicked";
    AnalyticsEventNames["ClickBackButton"] = "Back Button Clicked";
    AnalyticsEventNames["ClickNextButton"] = "Next Button Clicked";
    AnalyticsEventNames["ReviewPage"] = "Review Page Viewed";
    AnalyticsEventNames["Submitted"] = "FNOL Submitted";
    AnalyticsEventNames["ConfirmationPage"] = "Confirmation Page Viewed";
    AnalyticsEventNames["ExitForm"] = "Exit FNOL Form";
    AnalyticsEventNames["ValidationError"] = "Validation Error Displayed";
    AnalyticsEventNames["FormLoadError"] = "FNOL Form Load Error";
    AnalyticsEventNames["WindHailModalDisplayed"] = "Wind/Hail Modal Displayed";
    AnalyticsEventNames["WindHailModalClickViewDetails"] = "Wind/Hail Modal View Details Clicked";
    AnalyticsEventNames["WindHailModalClickCheckAdjDates"] = "Wind/Hail Modal Check Adjacent Dates Clicked";
    AnalyticsEventNames["WindHailModalClickChangeDate"] = "Wind/Hail Modal Change Date";
    AnalyticsEventNames["DuplicateClaimModalDisplayed"] = "Duplicate Claim Modal Displayed";
    AnalyticsEventNames["DuplicateClaimModalClickExistingClaim"] = "Duplicate Claim Modal Go To Existing Claim Clicked";
    AnalyticsEventNames["DuplicateClaimModalClickContinueClaim"] = "Duplicate Claim Modal Continue New Claim Clicked";
    AnalyticsEventNames["ContinueExistingClaim"] = "Continue In Progress Clicked";
    AnalyticsEventNames["PolicyTermModalDisplayed"] = "Policy Term Modal Displayed";
    AnalyticsEventNames["PolicyTermModalClickBack"] = "Policy Term Modal Go Back Clicked";
    AnalyticsEventNames["PolicyTermModalClickContinueClaim"] = "Policy Term Modal Continue New Claim Clicked";
    AnalyticsEventNames["PolicyTermContinueExistingClaim"] = "Policy Term Continue In Progress Clicked";
})(AnalyticsEventNames || (AnalyticsEventNames = {}));

var REVIEW_ID = 'review-section';
var REVIEW_STEP_ID = 'review-step';
var FUNCTION_NOT_IMPLEMENTED_ERROR_MESSAGE = 'Function not implemented.';
var REQUIRED_ERROR_MESSAGE = 'Please provide the requested information.';
var DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";
var DATE_YEAR_MONTH_DAY_FORMAT = 'yyyy-MM-dd';
var DATE_MONTH_DAY_YEAR_FORMAT = 'MM/dd/yyyy';
var LOSS_TYPE = {
    "Other": 'Other',
    "WindHailHurricaneStorm": 'Wind / Hail / Hurricane / Storm',
    "Fire": 'Fire',
    "Water": 'Water',
    "TheftOrMysteriousDisappearance": 'Theft or mysterious disappearance',
    "Freezing": 'Freezing',
    "EarthquakeOrGroundMovement": 'Earthquake or ground movement',
    "PhysicalInjury": 'Physical injury'
};
var LOSS_SUB_TYPE = {
    "Other": 'lossSubTypeOther',
    "WindHailHurricaneStorm": 'lossSubTypeStorm',
    "Fire": 'lossSubTypeFire',
    "Water": 'lossSubTypeWater',
    "TheftOrMysteriousDisappearance": 'lossSubTypeTheft',
    "Freezing": 'lossSubTypeFreezing',
    "EarthquakeOrGroundMovement": 'lossSubTypeEarthquake',
    "PhysicalInjury": 'lossSubTypeInjury'
};
var LOSS_TYPES_WITH_SUBVALUE = [
    'Other',
    'Wind / Hail / Hurricane / Storm',
    'Fire',
    'Water',
    'Theft or mysterious disappearance',
    'Freezing',
    'Earthquake or ground movement',
    'Physical injury',
];
var MITIGATION_FIELD_WATER = 'customerRequestsWaterMitigation';
var MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY = 'customerRequestsSmokeMitigationForPersonalProperty';
var MITIGATION_FIELD_SMOKE_FOR_STRUCTURE = 'customerRequestsSmokeMitigationForStructure';
var MITIGATION_FIELD_DEBRIS_REMOVAL = 'customerRequestsDebrisRemoval';
var MITIGATION_FIELD_TARPING = 'customerRequestsTarping';
var MITIGATION_FIELD_REJECT_ALL = 'mitigationRejectAll';
var MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_PERSONAL_PROPERTY = "Property inside my home has smoke damage (rugs, furniture, etc.)";
var MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_STRUCTURE = "My home has smoke damage (ceilings, walls, etc.)";
var SOURCE = {
    AGENT_PORTAL: 'Agent Portal',
    MY_SAGE_SURE: 'MySageSure.com',
    IPCM: 'IPC Manager',
};

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
function parseIntBaseTen(input) {
    return parseInt(input, 10);
}
/**
 * Determines whether the specified input is valid string.
 */
function hasRequiredValue(input) {
    if (input == null) {
        return false;
    }
    return Boolean(input.trim());
}
/**
 * Returns array of rules that didn't pass validation.
 */
function failedValidationRules(input, rules) {
    return rules.filter(function (rule) {
        if (rule.regex) {
            var re = new RegExp(rule.regex);
            return !re.test(input);
        }
        return false;
    });
}
/**
 * Some existing phone numbers might have an international prefix or business
 * extension. For now, we don't want to use those to pre-fill values.
 */
function phoneNumPreFillCompatible(input) {
    // strip leading 1 and all symbols
    var justDigits = input.replace(/(?:^1)|\D/g, '');
    return justDigits.length === 10;
}
/**
 * Determines whether the specified input is valid phone number.
 */
function isValidPhoneNum(input) {
    var regex = /^\(([0-9]{3})\) ([0-9]{3})-([0-9]{4})$/;
    return regex.test(input);
}
/**
 * Determines whether the specified input is valid email.
 */
function isValidEmail(input) {
    var regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return regex.test(input);
}
/**
 * Determines whether the specified input is valid time (HH:MM [AP]M)
 * without any missing values.
 */
function isValidTime(input) {
    var regex = /^(1[0-2]|0[1-9]):([0-5][0-9]) ([AP]M)$/;
    return regex.test(input);
}
/**
 * Determines whether the specified input is valid time (HH:MM),
 * it can have missing values as long as it could become the
 * correct HH:MM format.
 */
function isValidHourAndMinute(input) {
    var isValid = true;
    var hour = input.split(':')[0];
    isValid = /^(1[0-2]|0?[0-9])$/.test(hour);
    if (isValid) {
        isValid = /^(1[0-2]|0?[0-9]):?([0-5][0-9]?)?$/.test(input);
    }
    return isValid;
}
/**
 * Determines whether the specified input is valid time within the past
 * NOTE: This logic is based on the fact that the time input "11:00AM"
 * is within the Eastern Timezone. Meaning a user within MT can subimit a time
 * that is in the future for them but as long as it is NOT in the future for ET
 */
function isTimeInFuture(input) {
    var isFuture = false;
    // need to have these checks to only show when the time is complete
    // and cannot use isValidTime() regex
    if (input.length > 7 && input != '' && input.includes(':')) {
        var timeNowEastern = dayjs().tz('America/New_York').format();
        var inputDayjs = dayjs(input, 'h:m a').format();
        isFuture = inputDayjs > timeNowEastern;
    }
    return isFuture;
}
/**
 * Determines whether the specified input is valid date (mm/dd/yyyy)
 * without any missing values.
 */
function isValidDate(input) {
    var regex = /^(1[0-2]|0[1-9])\/((0[0-9]|1[0-9]|2[0-9])|(3[0-1]))\/(20\d{2})$/;
    return regex.test(input);
}
/**
 * Determines if the date is valid and exists on the calendar
 * by checking that what is run through the date function has
 * the same output as the user input
 *   Ex: 02/31/2021 does not exist since Feb doesn't have 31 days
 */
function doesDateExist(input) {
    var date = input.split('/');
    var year = parseIntBaseTen(date[2]);
    var month = parseIntBaseTen(date[0]) - 1;
    var day = parseIntBaseTen(date[1]);
    var calendar = new Date(year, month, day);
    if (calendar.getFullYear() === year &&
        calendar.getMonth() === month &&
        calendar.getDate() === day) {
        return true;
    }
    return false;
}
/**
 * Determines if the date is older than X months from today
 */
function isDateOlderThanMonths(input, months) {
    var date = input.split('/');
    var inputDate = new Date(parseIntBaseTen(date[2]), parseIntBaseTen(date[0]) - 1, parseIntBaseTen(date[1]));
    var monthsAgo = new Date();
    monthsAgo.setMonth(monthsAgo.getMonth() - months);
    return monthsAgo > inputDate;
}
/**
 * Determines if the date is today
 */
function isDateToday(input) {
    var date = input.split('/');
    var inputDate = new Date(parseIntBaseTen(date[2]), parseIntBaseTen(date[0]) - 1, parseIntBaseTen(date[1]));
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today.getTime() === inputDate.getTime();
}
/**
 * Determines whether the specified input is valid dollar format ($XX,XXX.XX)
 * Verifies value is formatted with a dollar sign and commas as needed
 */
function isValidDollar(input) {
    var regexWithAll = /^\$(([0-9]{1,3})|(([0-9]{1,3},)+([0-9]{3})?))\.([0-9][0-9])$/;
    return regexWithAll.test(input);
}
/**
 * Validates the value from BlockBoolean is correct
 */
var boolValidation = function (block) { return function (value) {
    var hasError = block.required && (value === null || value === '' || value.length < 1);
    if (hasError) {
        // TODO: map to error constants for default message
        return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
    }
}; };
/**
 * Shared text Field Validations
 */
var textFieldValidations = function (block) { return function (value) {
    if (block.required && !hasRequiredValue(value)) {
        return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
    }
    else if (block.validationRules) {
        var fails = failedValidationRules(value, block.validationRules);
        if (fails.length > 0) {
            return block.error && block.error !== '' ? block.error : fails[0].message;
        }
    }
}; };
/**
 * Validates the telephone input
 */
var telephoneFieldValidation = function (block) { return function (value) {
    if (value && !isValidPhoneNum(value)) {
        return block.error && block.error !== '' ? block.error : 'Phone number is incomplete.';
    }
    else {
        return textFieldValidations(block)(value);
    }
}; };
/**
 * Validates the currency input
 */
var currencyFieldValidation = function (block) { return function (value) {
    if (value && !isValidDollar(value)) {
        return block.error && block.error !== '' ? block.error : 'Invalid dollar format.';
    }
    else {
        return textFieldValidations(block)(value);
    }
}; };
/**
 * Validates the email input
 */
var emailFieldValidation = function (block) { return function (value) {
    if (value && !isValidEmail(value)) {
        return block.error && block.error !== '' ? block.error : 'Invalid email address format.';
    }
    else {
        return textFieldValidations(block)(value);
    }
}; };
/**
 * Validates the select input
 */
var selectFieldValidation = function (block) { return function (value) {
    if (block.required && (!value || value.length < 1)) {
        return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
    }
}; };

function isRuleGroup(rule) {
    return rule.children !== undefined;
}
function mapYesNoToBoolOrNull(value) {
    return value ? value === 'yes' : null;
}
function shouldRender(rules, values) {
    if (!rules || rules.length === 0) {
        return true;
    }
    return rules.every(function (rule) {
        if (isRuleGroup(rule)) {
            return rule.operator === RuleGroupOperator.Or
                ? rule.children.some(function (r) { return shouldRenderRule(r, values); })
                : rule.children.every(function (r) { return shouldRenderRule(r, values); });
        }
        else {
            return shouldRenderRule(rule, values);
        }
    });
}
function shouldRenderRule(rule, values) {
    if (rule.children !== undefined) {
        return shouldRender(rule.children, values);
    }
    var value = values[rule.watchId];
    var formValue = value && typeof value === 'string' ? value.toLowerCase() : value;
    var ruleValue = typeof rule.value === 'string' ? rule.value.toLowerCase() : rule.value;
    var notNull = formValue != null;
    switch (rule.operator) {
        case RuleOperator.Equal: {
            if (notNull && typeof formValue === 'string' && rule.valueType === 'date') {
                return isDateToday(formValue);
            }
            else {
                // map rule value of yes/no to true/false
                var mappedRuleValue = typeof formValue === 'boolean' && typeof ruleValue === 'string'
                    ? mapYesNoToBoolOrNull(ruleValue)
                    : ruleValue;
                return notNull && formValue === mappedRuleValue;
            }
        }
        case RuleOperator.NotEqual:
            return notNull && formValue !== ruleValue;
        case RuleOperator.OneOf: {
            if (notNull && Array.isArray(ruleValue)) {
                if (Array.isArray(formValue) && typeof formValue[0] === 'string') {
                    // check if any values in rule are in an array of values
                    return ruleValue.some(function (rv) {
                        return formValue.some(function (fv) {
                            return (typeof rv === 'string' ? rv.toLowerCase() : rv) ===
                                (typeof fv === 'string' ? fv.toLowerCase() : fv);
                        });
                    });
                }
                else {
                    // check if single value is any of rule's value
                    return ruleValue.some(function (rv) { return (typeof rv === 'string' ? rv.toLowerCase() : rv) === formValue; });
                }
            }
            return false;
        }
        case RuleOperator.GreaterThan:
            if (notNull && typeof formValue === 'string') {
                if (rule.valueType === 'months' && typeof ruleValue === 'string') {
                    return isDateOlderThanMonths(formValue, parseInt(ruleValue, 10));
                }
                else if (rule.valueType === 'months' && typeof ruleValue === 'number') {
                    return isDateOlderThanMonths(formValue, ruleValue);
                }
                else if (rule.valueType === 'time' && typeof ruleValue === 'string') {
                    return isTimeInFuture(formValue);
                }
                else if (!rule.valueType) {
                    return formValue.length > ruleValue;
                }
            }
            return false;
    }
}

var MITIGATION_SERVICES = {
    customerRequestsWaterMitigation: 'water extraction & dry out',
    customerRequestsTarping: 'tarping/board-up',
    customerRequestsDebrisRemoval: 'debris removal',
    customerRequestsSmokeMitigationForPersonalProperty: 'fire or smoke cleanup (personal property)',
    customerRequestsSmokeMitigationForStructure: 'fire or smoke cleanup (dwelling)',
};
/**
 * Returns true if there is a mitigation selected
 * @param values Formik values
 * @returns
 */
var isMitigationSelected = function (values) {
    return Object.keys(MITIGATION_SERVICES).some(function (item) { return values[item]; });
};
/**
 * Loop through the mitigation services and returns an array of mitigation services
 * @param values Formik values
 * @returns
 */
var getMitigationSelectedServices = function (values) {
    return Object.entries(MITIGATION_SERVICES)
        .filter(function (item) { return values[item[0]]; })
        .map(function (item) { return item[1]; });
};
var getSelectedServicesDisplayStrings = function (selectedServices) {
    return selectedServices
        .join(selectedServices.length > 2 ? ', ' : ' and ')
        .replace(/, ([^,]*)$/, ', and $1');
}; // replaces last comma with ', and <service>'
/**
 * Returns true if a mitigation service is offered
 * @param mitigationServices
 * @returns
 */
var isMitigationServicesOffered = function (mitigationServices) {
    return mitigationServices.debrisRemoval ||
        mitigationServices.smokeForPersonalProperty ||
        mitigationServices.smokeForStructure ||
        mitigationServices.tarping ||
        mitigationServices.waterMitigation;
};

var DEFAULT_STATE = {
    claimNumber: '',
    claimSubmissionNumber: '',
    completedSections: [],
    definition: {
        meta: {
            environment: 'policyholder',
            carrier: '',
            created: '',
            version: 0,
        },
        blocks: [],
        rules: {},
        mappings: [],
    },
    definitionLocation: '',
    existingClaim: { timestamp: '' },
    googleMapsKey: '',
    location: { section: '' },
    pendingClaimNumber: '',
    policy: {
        policyId: '',
        policyName: '',
        policyEffectiveDate: '',
        policyExpirationDate: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        streetAddress: '',
        city: '',
        state: '',
        zip: '',
        carrierGroup: 'default',
    },
    source: '',
    queries: {},
    stepComplete: false,
    submit: {
        sending: false,
        success: false,
        error: null,
    },
    hydratingDraft: false,
    editingDraft: false,
    draftBeingEdited: null,
    consultativeFnol: {
        policyId: '',
        commercialProperty: false,
        agent: {
            agencyName: '',
            phone: '',
            email: '',
        },
        draftFnols: [],
        constants: {},
        featureFlags: {},
    },
    showMitigation: false,
    mitigationServices: {
        mitigationEligibility: {
            waterMitigation: false,
            tarping: false,
            debrisRemoval: false,
            smokeForPersonalProperty: false,
            smokeForStructure: false,
        },
        constants: {
            bullets: [],
            recommendedServices: {
                waterMitigation: {
                    serviceName: 'Water extraction & dry out',
                    copy: 'Remove standing water and dry out the home/property',
                    subCopy: 'Note: a plumber should be contacted first to repair any active leaks',
                },
                tarping: {
                    serviceName: 'Tarping/Board-up',
                    copy: 'Cover any openings in the home to protect against weather, vandalism, or theft',
                    subCopy: '',
                },
                debrisRemoval: {
                    serviceName: 'Debris removal',
                    copy: 'Remove or clean up trees, branches, or other fallen debris on covered structures',
                    subCopy: '',
                },
                smokeForPersonalProperty: {
                    serviceName: 'Fire or smoke cleanup (personal property)',
                    copy: 'Remove or clean damage to property within the home caused by fire or smoke',
                    subCopy: '',
                },
                smokeForStructure: {
                    serviceName: 'Fire or smoke cleanup (dwelling)',
                    copy: 'Remove or clean damage to the home (such as walls, ceilings, and floors) caused by fire or smoke',
                    subCopy: '',
                },
            },
        },
    },
};
var selectSections = function (def) {
    return def.blocks.filter(function (block) { return block.type === BlockType.Section; });
};
var selectSteps = function (blocks) {
    return blocks.filter(function (block) { return block.type === BlockType.Step; });
};
var selectFilteredSteps = function (blocks, rules, values) {
    return blocks.filter(function (step) {
        return step.type === BlockType.Step &&
            (!(rules && rules[step.id] && rules[step.id].length > 0) ||
                shouldRender(rules[step.id], values));
    });
};
var isLastStep = function (location, def, values) {
    if (!location.step) {
        return false;
    }
    var sections = selectSections(def);
    var currSection = sections.find(function (block) { return block.id === location.section; });
    if (currSection) {
        var steps = selectFilteredSteps(currSection.children, def.rules, values);
        return location.step === steps[steps.length - 1].id;
    }
    return false;
};
var isQueryStep = function (location, def) {
    if (!location.step) {
        return false;
    }
    var sections = selectSections(def);
    var currSection = sections.find(function (block) { return block.id === location.section; });
    if (currSection) {
        var steps = selectSteps(currSection.children);
        var step = steps.find(function (step) { return step.id === location.step; });
        if (step && step.children) {
            return step.children.some(function (child) { return child.type === BlockType.Query; });
        }
    }
    return false;
};
// The reducer is used in the use-immer hook, so our actions modify the draft,
// producing the next version of our state.
function reducer(draft, action) {
    action(draft);
}
var setDefinition = function (def) { return function (draft) {
    draft.definition = castDraft(def);
}; };
var setPolicy = function (policy) { return function (draft) {
    draft.policy = policy;
}; };
var setSource = function (source) { return function (draft) {
    draft.source = source;
}; };
var setDefLocation = function (location) { return function (draft) {
    draft.definitionLocation = location;
}; };
var setUser = function (user) { return function (draft) {
    draft.user = user;
}; };
var setConsultativeFnol = function (data) { return function (draft) {
    draft.consultativeFnol = data;
}; };
var setDeductibles = function (data) { return function (draft) {
    draft.deductibles = data;
}; };
var hydratingDraft = function (value) { return function (draft) {
    draft.hydratingDraft = value;
}; };
var setEditingDraft = function (editingDraft) { return function (draft) {
    draft.editingDraft = editingDraft;
}; };
var setDraftBeingEdited = function (draftFnol) { return function (draft) {
    draft.draftBeingEdited = draftFnol;
}; };
var setLocation = function (location, values, exit) {
    return function (draft) {
        if (location.section && location.step && draft.location.section === location.section) {
            draft.location = location;
            draft.stepComplete = false;
            return;
        }
        if (location.section === REVIEW_ID) {
            draft.location = { section: REVIEW_ID, step: REVIEW_STEP_ID };
            draft.stepComplete = false;
            return;
        }
        var nextSection = selectSections(draft.definition).find(function (block) { return block.id === location.section; });
        if (draft.submit.sending || draft.submit.success || !nextSection) {
            exit(values.lossType);
            return;
        }
        if (nextSection) {
            var nextLocation = {
                section: nextSection.id,
                step: location.step,
            };
            var nextSteps = selectFilteredSteps(nextSection.children, draft.definition.rules, values);
            if (nextSteps.length > 0 && !location.step) {
                nextLocation.step = nextSteps[0].id;
            }
            draft.location = nextLocation;
            draft.stepComplete = false;
        }
    };
};
var setGoogleMapsKey = function (googleMapsKey) { return function (draft) {
    draft.googleMapsKey = googleMapsKey;
}; };
var nextStep = function (values) { return function (draft) {
    var sections = selectSections(draft.definition);
    var currSectionIndex = sections.findIndex(function (block) { return block.id == draft.location.section; });
    var currSection = sections[currSectionIndex];
    var filteredSteps = selectFilteredSteps(currSection.children, draft.definition.rules, values);
    var stepIndex = filteredSteps.findIndex(function (block) { return block.id === draft.location.step; });
    // Stay on step if not yet complete
    if (!draft.stepComplete) {
        return;
    }
    if (stepIndex >= 0 && stepIndex < filteredSteps.length - 1) {
        // Next Step
        draft.location.step = filteredSteps[stepIndex + 1].id;
        draft.location.browser = false;
        return;
    }
    else {
        // Last section? Move to review section
        if (currSectionIndex === sections.length - 1) {
            draft.location = {
                section: REVIEW_ID,
                step: REVIEW_STEP_ID,
                browser: false,
            };
            draft.stepComplete = false;
            return;
        }
        // Go to first step of next section
        var nextSection = sections[currSectionIndex + 1];
        var nextLocation = {
            section: nextSection.id,
            browser: false,
        };
        var filteredNextSteps = selectFilteredSteps(nextSection.children, draft.definition.rules, values);
        if (filteredNextSteps.length > 0) {
            nextLocation.step = filteredNextSteps[0].id;
        }
        draft.location = nextLocation;
        draft.stepComplete = false;
    }
}; };
var prevStep = function (values) { return function (draft) {
    var sections = selectSections(draft.definition);
    var prev;
    if (draft.location.section === REVIEW_ID) {
        prev = findPrevLocation([], -1, sections, draft.location.section, draft.definition.rules, values);
    }
    else {
        var currSectionIndex = sections.findIndex(function (block) { return block.id == draft.location.section; });
        var currSection = sections[currSectionIndex];
        var filteredSteps = selectFilteredSteps(currSection.children, draft.definition.rules, values);
        var stepIndex = filteredSteps.findIndex(function (block) { return block.id === draft.location.step; });
        prev = findPrevLocation(filteredSteps, stepIndex - 1, sections, draft.location.section, draft.definition.rules, values, isMitigationServicesOffered(draft.mitigationServices.mitigationEligibility), isMitigationSelected(values));
    }
    if (prev) {
        draft.location = __assign(__assign({}, prev), { browser: false });
        draft.stepComplete = false;
    }
}; };
function findPrevLocation(steps, index, sections, sectionId, rules, values, isMitigationServicesOffered, isMitigationSelected) {
    var _a;
    var endOfSection = index < 0;
    // Skip over query steps when going back (default)
    // Show step on back if showOnBack is true
    var isQuery = !endOfSection &&
        ((_a = steps[index].children) === null || _a === void 0 ? void 0 : _a.some(function (child) { return child.type === BlockType.Query && !(child.showOnBack === true); }));
    if (isQuery && index > 0) {
        // previous in section
        return findPrevLocation(steps, index - 1, sections, sectionId, rules, values);
    }
    if (isQuery || endOfSection) {
        // move to previous section
        var sectionIndex = sections.findIndex(function (block) { return block.id === sectionId; });
        if (sectionIndex > 0 || sectionId === REVIEW_ID) {
            var prevSection = sectionId === REVIEW_ID ? sections[sections.length - 1] : sections[sectionIndex - 1];
            var prevSteps = selectSteps(prevSection.children);
            var filteredPrevSteps = selectFilteredSteps(prevSteps, rules, values);
            if (filteredPrevSteps.length > 0) {
                return findPrevLocation(filteredPrevSteps, filteredPrevSteps.length - 1, sections, prevSection.id, rules, values, isMitigationServicesOffered, isMitigationSelected);
            }
        }
        return null;
    }
    // Special case for Mitigation
    if (steps[index].id === 'stepMitigationServicesDeclineReason') {
        if (!isMitigationServicesOffered) {
            index = index - 3;
        }
        else if (isMitigationSelected) {
            index = index - 2;
        }
    }
    return { section: sectionId, step: steps[index].id };
}
var validateStep = function (results, values, invalidateNextSections) {
    return function (draft) {
        if (!results) {
            // Step incomplete and remove section completed list
            draft.stepComplete = false;
            draft.completedSections = draft.completedSections.filter(function (id) { return id !== draft.location.section; });
        }
        else if (invalidateNextSections) {
            // mark current and all following section incomplete
            var index = draft.completedSections.findIndex(function (id) { return id == draft.location.section; });
            if (index !== -1) {
                draft.completedSections = draft.completedSections.slice(0, index);
                draft.stepComplete = false;
            }
        }
        else {
            // Step complete, and if last step, add section to completed list
            var alreadyComplete = draft.completedSections.includes(draft.location.section);
            draft.stepComplete = true;
            draft.completedSections =
                isLastStep(draft.location, draft.definition, values) && !alreadyComplete
                    ? __spreadArray(__spreadArray([], draft.completedSections, true), [draft.location.section], false) : draft.completedSections;
        }
    };
};
var submitClaim = function (callback) { return function (draft) {
    callback();
    draft.submit.sending = true;
    draft.submit.success = false;
    draft.submit.error = null;
}; };
var submitClaimSuccess = function (submissionNumber, claimNumber) { return function (draft) {
    draft.submit.sending = false;
    draft.submit.success = true;
    draft.submit.error = null;
    draft.claimSubmissionNumber = submissionNumber;
    draft.claimNumber = claimNumber;
}; };
var submitClaimError = function (message) { return function (draft) {
    var error = message !== null && message !== void 0 ? message : 'The claim could not be submitted. Please try again in a minute. If you continue to have problems, please contact support.';
    draft.submit.sending = false;
    draft.submit.success = false;
    draft.submit.error = error;
}; };
var setQuery = function (queryState) { return function (draft) {
    Object.keys(queryState).forEach(function (k) {
        draft.queries[k] = queryState[k];
    });
}; };
var setPendingClaimNumber = function (pendingNumber) { return function (draft) {
    draft.pendingClaimNumber = pendingNumber;
}; };
var setMitigationServices = function (services) { return function (draft) {
    draft.mitigationServices = services;
}; };
var setShowMitigation = function (value) { return function (draft) {
    draft.showMitigation = value;
}; };

var FnolDataContext = createContext(DEFAULT_STATE);

var FnolDataDispatcher = createContext(null);

/**
 * Access the form definition, policy data, section state, and dispatcher with
 * this hook.
 */
function useFnolData() {
    var _this = this;
    var dataContext = useContext(FnolDataContext);
    var dispatcher = useContext(FnolDataDispatcher);
    if (dataContext == null) {
        throw new Error('useFnolData must be used within a FnolDataContext.Provider');
    }
    if (dispatcher == null) {
        throw new Error('No dispatcher initialized');
    }
    return __assign(__assign({}, dataContext), { validate: useCallback(function (formik, invalidateNextSections) {
            if (invalidateNextSections === void 0) { invalidateNextSections = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, formik.validateForm()];
                        case 1:
                            results = _a.sent();
                            dispatcher.dispatch(validateStep(Object.keys(results).length === 0, formik.values, invalidateNextSections));
                            return [2 /*return*/];
                    }
                });
            });
        }, []), nextStep: useCallback(function (values) {
            dispatcher.sendEvent({
                name: AnalyticsEventNames.ClickNextButton,
                section: dataContext.location.section,
                step: dataContext.location.step,
                lossType: values.lossType,
            });
            dispatcher.dispatch(nextStep(values));
        }, []), prevStep: useCallback(function (values) {
            dispatcher.sendEvent({
                name: AnalyticsEventNames.ClickBackButton,
                section: dataContext.location.section,
                step: dataContext.location.step,
                lossType: values.lossType,
            });
            dispatcher.dispatch(prevStep(values));
        }, []), setLocation: useCallback(function (payload) {
            dispatcher.dispatch(setLocation(payload.location, payload.values, dispatcher.sendExit));
        }, []), setConsultativeFnol: useCallback(function (data) {
            dispatcher.dispatch(setConsultativeFnol(data));
        }, []), setDeductibles: useCallback(function (data) {
            dispatcher.dispatch(setDeductibles(data));
        }, []), setHydratingDraft: useCallback(function (value) {
            dispatcher.dispatch(hydratingDraft(value));
        }, []), setEditingDraft: useCallback(function (value) {
            dispatcher.dispatch(setEditingDraft(value));
        }, []), setDraftBeingEdited: useCallback(function (draft) {
            dispatcher.dispatch(setDraftBeingEdited(draft));
        }, []), submitClaim: useCallback(function (payload) {
            dispatcher.dispatch(submitClaim(payload));
        }, []), sendEvent: useCallback(function (event) {
            dispatcher.sendEvent(event);
        }, []), sendPost: useCallback(function (body) {
            return dispatcher.sendPost(body);
        }, []), sendExit: useCallback(function (values) {
            dispatcher.sendExit(values.lossType);
        }, []), setQuery: useCallback(function (payload) {
            dispatcher.dispatch(setQuery(payload));
        }, []), setPendingNumber: useCallback(function (pendingNumber) {
            dispatcher.dispatch(setPendingClaimNumber(pendingNumber));
        }, []), setMitigationServices: useCallback(function (services) {
            dispatcher.dispatch(setMitigationServices(services));
        }, []), setShowMitigation: useCallback(function (value) {
            dispatcher.dispatch(setShowMitigation(value));
        }, []) });
}

var StyledHeaderContainer$1 = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  background: ", ";\n  > div {\n    ", "\n    width: 90vw;\n  }\n"], ["\n  background: ", ";\n  > div {\n    ", "\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
}, wrapper);
var StyledTitleContainer = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 0px;\n  max-width: 624px;\n\n  div {\n    align-items: center;\n    display: flex;\n  }\n\n  h3 {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  a {\n    color: grey;\n    text-decoration: none;\n  }\n\n  @media (max-width: ", ") {\n    padding: 16px 0px 16px 0px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 0px;\n  max-width: 624px;\n\n  div {\n    align-items: center;\n    display: flex;\n  }\n\n  h3 {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  a {\n    color: grey;\n    text-decoration: none;\n  }\n\n  @media (max-width: ", ") {\n    padding: 16px 0px 16px 0px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledVerticalDivider = styled.div(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: block !important;\n    border-right: 1px solid lightgrey;\n    height: 3em;\n    margin: 0px 1em;\n  }\n"], ["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: block !important;\n    border-right: 1px solid lightgrey;\n    height: 3em;\n    margin: 0px 1em;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
});
var StyledPhoneText = styled.span(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledIconContainer$2 = styled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  cursor: pointer;\n  color: grey;\n  position: absolute;\n  top: 10;\n  left: 2vw;\n\n  .exit-span {\n    margin-left: 12px;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n  }\n\n  @media (max-width: ", ") {\n    position: relative;\n    left: 0;\n  }\n"], ["\n  cursor: pointer;\n  color: grey;\n  position: absolute;\n  top: 10;\n  left: 2vw;\n\n  .exit-span {\n    margin-left: 12px;\n\n    @media (max-width: ", ") {\n      display: none;\n    }\n  }\n\n  @media (max-width: ", ") {\n    position: relative;\n    left: 0;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
});
var StyledProgressContainer = styled.div(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  max-width: 624px;\n"], ["\n  max-width: 624px;\n"])));
var templateObject_1$E, templateObject_2$t, templateObject_3$i, templateObject_4$f, templateObject_5$e, templateObject_6$b;

var Header = function (_a) {
    var handleOnExit = _a.handleOnExit;
    var _b = useFnolData(), definition = _b.definition, completedSections = _b.completedSections;
    var values = useFormikContext().values;
    var steps = definition.blocks.map(function (block) {
        return {
            label: block.title,
            status: completedSections.includes(block.id) ? 'completed' : 'incomplete',
        };
    });
    var handleOnClick = function () {
        handleOnExit(values);
    };
    return (React.createElement(StyledHeaderContainer$1, null,
        React.createElement(StyledTitleContainer, { id: "headerComponent" },
            React.createElement("div", null,
                React.createElement(StyledIconContainer$2, { "data-testid": "logout-icon", onClick: handleOnClick },
                    React.createElement(UiIcon, { name: "Logout", size: "md" }),
                    React.createElement(Span, { medium: true, size: 'md', color: 'quiet', className: 'exit-span' }, "Exit")),
                React.createElement(StyledVerticalDivider, null),
                React.createElement(Heading, { tag: "h3", size: "md" }, "New claim")),
            React.createElement(Link, { leadingIcon: "Phone", href: 'tel:(866)311-7243' },
                React.createElement(StyledPhoneText, null, "(866) 311-7243"))),
        React.createElement(StyledProgressContainer, { "data-testid": "progress-stepper" },
            React.createElement(ProgressStepper, { appearance: "simple", steps: steps }))));
};

var StyledPolicyWrapper = styled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 624px;\n\n  .isReviewScreen {\n    padding: 0 !important;\n    background: ", ";\n    margin-top: 24px;\n    margin-bottom: 48px;\n    min-width: auto;\n    max-width: fit-content;\n\n    .mapIcon {\n      box-shadow: 0px 1px 3px 0px #00000026;\n      margin-left: 0px;\n      margin-right: 15px;\n    }\n\n    .reviewScreenPolicyInfo {\n      margin-left: 0 !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: unset;\n    width: 90vw;\n    max-width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 624px;\n\n  .isReviewScreen {\n    padding: 0 !important;\n    background: ", ";\n    margin-top: 24px;\n    margin-bottom: 48px;\n    min-width: auto;\n    max-width: fit-content;\n\n    .mapIcon {\n      box-shadow: 0px 1px 3px 0px #00000026;\n      margin-left: 0px;\n      margin-right: 15px;\n    }\n\n    .reviewScreenPolicyInfo {\n      margin-left: 0 !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: unset;\n    width: 90vw;\n    max-width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledPolicyCardContainer = styled.div(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  background: #f3f5f7;\n  border-radius: 12px;\n  padding: 32px;\n  display: flex;\n  justify-content: space-between;\n\n  img {\n    height: 55px;\n    width: 55px;\n    border-radius: 12px;\n  }\n\n  @media (max-width: 250px) {\n    padding: 16px;\n  }\n"], ["\n  background: #f3f5f7;\n  border-radius: 12px;\n  padding: 32px;\n  display: flex;\n  justify-content: space-between;\n\n  img {\n    height: 55px;\n    width: 55px;\n    border-radius: 12px;\n  }\n\n  @media (max-width: 250px) {\n    padding: 16px;\n  }\n"])));
var StyledPolicyInfoContainer$1 = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media (max-width: 250px) {\n    .mapIcon {\n      display: none;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media (max-width: 250px) {\n    .mapIcon {\n      display: none;\n    }\n  }\n"])));
var StyledPolicyInfoRow = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n\n  svg {\n    margin-top: 5px;\n  }\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n\n  .mapIcon {\n    margin-right: 15px;\n    box-shadow: none !important;\n  }\n\n  @media (max-width: 250px) {\n    word-break: break-word;\n\n    .mapIcon {\n      display: none;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n\n  svg {\n    margin-top: 5px;\n  }\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n\n  .mapIcon {\n    margin-right: 15px;\n    box-shadow: none !important;\n  }\n\n  @media (max-width: 250px) {\n    word-break: break-word;\n\n    .mapIcon {\n      display: none;\n    }\n  }\n"])));
var StyledPolicyInfo = styled.div(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  text-align: left;\n\n  .boldedSpanDetails {\n    display: flex;\n    flex-direction: row;\n    font-weight: 500;\n  }\n\n  .toText {\n    margin: 0 10px;\n    font-weight: 400;\n    white-space:nowrap;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  text-align: left;\n\n  .boldedSpanDetails {\n    display: flex;\n    flex-direction: row;\n    font-weight: 500;\n  }\n\n  .toText {\n    margin: 0 10px;\n    font-weight: 400;\n    white-space:nowrap;\n  }\n"])));
styled.div(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  color: ", ";\n  padding: 0px 10px;\n\n  svg {\n    margin-top: 0;\n  }\n"], ["\n  color: ", ";\n  padding: 0px 10px;\n\n  svg {\n    margin-top: 0;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
});
var StyledSelectOtherPolicyContainer = styled.div(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  max-width: 624px;\n  margin-top: 25px;\n  margin-bottom: 100px;\n  text-align: left;\n  \n\n  .boldText {\n    font-weight: 500;\n    color: #58595B !important;\n  }\n\n  .defaultText {\n    font-weight: 400 !important;\n    color: #58595B !important;\n  }\n\n  .interactiveText {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  @media (max-width: 250px) {\n    padding: 0 10px;\n  }\n"], ["\n  max-width: 624px;\n  margin-top: 25px;\n  margin-bottom: 100px;\n  text-align: left;\n  \n\n  .boldText {\n    font-weight: 500;\n    color: #58595B !important;\n  }\n\n  .defaultText {\n    font-weight: 400 !important;\n    color: #58595B !important;\n  }\n\n  .interactiveText {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  @media (max-width: 250px) {\n    padding: 0 10px;\n  }\n"])));
var templateObject_1$D, templateObject_2$s, templateObject_3$h, templateObject_4$e, templateObject_5$d, templateObject_6$a, templateObject_7$9;

var PolicyCard = function (_a) {
    var isReviewScreen = _a.isReviewScreen;
    var _b = useFnolData(), _c = _b.policy, streetAddress = _c.streetAddress, city = _c.city, state = _c.state, zip = _c.zip, policyName = _c.policyName, policyId = _c.policyId, policyEffectiveDate = _c.policyEffectiveDate, policyExpirationDate = _c.policyExpirationDate, sendExit = _b.sendExit;
    var values = useFormikContext().values;
    var handleOnClick = function () {
        sendExit(values);
    };
    return (React.createElement(StyledPolicyWrapper, null,
        React.createElement(StyledPolicyCardContainer, { className: classNames({ isReviewScreen: isReviewScreen }) },
            React.createElement(StyledPolicyInfoContainer$1, null,
                React.createElement(StyledPolicyInfoRow, null,
                    React.createElement("div", { className: "mapIcon", "data-testid": "policy-card" },
                        React.createElement(SpotIcon, { name: "Location", size: "sm", appearance: 'bold' })),
                    React.createElement(StyledPolicyInfo, { className: classNames({ reviewScreenPolicyInfo: isReviewScreen }) },
                        React.createElement(Span, { bold: true }, streetAddress),
                        React.createElement(Span, { bold: true },
                            city,
                            ", ",
                            state,
                            " ",
                            zip))),
                React.createElement(StyledPolicyInfoRow, null,
                    React.createElement(StyledPolicyInfo, { className: classNames({ reviewScreenPolicyInfo: isReviewScreen }) },
                        React.createElement(Span, { size: "sm", color: "quiet" }, policyName),
                        React.createElement(Span, { size: "sm", className: "boldedSpanDetails" }, policyId))),
                React.createElement(StyledPolicyInfoRow, null,
                    React.createElement(StyledPolicyInfo, { className: classNames({ reviewScreenPolicyInfo: isReviewScreen }) },
                        React.createElement(Span, { size: "sm", color: "quiet" }, "Effective dates"),
                        React.createElement(Span, { size: "sm", className: "boldedSpanDetails" },
                            policyEffectiveDate,
                            ' ',
                            React.createElement(Span, { size: 'sm', className: "toText" }, "to"),
                            ' ',
                            policyExpirationDate))))),
        !isReviewScreen && (React.createElement(StyledSelectOtherPolicyContainer, null,
            React.createElement(Span, { className: "boldText" },
                "Not the one you need?",
                ' ',
                React.createElement(Span, { className: "defaultText", color: "quiet" },
                    "You can switch policies on the",
                    ' ',
                    React.createElement(Span, { className: "interactiveText", color: "interactive", onClick: handleOnClick }, "policy overview page.")))))));
};

styled.p(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  && {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 32px;\n\n    b {\n      ", ";\n    }\n  }\n"], ["\n  && {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 32px;\n\n    b {\n      ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.bold;
});
styled.a(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  && {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  && {\n    color: ", ";\n    text-decoration: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
});
styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin-top: 18px;\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin-top: 18px;\n"])));
styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  margin-bottom: 32px;\n  position: relative;\n\n  .background {\n    background: ", ";\n    bottom: 0;\n    height: 24px;\n    left: 50%;\n    margin: auto;\n    position: absolute;\n    transform: translateX(-50%);\n    width: 90%;\n    z-index: 1;\n  }\n\n  .statuses {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(2, auto);\n    justify-content: space-between;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n\n    .status {\n      align-items: center;\n      display: flex;\n      flex-flow: column nowrap;\n      justify-content: flex-end;\n      width: 60px;\n    }\n\n    p {\n      ", ";\n      font-size: 12px;\n      line-height: 16px;\n      text-align: center;\n      margin: 1px 0 11px 0;\n    }\n\n    span {\n      ", ";\n      font-size: 10px;\n      line-height: 13px;\n    }\n  }\n"], ["\n  margin-bottom: 32px;\n  position: relative;\n\n  .background {\n    background: ", ";\n    bottom: 0;\n    height: 24px;\n    left: 50%;\n    margin: auto;\n    position: absolute;\n    transform: translateX(-50%);\n    width: 90%;\n    z-index: 1;\n  }\n\n  .statuses {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(2, auto);\n    justify-content: space-between;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n\n    .status {\n      align-items: center;\n      display: flex;\n      flex-flow: column nowrap;\n      justify-content: flex-end;\n      width: 60px;\n    }\n\n    p {\n      ", ";\n      font-size: 12px;\n      line-height: 16px;\n      text-align: center;\n      margin: 1px 0 11px 0;\n    }\n\n    span {\n      ", ";\n      font-size: 10px;\n      line-height: 13px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.canvas;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.bold;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.book;
});
styled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  svg {\n    margin-right: 5px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      display: none;\n    }\n  }\n"], ["\n  svg {\n    margin-right: 5px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      display: none;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var StyledLoadingPlaceholder = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"])));
styled.div(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-top: 16px;\n  }\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-top: 16px;\n  }\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var StyledReviewPageContentContainer = styled.div(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  width: 70vw;\n  display: flex;\n  justify-content: space-between;\n  margin: 75px 0;\n\n  div[class*='StyledPolicyWrapper'] {\n    min-width: unset;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    margin: 24px 0 300px 0;\n  }\n"], ["\n  width: 70vw;\n  display: flex;\n  justify-content: space-between;\n  margin: 75px 0;\n\n  div[class*='StyledPolicyWrapper'] {\n    min-width: unset;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    margin: 24px 0 300px 0;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledReviewPageFooterContainer = styled.div(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  display: none;\n  @media (max-width: ", ") {\n    width: 100vw;\n    background: ", ";\n    box-shadow: 0px 1px 5px 0px #00000059;\n    left: 0;\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    flex-direction: column;\n    position: fixed;\n    z-index: 1;\n    padding: 1em;\n  \n  \n    button {\n      width: 100% !important;\n  \n      span {\n        margin: 0 !important;\n      }\n  }\n"], ["\n  display: none;\n  @media (max-width: ", ") {\n    width: 100vw;\n    background: ", ";\n    box-shadow: 0px 1px 5px 0px #00000059;\n    left: 0;\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    flex-direction: column;\n    position: fixed;\n    z-index: 1;\n    padding: 1em;\n  \n  \n    button {\n      width: 100% !important;\n  \n      span {\n        margin: 0 !important;\n      }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
});
var StyledHeaderTextContainer = styled.div(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid lightgrey !important;\n  padding-bottom: 5px;\n  margin-top: 64px;\n  max-width: 464px;\n\n  .changePolicyHeader {\n    cursor: pointer;\n    font-weight: 500;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid lightgrey !important;\n  padding-bottom: 5px;\n  margin-top: 64px;\n  max-width: 464px;\n\n  .changePolicyHeader {\n    cursor: pointer;\n    font-weight: 500;\n  }\n"])));
var StyledPolicyInfoHeaderContainer = styled.div(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid lightgrey !important;\n  padding-bottom: 5px;\n\n  .changePolicyHeader {\n    cursor: pointer;\n    font-weight: 500;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid lightgrey !important;\n  padding-bottom: 5px;\n\n  .changePolicyHeader {\n    cursor: pointer;\n    font-weight: 500;\n  }\n"])));
styled.div(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: inline;\n  }\n"], ["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: inline;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledPolicyInfoContainer = styled.div(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  padding: 24px;\n  justify-content: flex-start;\n  box-shadow: 0px 4px 20px 0px #00000033;\n  border-radius: 12px;\n  max-width: 375px;\n  height: fit-content;\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  padding: 24px;\n  justify-content: flex-start;\n  box-shadow: 0px 4px 20px 0px #00000033;\n  border-radius: 12px;\n  max-width: 375px;\n  height: fit-content;\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledContactValuesContainer = styled.div(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  margin-top: 24px;\n  line-height: 24px;\n  text-align: left;\n  max-width: 464px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  margin-top: 24px;\n  line-height: 24px;\n  text-align: left;\n  max-width: 464px;\n"])));
var StyledFnolInfoContainer = styled.div(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  text-align: left;\n  word-break: break-word;\n  margin-right: 10px;\n\n  .pageHeader {\n    font-size: 28px;\n    margin-bottom: 16px;\n  }\n\n  .textSubheader {\n    max-width: 450px;\n  }\n\n  @media (max-width: ", ") {\n    .pageHeader {\n      font-size: 24px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  text-align: left;\n  word-break: break-word;\n  margin-right: 10px;\n\n  .pageHeader {\n    font-size: 28px;\n    margin-bottom: 16px;\n  }\n\n  .textSubheader {\n    max-width: 450px;\n  }\n\n  @media (max-width: ", ") {\n    .pageHeader {\n      font-size: 24px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
});
var StyledSubmissionTextContainer = styled.div(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 48px 0;\n  text-align: left;\n  width: 300px !important;\n\n  div[class*='ds__checkboxgroup '] {\n    p {\n      margin: 10px !important;\n      display: none;\n    }\n\n    label {\n      align-items: flex-start;\n    }\n  }\n\n  @media (max-width: ", ") {\n    margin: 16px 0;\n    max-height: 100px;\n    overflow-y: scroll;\n    width: auto !important;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 48px 0;\n  text-align: left;\n  width: 300px !important;\n\n  div[class*='ds__checkboxgroup '] {\n    p {\n      margin: 10px !important;\n      display: none;\n    }\n\n    label {\n      align-items: flex-start;\n    }\n  }\n\n  @media (max-width: ", ") {\n    margin: 16px 0;\n    max-height: 100px;\n    overflow-y: scroll;\n    width: auto !important;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledMitigationReviewCardWrapperContainer = styled.div(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n  margin-top: 64px;\n  background: linear-gradient(107.06deg, #e9f4d2 0%, #dfefbd 100%);\n  padding: 24px;\n  box-shadow: 0px 4px 20px 0px #00000033;\n  border-radius: 12px;\n  max-width: 464px;\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  margin-top: 64px;\n  background: linear-gradient(107.06deg, #e9f4d2 0%, #dfefbd 100%);\n  padding: 24px;\n  box-shadow: 0px 4px 20px 0px #00000033;\n  border-radius: 12px;\n  max-width: 464px;\n\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
});
var StyledMitigationReviewCardContainer = styled.div(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var StyledHeaderContainer = styled.div(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var StyledReviewCardCopy = styled.div(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  margin: 24px 0;\n"], ["\n  margin: 24px 0;\n"])));
var StyledIconContainer$1 = styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50px;\n  background: #b5da62;\n  margin-right: 10px;\n\n  svg path {\n    fill: #80bc00;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50px;\n  background: #b5da62;\n  margin-right: 10px;\n\n  svg path {\n    fill: #80bc00;\n  }\n"])));
var StyledCondHiddenContainer = styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: inline;\n  }\n"], ["\n  display: none;\n\n  @media (max-width: ", ") {\n    display: inline;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledErrorMessageContainer = styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  align-items: flex-start;\n  background: ", ";\n  border-radius: 5px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n  padding: 15px;\n\n  @media (max-width: ", ") {\n    margin: 0;\n    width: 100%;\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n"], ["\n  align-items: flex-start;\n  background: ", ";\n  border-radius: 5px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n  padding: 15px;\n\n  @media (max-width: ", ") {\n    margin: 0;\n    width: 100%;\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.dangerLight;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var templateObject_1$C, templateObject_2$r, templateObject_3$g, templateObject_4$d, templateObject_5$c, templateObject_6$9, templateObject_7$8, templateObject_8$5, templateObject_9$5, templateObject_10$4, templateObject_11$4, templateObject_12$4, templateObject_13$2, templateObject_14$1, templateObject_15$1, templateObject_16$1, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1, templateObject_22, templateObject_23, templateObject_24;

var ReviewSubmissionConfirmation = function () {
    var _a = useState(true), preventSubmit = _a[0], setPreventSubmit = _a[1];
    var submitForm = useFormikContext().submitForm;
    var submitClaim = useFnolData().submitClaim;
    var handleSubmitFNOL = function () {
        submitClaim(submitForm);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledSubmissionTextContainer, null,
            React.createElement(CheckboxGroup, { className: "confirmationText" },
                React.createElement(CheckboxGroup.Checkbox, { value: "yes", onChange: function () { return setPreventSubmit(!preventSubmit); } }, "* I confirm that the information I have provided is accurate to the best of my knowledge at this time. I understand that reporting a claim with false or misleading information is fraud and could be punished by law."))),
        React.createElement(Button, { disabled: preventSubmit, onPress: handleSubmitFNOL }, "Submit claim")));
};

var ReviewPolicyAndSubmitCard = function (_a) {
    var contactName = _a.contactName, contactRelationship = _a.contactRelationship, contactPrimaryPhoneType = _a.contactPrimaryPhoneType, contactPrimaryPhone = _a.contactPrimaryPhone, contactWantsSms = _a.contactWantsSms, contactEmail = _a.contactEmail;
    var values = useFormikContext().values;
    var sendExit = useFnolData().sendExit;
    var handleOnChangePolicyClick = function () {
        sendExit(values);
    };
    return (React.createElement(StyledPolicyInfoContainer, null,
        React.createElement(StyledPolicyInfoHeaderContainer, null,
            React.createElement(Heading, { size: "md", tag: "h2", className: "reviewCardHeader" }, "Policy"),
            React.createElement(Span, { color: "quiet", className: "changePolicyHeader", onClick: handleOnChangePolicyClick }, "Change")),
        React.createElement(PolicyCard, { isReviewScreen: true }),
        React.createElement(StyledPolicyInfoHeaderContainer, null,
            React.createElement(Heading, { size: "md", tag: "h2", className: "reviewCardHeader" }, "Contact details")),
        React.createElement(StyledContactValuesContainer, null,
            React.createElement(Span, { color: "quiet" },
                contactName,
                " (",
                contactRelationship,
                ")"),
            React.createElement(Span, { color: "quiet" },
                contactPrimaryPhoneType || 'Home',
                ": ",
                contactPrimaryPhone),
            React.createElement(Span, { color: "quiet" },
                "OK to text: ",
                contactWantsSms ? 'Yes' : 'No'),
            React.createElement(Span, { color: "quiet" }, contactEmail)),
        React.createElement(ReviewSubmissionConfirmation, null)));
};

var MitigationReviewCard = function (_a) {
    var onClick = _a.onClick, mitigationSelected = _a.mitigationSelected, selectedMitigationServices = _a.selectedMitigationServices, selectedMitigationServicesDisplayString = _a.selectedMitigationServicesDisplayString;
    var header = mitigationSelected ? 'Important reminder' : 'Service reminder';
    var isMultipleServicesSelected = selectedMitigationServices.length > 1;
    var renderCopy = function () {
        if (mitigationSelected) {
            return (React.createElement(Span, null,
                "After you submit this claim we will contact ",
                isMultipleServicesSelected ? ' ' : 'a ',
                React.createElement("b", null, selectedMitigationServicesDisplayString),
                " service provider",
                isMultipleServicesSelected ? 's' : '',
                ". Expect them to reach out within the next 4 hours."));
        }
        return 'You’ve said you don’t want to talk to a service provider about cleanup and damage prevention. Remember, preventing further damage is crucial. Don’t wait to take action!';
    };
    return (React.createElement(StyledMitigationReviewCardContainer, null,
        React.createElement(StyledHeaderContainer, null,
            React.createElement(StyledIconContainer$1, null,
                React.createElement(UiIcon, { name: "ServiceRequest", size: "md" })),
            ' ',
            React.createElement(Heading, { size: "md" }, header)),
        React.createElement(StyledReviewCardCopy, null, renderCopy()),
        React.createElement(Button, { appearance: "secondary", size: "sm", onClick: onClick }, "Change selection")));
};

var MitigationReviewCardWrapper = function () {
    var location = { section: 'sectionLossDetails', step: 'stepMitigationServices' };
    var _a = useFnolData(), setLocation = _a.setLocation, mitigationEligibility = _a.mitigationServices.mitigationEligibility;
    var values = useFormikContext().values;
    var mitigationOfferred = isMitigationServicesOffered(mitigationEligibility);
    var mitigationSelected = isMitigationSelected(values);
    var selectedMitigationServices = getMitigationSelectedServices(values);
    var selectedMitigationServicesDisplayString = getSelectedServicesDisplayStrings(selectedMitigationServices);
    var handleOnChangeClick = function () {
        setLocation({ location: location, values: values });
    };
    if (!mitigationOfferred) {
        return null;
    }
    return (React.createElement(StyledMitigationReviewCardWrapperContainer, null,
        React.createElement(MitigationReviewCard, { onClick: handleOnChangeClick, mitigationSelected: mitigationSelected, selectedMitigationServices: selectedMitigationServices, selectedMitigationServicesDisplayString: selectedMitigationServicesDisplayString })));
};

var ReviewSection = function (_a) {
    var title = _a.title, values = _a.values, questions = _a.questions;
    var _b = useFnolData(), setLocation = _b.setLocation, sendExit = _b.sendExit;
    var handleOnChangePolicyClick = function () {
        sendExit(values);
    };
    var handleOnClick = function (title) {
        if (title === "General info") {
            setLocation({
                location: { section: 'sectionGeneralInfo', step: 'stepConfirmAddress' },
                values: values,
            });
        }
        if (title === "Loss details") {
            setLocation({
                location: { section: 'sectionGeneralInfo', step: 'stepLossType' },
                values: values,
            });
        }
        if (title === "Repair work") {
            setLocation({
                location: { section: 'sectionLossDetails' },
                values: values,
            });
        }
        if (title === "Contact details") {
            setLocation({
                location: { section: 'sectionContactDetails', step: 'step-contact-details' },
                values: values,
            });
        }
    };
    var renderQuestionAndValue = function () {
        return Object.keys(questions).map(function (question) {
            var answers = questions[question];
            return (React.createElement(StyledContactValuesContainer, { key: question },
                React.createElement(Span, { color: "default", bold: true }, question),
                answers.map(function (answer) {
                    var _a;
                    var formattedAnswer;
                    // case where there is no value set or dne
                    if (values[answer] === undefined ||
                        values[answer] === '') {
                        formattedAnswer = '-';
                        // case for bool
                    }
                    else if (typeof values[answer] === 'boolean') {
                        formattedAnswer = values[answer] ? 'Yes' : 'No';
                        // edge case empty cost of estimate
                    }
                    else if (values[answer] === '$') {
                        formattedAnswer = '-';
                        // edge case for multiple values
                    }
                    else if (typeof values[answer] === 'object' &&
                        (
                        // @ts-ignore -- ignoring no length on FormField keys when there are
                        (_a = values[answer]) === null || _a === void 0 ? void 0 : _a.length)) {
                        return (React.createElement("div", { style: { display: 'flex', flexFlow: 'column' } }, values[answer].map(function (str) { return (React.createElement(Span, { color: "quiet", key: str }, str)); })));
                    }
                    else {
                        formattedAnswer = values[answer];
                    }
                    return (React.createElement(Span, { color: "quiet", key: answer }, formattedAnswer));
                })));
        });
    };
    if (title === 'Policy') {
        return (React.createElement(StyledCondHiddenContainer, null,
            React.createElement(StyledHeaderTextContainer, null,
                React.createElement(Heading, { size: "md", tag: "h2", className: "reviewCardHeader", "data-testid": "reviewSectionHeader" }, title),
                React.createElement(Span, { color: "quiet", className: "changePolicyHeader", onClick: handleOnChangePolicyClick }, "Change")),
            React.createElement(PolicyCard, { isReviewScreen: true })));
    }
    if (title === 'Contact details') {
        return (React.createElement(StyledCondHiddenContainer, null,
            React.createElement(StyledHeaderTextContainer, null,
                React.createElement(Heading, { size: "md", tag: "h2", className: "reviewCardHeader", "data-testid": "reviewSectionHeader" }, "Contact details"),
                React.createElement(Span, { color: "quiet", className: "changePolicyHeader", onClick: function () { return handleOnClick(title); } }, "Change")),
            React.createElement(StyledContactValuesContainer, null,
                React.createElement(Span, { color: "quiet" },
                    values.contactName,
                    " (",
                    values.contactRelationship,
                    ")"),
                React.createElement(Span, { color: "quiet" },
                    values.contactPrimaryPhoneType || 'Home',
                    ": ",
                    values.contactPrimaryPhone),
                React.createElement(Span, { color: "quiet" },
                    "OK to text: ",
                    values.contactWantsSms ? 'Yes' : 'No'),
                React.createElement(Span, { color: "quiet" }, values.contactEmail))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledHeaderTextContainer, null,
            React.createElement(Heading, { size: "md", tag: "h2", className: "reviewCardHeader", "data-testid": "reviewSectionHeader" }, title),
            React.createElement(Span, { color: "quiet", className: "changePolicyHeader", onClick: function () { return handleOnClick(title); } }, "Change")),
        renderQuestionAndValue()));
};

var Icon = forwardRef(function (props, ref) {
    var definitionLocation = useFnolData().definitionLocation;
    return (React.createElement(SVG, __assign({ innerRef: ref, title: props.label }, props, { src: "".concat(definitionLocation, "/").concat(props.src) })));
});

var Container$2 = styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--Spacing-xl, 24px);\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--Spacing-xl, 24px);\n"])));
var HeaderContainer = styled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: var(--Spacing-md, 12px);\n"], ["\n  display: flex;\n  align-items: center;\n  gap: var(--Spacing-md, 12px);\n"])));
var IconContainer = styled.span(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  // margin-top: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: var(--border-radius-xl-48, 48px);\n  background: var(--Lime-50, #f0f9dc);\n\n  svg path {\n    fill: #80bc00;\n  }\n"], ["\n  // margin-top: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: var(--border-radius-xl-48, 48px);\n  background: var(--Lime-50, #f0f9dc);\n\n  svg path {\n    fill: #80bc00;\n  }\n"])));
/**
 * Generate the Mitigation card on the review step of AP and MSS
 * @param location Mitigation step location
 * @returns
 */
var MitigationSubmittedCard = function () {
    var _a = useFnolData(), mitigationEligibility = _a.mitigationServices.mitigationEligibility, source = _a.source;
    var values = useFormikContext().values;
    var mitigationOfferred = isMitigationServicesOffered(mitigationEligibility);
    var mitigationSelected = isMitigationSelected(values);
    if (mitigationOfferred && mitigationSelected) {
        return (React.createElement(Card, { style: { margin: '20px 0px' } },
            React.createElement(Container$2, null,
                React.createElement(Heading, { size: "md" },
                    React.createElement(HeaderContainer, null,
                        React.createElement(IconContainer, null,
                            React.createElement(UiIcon, { name: "ServiceRequest", size: "md" })),
                        ' ',
                        "Service Requested")),
                React.createElement("div", null,
                    "We are contacting",
                    ' ',
                    React.createElement("b", null, getSelectedServicesDisplayStrings(getMitigationSelectedServices(values))),
                    ' ',
                    "service providers.",
                    ' ',
                    source === SOURCE.MY_SAGE_SURE ? 'Expect' : 'The policyholder should expect',
                    " to hear from them in the next 4 hours. We just sent a service request confirmation email",
                    ' ',
                    source === SOURCE.AGENT_PORTAL ? 'to the policyholder ' : '',
                    "with next steps and further information."))));
    }
    return React.createElement(React.Fragment, null);
};
var templateObject_1$B, templateObject_2$q, templateObject_3$f;

var StyledArticle = styled.article(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var StyledSectionHeader = styled.h6(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  ", ";\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  line-height: 24px;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  text-transform: uppercase;\n"], ["\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  ", ";\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  line-height: 24px;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  text-transform: uppercase;\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralLight;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.thin;
});
var StyledSubmissionTitleContainer = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n\n  div,\n  button {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n  }\n\n  button {\n    background: transparent;\n    border: none;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  h3 {\n    color: ", ";\n    ", ";\n    font-size: 24px;\n    line-height: 32px;\n    margin: 0 0 0 12px;\n  }\n\n  Text {\n    color: ", ";\n    margin-left: 10px;\n  }\n\n  @media (max-width: ", ") {\n    div {\n      padding: 0 0 16px 0;\n    }\n  }\n"], ["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n\n  div,\n  button {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n  }\n\n  button {\n    background: transparent;\n    border: none;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  h3 {\n    color: ", ";\n    ", ";\n    font-size: 24px;\n    line-height: 32px;\n    margin: 0 0 0 12px;\n  }\n\n  Text {\n    color: ", ";\n    margin-left: 10px;\n  }\n\n  @media (max-width: ", ") {\n    div {\n      padding: 0 0 16px 0;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralLight;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.book;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.interactive;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledNextStepsContainer = styled.p(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  && {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 32px;\n\n    b {\n      ", ";\n    }\n  }\n"], ["\n  && {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 32px;\n\n    b {\n      ", ";\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.bold;
});
var Phone = styled.a(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  && {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  && {\n    color: ", ";\n    text-decoration: none;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
});
var StyledClaimInfoContainer = styled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin: 24px 0;\n\n  @media (max-width: ", ") {\n    flex-flow: column nowrap;\n  }\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin: 24px 0;\n\n  @media (max-width: ", ") {\n    flex-flow: column nowrap;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledClaimTimelineContainer = styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  margin-bottom: 32px;\n  position: relative;\n\n  .background {\n    background: ", ";\n    bottom: 0;\n    height: 24px;\n    left: 50%;\n    margin: auto;\n    position: absolute;\n    transform: translateX(-50%);\n    width: 90%;\n    z-index: 1;\n  }\n\n  .statuses {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(2, auto);\n    justify-content: space-between;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n\n    .status {\n      align-items: center;\n      display: flex;\n      flex-flow: column nowrap;\n      justify-content: flex-end;\n      width: 60px;\n    }\n\n    p {\n      ", ";\n      font-size: 12px;\n      line-height: 16px;\n      text-align: center;\n      margin: 1px 0 11px 0;\n    }\n\n    span {\n      ", ";\n      font-size: 10px;\n      line-height: 13px;\n    }\n  }\n"], ["\n  margin-bottom: 32px;\n  position: relative;\n\n  .background {\n    background: ", ";\n    bottom: 0;\n    height: 24px;\n    left: 50%;\n    margin: auto;\n    position: absolute;\n    transform: translateX(-50%);\n    width: 90%;\n    z-index: 1;\n  }\n\n  .statuses {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(2, auto);\n    justify-content: space-between;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n\n    .status {\n      align-items: center;\n      display: flex;\n      flex-flow: column nowrap;\n      justify-content: flex-end;\n      width: 60px;\n    }\n\n    p {\n      ", ";\n      font-size: 12px;\n      line-height: 16px;\n      text-align: center;\n      margin: 1px 0 11px 0;\n    }\n\n    span {\n      ", ";\n      font-size: 10px;\n      line-height: 13px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.canvas;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.bold;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.book;
});
var StyledPrintButtonContainer = styled.div(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  svg {\n    margin-right: 5px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      display: none;\n    }\n  }\n"], ["\n  svg {\n    margin-right: 5px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      display: none;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledSubmissionSuccessContainer = styled.div(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  width: 80vw;\n  margin-top: 75px;\n\n  p {\n    width: auto !important;\n    text-align: left !important;\n  }\n\n  div[class*='ds__card'] {\n    padding: 0;\n    margin: 24px 0 !important;\n  }\n"], ["\n  width: 80vw;\n  margin-top: 75px;\n\n  p {\n    width: auto !important;\n    text-align: left !important;\n  }\n\n  div[class*='ds__card'] {\n    padding: 0;\n    margin: 24px 0 !important;\n  }\n"])));
var templateObject_1$A, templateObject_2$p, templateObject_3$e, templateObject_4$c, templateObject_5$b, templateObject_6$8, templateObject_7$7, templateObject_8$4, templateObject_9$4;

var SubmissionSuccess = function (_a) {
    var values = _a.values, claimNumber = _a.claimNumber, claimSubmissionNumber = _a.claimSubmissionNumber;
    return (React.createElement(StyledSubmissionSuccessContainer, { "data-testid": "submissionSuccesss" },
        React.createElement(StyledSubmissionTitleContainer, null,
            React.createElement("div", null,
                React.createElement(Icon, { src: "assets/checkmark-icon.svg", label: "checkmark" }),
                React.createElement("h3", null,
                    " ",
                    'Your claim has been successfully submitted.')),
            React.createElement(StyledPrintButtonContainer, null,
                React.createElement("button", { type: "button", onClick: function () { return window.print(); } },
                    React.createElement(Icon, { src: "assets/print-icon.svg", label: "print" }),
                    React.createElement(Span, { bold: true }, "Print")))),
        React.createElement(StyledClaimInfoContainer, null,
            claimNumber ? (React.createElement(StyledArticle, null,
                React.createElement(Span, { bold: true }, "Claim Number"),
                React.createElement(Span, { color: "quiet" }, claimNumber))) : (React.createElement(StyledArticle, null,
                React.createElement(Span, { bold: true }, "Submission Number"),
                React.createElement(Span, { color: "quiet" }, claimSubmissionNumber ? claimSubmissionNumber : 'Generating...'))),
            React.createElement(StyledArticle, null,
                React.createElement(Span, { bold: true }, "Date Submitted"),
                React.createElement(Span, { color: "quiet" }, format(new Date(), 'LLL d, yyyy'))),
            React.createElement(StyledArticle, null,
                React.createElement(Span, { bold: true }, "Status"),
                React.createElement(Span, { color: "quiet" }, 'Claim Reported'))),
        React.createElement(StyledClaimTimelineContainer, null,
            React.createElement("div", { className: "statuses" },
                React.createElement("div", { className: "status" },
                    React.createElement("span", null, format(new Date(), 'LLL d')),
                    React.createElement("p", null, "Claim Reported"),
                    React.createElement(Icon, { src: "assets/circled-checkmark-icon.svg", label: "checkmark" })),
                React.createElement("div", { className: "status" },
                    React.createElement("p", null, "Adjuster Assigned"),
                    React.createElement(Icon, { src: "assets/time-icon.svg", label: "checkmark" })),
                React.createElement("div", { className: "status" },
                    React.createElement("p", null, "Customer Contacted"),
                    React.createElement(Icon, { src: "assets/time-icon.svg", label: "checkmark" })),
                React.createElement("div", { className: "status" },
                    React.createElement("p", null, "Claim Settled"),
                    React.createElement(Icon, { src: "assets/time-icon.svg", label: "checkmark" }))),
            React.createElement("div", { className: "background" })),
        React.createElement(React.Fragment, null,
            React.createElement(StyledSectionHeader, null, "Next Steps"),
            React.createElement(StyledNextStepsContainer, null,
                "We just sent a confirmation email to ",
                React.createElement("b", null, values.contactEmail),
                ". We'll review your claim, assign it to an adjuster, and reach out to you with next steps. You can expect to hear from us in 1-2 business days. If you have questions you can track your claim on the",
                ' ',
                React.createElement(Link, { href: "https://my.sagesure.com/my/claims" }, "Claims"),
                " page or call us at",
                ' ',
                React.createElement(Phone, { href: "tel:8663117243" },
                    React.createElement("b", null, "(866) 311-7243.")),
                ' ',
                "If this is a fire loss, we will be contacting a vendor to begin investigating the source and origin of the fire."),
            React.createElement(MitigationSubmittedCard, null),
            React.createElement(StyledSectionHeader, null, "Claim Details"))));
};

styled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: center;\n  position: relative;\n  z-index: 0;\n\n  svg:nth-child(2) {\n    position: absolute;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: center;\n  position: relative;\n  z-index: 0;\n\n  svg:nth-child(2) {\n    position: absolute;\n  }\n"])));
var Svg = styled.svg(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  &:not(.omit-hover) {\n    &:hover {\n      cursor: pointer;\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  &:not(.omit-hover) {\n    &:hover {\n      cursor: pointer;\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.interactive;
});
var templateObject_1$z, templateObject_2$o;

var IconError = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? '#BF2324' : _b, _c = _a.width, width = _c === void 0 ? '21' : _c, _d = _a.height, height = _d === void 0 ? '21' : _d;
    return (React.createElement(Svg, { className: className, width: width, height: height, viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2296 20.5C15.8554 20.5 20.4211 16.02 20.4211 10.5C20.4211 4.98 15.8554 0.5 10.2296 0.5C4.60394 0.5 0.038147 4.98 0.038147 10.5C0.038147 16.02 4.60394 20.5 10.2296 20.5ZM9.21049 5.5H11.2488V7.5H9.21049V5.5ZM9.21049 9.5H11.2488L11.2488 15.5L9.21049 15.5L9.21049 9.5Z", fill: color })));
};

var reviewScreenKeyValueMap = {
    'Policy': {},
    'General info': {
        'Loss happened at the policy address?': ['atInsuredAddress'],
        'Reported by policyholder?': ['submitByPolicyholder'],
        'Loss date': ['lossDate', 'lossTime'],
    },
    'Loss details': {
        'Type of loss': ['lossType'],
        'Loss description': ['lossDescription'],
        'What was damaged?': ['damaged'],
        'Interior or exterior?': ['damagedHome'],
        'Things that appear damaged': ['damagedExterior', 'damagedRooms'],
    },
    'Repair work': {
        'Is your home currently without electricity or water?': ['withoutElectricityOrWater'],
        'Is your home currently habitable?': ['habitable'],
        'Is there standing water in your home or water-soaked property that needs to be dried?': ['standingWater'],
        'Are there uncovered holes in the roof, walls, windows, or doors?': ['uncoveredHoles'],
        'Are there trees, branches, or other debris on your home that require immediate removal?': ['debrisRemovalRequired'],
        'Have you received an estimate, started, or completed any repairs or mitigation?': ['repairOrMitigationProgress'],
        'Estimate amount': ['estimateAmount'],
    },
    'Contact details': {},
};

var ReviewBlock = function (_a) {
    var values = _a.values, submitted = _a.submitted, submissionError = _a.submissionError, isSubmitting = _a.isSubmitting;
    var _b = useFnolData(), claimSubmissionNumber = _b.claimSubmissionNumber, claimNumber = _b.claimNumber, sendEvent = _b.sendEvent;
    useEffect(function () {
        if (!submitted && !isSubmitting) {
            sendEvent({
                name: AnalyticsEventNames.ReviewPage,
                lossType: values === null || values === void 0 ? void 0 : values.lossType,
            });
        }
        else if (submitted && !isSubmitting) {
            sendEvent({
                name: AnalyticsEventNames.ConfirmationPage,
                lossType: values === null || values === void 0 ? void 0 : values.lossType,
                hasClaimID: claimNumber || claimSubmissionNumber ? true : false,
            });
        }
    }, [submitted, claimSubmissionNumber, claimNumber, isSubmitting, values === null || values === void 0 ? void 0 : values.lossType, sendEvent]);
    var renderSubmissionError = function () {
        return (React.createElement(StyledErrorMessageContainer, null,
            React.createElement(IconError, { className: "omit-hover" }),
            submissionError));
    };
    if (isSubmitting || !values) {
        return (React.createElement(StyledLoadingPlaceholder, { "data-testid": "reviewBlock", className: "loadingSpinner" },
            React.createElement(Spinner, null)));
    }
    if (submitted) {
        return (React.createElement(SubmissionSuccess, { values: values, claimNumber: claimNumber, claimSubmissionNumber: claimSubmissionNumber }));
    }
    return (React.createElement("div", null,
        submissionError && renderSubmissionError(),
        React.createElement(StyledReviewPageContentContainer, null,
            React.createElement(StyledFnolInfoContainer, null,
                React.createElement(Heading, { size: "md", tag: "h2", className: "pageHeader", "data-testid": "reviewBlock" }, "You're almost there"),
                React.createElement(Span, { className: "textSubheader" }, "Please make sure your claim details are complete and accurate before submitting."),
                React.createElement(MitigationReviewCardWrapper, null),
                Object.keys(reviewScreenKeyValueMap).map(function (key) {
                    return (React.createElement(ReviewSection, { title: key, key: key, values: values, questions: reviewScreenKeyValueMap[key] }));
                })),
            React.createElement(ReviewPolicyAndSubmitCard, { contactName: values.contactName, contactRelationship: values.contactRelationship, contactPrimaryPhoneType: values.contactPrimaryPhoneType, contactPrimaryPhone: values.contactPrimaryPhone, contactWantsSms: values.contactWantsSms, contactEmail: values.contactEmail })),
        React.createElement(StyledReviewPageFooterContainer, null,
            React.createElement(ReviewSubmissionConfirmation, null))));
};

function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}

function formatPhoneNum(input) {
    var mask = new StringMask('(000) 000-0000');
    return mask.apply(input.replace(/(?:^1)|\D/g, ''));
}
/**
 * Force format time to HH:MM format
 *  force format- add empty zeros if all digits not given
 */
function formatTimeToRequired(input) {
    var formattedTime = '';
    var hour = '';
    var minute = '';
    var splitTimePeriod = input.split(/[\s:]+/);
    if (/^([0-2][0-9]?) (..)$/.test(input)) {
        hour = splitTimePeriod[0];
    }
    else {
        hour = splitTimePeriod[0];
        minute = splitTimePeriod[1];
    }
    if (!hour && !minute) {
        return '';
    }
    formattedTime = hour.length == 1 ? '0' + hour : hour;
    formattedTime += ':';
    if (minute && minute.length == 1) {
        formattedTime += minute + '0';
    }
    else if (minute) {
        formattedTime += minute;
    }
    else if (hour) {
        formattedTime += '00';
    }
    return formattedTime;
}
/**
 * Format time to HH:MM format
 *  don't force format if all digits not there yet
 */
function formatTime(input, current) {
    var savedTime = current && current.split(' ')[0];
    if (!savedTime) {
        return input;
    }
    else if (savedTime && savedTime.length > input.length) {
        return input;
    }
    else if (input.length == 2 && input[input.length - 1] == ':') {
        input = '0' + input;
    }
    var mask = new StringMask('00:00');
    var formattedTime = mask.apply(input.replace(/(:)/g, ''));
    return formattedTime;
}
/**
 * Format dollar to include dollar sign and commas
 */
function formatDollar(input) {
    var strippedInput = input.replace(/\$|,|[a-zA-Z]/g, '');
    var formattedDollar = strippedInput.split(/(?=(?:\d{3})+(?:\.|$))/g).join(',');
    formattedDollar = '$' + formattedDollar;
    return formattedDollar;
}
/**
 * Format dollar to required format ($XX,XXX.XX)
 *  add dollar sign, commas, and decimals
 */
function formatDollarToRequired(input) {
    if (input == '') {
        return input;
    }
    var strippedInput = input.replace(/\$|,|[a-zA-Z]/g, '');
    var formattedDollar = strippedInput.split(/(?=(?:\d{3})+(?:\.|$))/g).join(',');
    var splitDollar = input.split('.');
    if (splitDollar.length == 1) {
        formattedDollar += '.00';
    }
    else if (splitDollar[1].length == 0) {
        formattedDollar += '00';
    }
    else if (splitDollar[1].length == 1) {
        formattedDollar += '0';
    }
    formattedDollar = '$' + formattedDollar;
    return formattedDollar;
}
/**
 * Format dollar to match API formatting
 *   Remove commas and dollar sign
 */
function formatDollarToApiFormat(input) {
    return input.replace(/\$|,/g, '');
}

var subTypes = {
    "Damage to someone else's property": 'lossSubTypeDamagedPropertyOwner',
    'Earthquake or ground movement': 'lossSubTypeEarthquake',
    Fire: 'lossSubTypeFire',
    Freezing: 'lossSubTypeFreezing',
    'Physical injury': 'lossSubTypeInjury',
    Other: 'lossSubTypeOther',
    'Wind / Hail / Hurricane / Storm': 'lossSubTypeStorm',
    'Theft or mysterious disappearance': 'lossSubTypeTheft',
    Water: 'lossSubTypeWater',
};
var uploadMaps = {
    'Appraisals, receipts, or photos of the stolen or damaged items': 'fileUploadAppraisalsReceipts',
    'Photos of the damage': 'fileUploadDamagePhotos',
    'copy of the estimate(s)': 'fileUploadEstimates',
    'copy of the invoice(s) and photos of completed work': 'fileUploadInvoicesCompletedWork',
    'copy of report - police or fire department': 'fileUploadReport',
};
var mapDraftToFnol = function (mappings, draft, attachments) {
    var flattened = {};
    var values = {
        atInsuredAddress: false,
        lossDate: '',
        lossType: '',
        submitByPolicyholder: false,
    };
    mappings
        .filter(function (item) { return item.inputs !== undefined; })
        .filter(function (item) { return item.output[0] !== 'SubtypeOfLoss'; })
        .forEach(function (mapping) {
        return mapping.inputs.forEach(function (item) { return (flattened[item] = { value: '', input: mapping.output }); }, mapping);
    });
    for (var _i = 0, _a = Object.entries(flattened); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        value.input.length === 2
            ? (values[key] = draft[value.input[0]][value.input[1]])
            : (values[key] = draft[value.input[0]]);
    }
    var dateTimeString = new String(draft.DateOfLoss);
    var lossDate = new Date(dateTimeString);
    var time = dateFnsFormat(lossDate, 'hh:mm aa');
    values.lossDate = dateFnsFormat(lossDate, DATE_MONTH_DAY_YEAR_FORMAT);
    // if no time is submitted than time stamp defaults to 00:00
    // which breaks the validation since not real time
    values.lossTime = time === '00:00' ? '' : time;
    // Set singular subType of loss based on lossType
    values[subTypes[draft.TypeOfLoss]] = draft.SubtypeOfLoss;
    // set singular injuredPerson since its a repeat
    values.injuredPersons = [{ injuredPersonName: draft.Injury.InjuredPersons[0] }];
    // set witness info for mapping to form names
    values.witnesses = draft.Witnesses.map(function (info) { return ({
        witnessName: info.name,
        witnessPhone: info.phone,
        witnessEmail: info.email,
    }); });
    values.repairAmountPaid = formatDollar(draft.RepairOrMitigation.RepairAmountPaid);
    values.estimateAmount = formatDollar(draft.RepairOrMitigation.EstimateAmount);
    values.csrnotes = draft.CsrNotes;
    values.hasDrafts = true;
    var mappedAttachments = attachments === null || attachments === void 0 ? void 0 : attachments.reduce(function (acc, item) {
        var clone = JSON.parse(JSON.stringify(item));
        clone.type = item.contentType;
        clone.name = item.filename;
        clone.saved = true;
        clone.dataUrl = null;
        acc[uploadMaps[item.category]].push(clone);
        return acc;
    }, {
        fileUploadAppraisalsReceipts: [],
        fileUploadDamagePhotos: [],
        fileUploadEstimates: [],
        fileUploadInvoicesCompletedWork: [],
        fileUploadReport: [],
    });
    if (mappedAttachments !== null && mappedAttachments !== undefined) {
        Object.entries(mappedAttachments).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            values[key] = JSON.stringify(value);
        });
    }
    // Format phone numbers properly
    values.contactPrimaryPhone = formatPhoneNum(values.contactPrimaryPhone);
    values.contactAddPhone = formatPhoneNum(values.contactAddPhone);
    values.submitByPrimaryPhone = formatPhoneNum(values.submitByPrimaryPhone);
    values.submitByAltPhone = formatPhoneNum(values.submitByAltPhone);
    // Properly assign value for contactAddPhoneLink in contact details section
    values.contactAddPhoneLink = values.contactAddPhone.length > 0 ? true : '';
    values.policyholderAddPhoneLink = values.submitByAltPhone.length > 0 ? true : '';
    if (draft.HomeDamage.HomeLocationDamage.includes('Interior') &&
        !draft.HomeDamage.HomeLocationDamage.includes('Exterior')) {
        values.damagedHome = ['Interior damage'];
    }
    else if (!draft.HomeDamage.HomeLocationDamage.includes('Interior') &&
        draft.HomeDamage.HomeLocationDamage.includes('Exterior')) {
        values.damagedHome = ['Exterior damage'];
    }
    else if (draft.HomeDamage.HomeLocationDamage.includes('Interior') &&
        draft.HomeDamage.HomeLocationDamage.includes('Exterior')) {
        values.damagedHome = ['Interior damage', 'Exterior damage'];
    }
    values.smokeRemovalRequiredForStructureOrPersonalProperty = [];
    // Values are saved as booleans, this converts the boolean into
    // a string value to support the multi input
    if (draft.Habitability.SmokeRemovalRequiredForPersonalProperty) {
        values.smokeRemovalRequiredForStructureOrPersonalProperty.push(MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_PERSONAL_PROPERTY);
    }
    // Values are saved as booleans, this converts the boolean into
    // a string value to support the multi input
    if (draft.Habitability.SmokeRemovalRequiredForStructure) {
        values.smokeRemovalRequiredForStructureOrPersonalProperty.push(MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_STRUCTURE);
    }
    return values;
};

var updateFieldValue = function (mitigationSelection, setFieldValue, setFieldTouched, mitigationField, lossType) {
    var _a;
    var mitigationFieldValue = (_a = mitigationSelection.get(lossType)) === null || _a === void 0 ? void 0 : _a[mitigationField];
    setFieldValue(mitigationField, mitigationFieldValue);
    if (mitigationFieldValue !== undefined) {
        setFieldTouched(mitigationField, mitigationFieldValue);
    }
};
/**
 * Handles updating the selected mitigation options. Mitigation is a unique case were the available
 * values change depending on other selected options. This causes scenarios where in one case
 * there could be fire mitigation but if you switch loss types then new mitigations could be available
 * and fire is no longer a valid mitigation. This function would clear out the selected mitigation(s)
 * when mitigations are updated to ensure that value does
 * @returns null
 */
function MitigationValueUpdater() {
    var _a = useFormikContext(), values = _a.values, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
    var _b = useFnolData(), mitigationServices = _b.mitigationServices, showMitigation = _b.showMitigation, hydratingDraft = _b.hydratingDraft, editingDraft = _b.editingDraft, draftBeingEdited = _b.draftBeingEdited, mappings = _b.definition.mappings;
    var lossType = values.lossType, customerRequestsDebrisRemoval = values.customerRequestsDebrisRemoval, customerRequestsSmokeMitigationForPersonalProperty = values.customerRequestsSmokeMitigationForPersonalProperty, customerRequestsSmokeMitigationForStructure = values.customerRequestsSmokeMitigationForStructure, customerRequestsTarping = values.customerRequestsTarping, customerRequestsWaterMitigation = values.customerRequestsWaterMitigation, mitigationRejectAll = values.mitigationRejectAll;
    var prevLossType = usePrevious(lossType);
    var prevCustomerRequestsDebrisRemoval = usePrevious(customerRequestsDebrisRemoval);
    var prevCustomerRequestsSmokeMitigationForPersonalProperty = usePrevious(customerRequestsSmokeMitigationForPersonalProperty);
    var prevCustomerRequestsSmokeMitigationForStructure = usePrevious(customerRequestsSmokeMitigationForStructure);
    var prevCustomerRequestsTarping = usePrevious(customerRequestsTarping);
    var prevCustomerRequestsWaterMitigation = usePrevious(customerRequestsWaterMitigation);
    var prevRejectAll = usePrevious(mitigationRejectAll);
    var _c = useState(null), draftApplied = _c[0], setDraftApplied = _c[1];
    var _d = useState(new Map()), mitigationSelection = _d[0], setMitigationSelection = _d[1];
    var prevShowMitigation = usePrevious(showMitigation);
    var prevHydratingDraft = usePrevious(hydratingDraft);
    var clearMitigationSelection = useCallback(function () {
        setFieldValue(MITIGATION_FIELD_WATER, '');
        setFieldValue(MITIGATION_FIELD_DEBRIS_REMOVAL, '');
        setFieldValue(MITIGATION_FIELD_TARPING, '');
        setFieldValue(MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY, '');
        setFieldValue(MITIGATION_FIELD_SMOKE_FOR_STRUCTURE, '');
        setFieldValue(MITIGATION_FIELD_REJECT_ALL, false);
    }, [setFieldValue]);
    var saveMitigationSelection = useCallback(function (_a) {
        var _b;
        var lossType = _a.lossType, customerRequestsWaterMitigation = _a.customerRequestsWaterMitigation, customerRequestsDebrisRemoval = _a.customerRequestsDebrisRemoval, customerRequestsTarping = _a.customerRequestsTarping, customerRequestsSmokeMitigationForPersonalProperty = _a.customerRequestsSmokeMitigationForPersonalProperty, customerRequestsSmokeMitigationForStructure = _a.customerRequestsSmokeMitigationForStructure, mitigationRejectAll = _a.mitigationRejectAll;
        mitigationSelection.set(lossType, (_b = {},
            _b[MITIGATION_FIELD_WATER] = customerRequestsWaterMitigation,
            _b[MITIGATION_FIELD_DEBRIS_REMOVAL] = customerRequestsDebrisRemoval,
            _b[MITIGATION_FIELD_TARPING] = customerRequestsTarping,
            _b[MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY] = customerRequestsSmokeMitigationForPersonalProperty,
            _b[MITIGATION_FIELD_SMOKE_FOR_STRUCTURE] = customerRequestsSmokeMitigationForStructure,
            _b[MITIGATION_FIELD_REJECT_ALL] = mitigationRejectAll !== null && mitigationRejectAll !== void 0 ? mitigationRejectAll : false,
            _b));
        setMitigationSelection(mitigationSelection);
    }, [mitigationSelection]);
    var restoreMitigationSelection = useCallback(function (mitigationSelection, mitigationEligibility, lossType) {
        if (mitigationEligibility.waterMitigation) {
            updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_WATER, lossType);
        }
        else {
            setFieldValue(MITIGATION_FIELD_WATER, "");
        }
        if (mitigationEligibility.debrisRemoval) {
            updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_DEBRIS_REMOVAL, lossType);
        }
        else {
            setFieldValue(MITIGATION_FIELD_DEBRIS_REMOVAL, "");
        }
        if (mitigationEligibility.smokeForPersonalProperty) {
            updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY, lossType);
        }
        else {
            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY, "");
        }
        if (mitigationEligibility.smokeForStructure) {
            updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_SMOKE_FOR_STRUCTURE, lossType);
        }
        else {
            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_STRUCTURE, "");
        }
        if (mitigationEligibility.tarping) {
            updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_TARPING, lossType);
        }
        else {
            setFieldValue(MITIGATION_FIELD_TARPING, "");
        }
        updateFieldValue(mitigationSelection, setFieldValue, setFieldTouched, MITIGATION_FIELD_REJECT_ALL, lossType);
    }, [setFieldTouched, setFieldValue]);
    useEffect(function () {
        if (showMitigation &&
            (prevCustomerRequestsDebrisRemoval !== customerRequestsDebrisRemoval ||
                prevCustomerRequestsSmokeMitigationForPersonalProperty !==
                    customerRequestsSmokeMitigationForPersonalProperty ||
                prevCustomerRequestsSmokeMitigationForStructure !==
                    customerRequestsSmokeMitigationForStructure ||
                prevCustomerRequestsTarping !== customerRequestsTarping ||
                prevCustomerRequestsWaterMitigation !== customerRequestsWaterMitigation ||
                prevRejectAll !== mitigationRejectAll)) {
            saveMitigationSelection({
                lossType: lossType,
                customerRequestsWaterMitigation: customerRequestsWaterMitigation,
                customerRequestsDebrisRemoval: customerRequestsDebrisRemoval,
                customerRequestsTarping: customerRequestsTarping,
                customerRequestsSmokeMitigationForPersonalProperty: customerRequestsSmokeMitigationForPersonalProperty,
                customerRequestsSmokeMitigationForStructure: customerRequestsSmokeMitigationForStructure,
                mitigationRejectAll: mitigationRejectAll,
            });
        }
    }, [
        customerRequestsDebrisRemoval,
        customerRequestsSmokeMitigationForPersonalProperty,
        customerRequestsSmokeMitigationForStructure,
        customerRequestsTarping,
        customerRequestsWaterMitigation,
        lossType,
        prevCustomerRequestsDebrisRemoval,
        prevCustomerRequestsSmokeMitigationForPersonalProperty,
        prevCustomerRequestsSmokeMitigationForStructure,
        prevCustomerRequestsTarping,
        prevCustomerRequestsWaterMitigation,
        prevRejectAll,
        mitigationRejectAll,
        saveMitigationSelection,
        showMitigation,
    ]);
    useEffect(function () {
        if (hydratingDraft && (draftBeingEdited === null || draftBeingEdited === void 0 ? void 0 : draftBeingEdited.draftFnolJson)) {
            setDraftApplied(draftBeingEdited.draftFnolJson);
        }
        if (prevHydratingDraft && !hydratingDraft && draftApplied) {
            var draftValues = mapDraftToFnol(mappings, draftApplied);
            saveMitigationSelection({
                lossType: draftValues.lossType,
                customerRequestsWaterMitigation: draftValues.customerRequestsWaterMitigation,
                customerRequestsDebrisRemoval: draftValues.customerRequestsDebrisRemoval,
                customerRequestsTarping: draftValues.customerRequestsTarping,
                customerRequestsSmokeMitigationForPersonalProperty: draftValues.customerRequestsSmokeMitigationForPersonalProperty,
                customerRequestsSmokeMitigationForStructure: draftValues.customerRequestsSmokeMitigationForStructure,
                mitigationRejectAll: draftValues.mitigationRejectAll,
            });
            setDraftApplied(null);
        }
    }, [
        hydratingDraft,
        editingDraft,
        saveMitigationSelection,
        prevHydratingDraft,
        mappings,
        draftBeingEdited === null || draftBeingEdited === void 0 ? void 0 : draftBeingEdited.draftFnolJson,
        setFieldTouched,
        draftApplied,
        setDraftApplied
    ]);
    useEffect(function () {
        if (prevShowMitigation != showMitigation) {
            if (showMitigation) {
                restoreMitigationSelection(mitigationSelection, mitigationServices === null || mitigationServices === void 0 ? void 0 : mitigationServices.mitigationEligibility, lossType);
            }
            else {
                clearMitigationSelection();
            }
        }
    }, [
        clearMitigationSelection,
        customerRequestsDebrisRemoval,
        customerRequestsSmokeMitigationForPersonalProperty,
        customerRequestsSmokeMitigationForStructure,
        customerRequestsTarping,
        customerRequestsWaterMitigation,
        lossType,
        mitigationServices === null || mitigationServices === void 0 ? void 0 : mitigationServices.mitigationEligibility,
        mitigationSelection,
        prevLossType,
        prevShowMitigation,
        restoreMitigationSelection,
        saveMitigationSelection,
        showMitigation,
    ]);
    return null;
}

/**
 * This mirrors the scripts/compile.js logic for generating the filename
 * @param application equivalent of environment in compile.js
 * @param carrier
 * @param formVersion
 * @returns
 */
var generateAwsFormFileName = function (_a) {
    var application = _a.application, _b = _a.carrier, carrier = _b === void 0 ? 'default' : _b, _c = _a.formVersion, formVersion = _c === void 0 ? 'latest' : _c;
    return "form-def-".concat(application, "-").concat(carrier, "-").concat(formVersion, ".json");
};

var carrierGroupCodes = ['iat', 'inb', 'fnhc', 'sic', 'imfic', 'srch', 'sure'];
function loadFormDef(location, platform, carrierGroup, file, definitionFormType) {
    var _a;
    if (carrierGroup === void 0) { carrierGroup = 'default'; }
    return __awaiter(this, void 0, void 0, function () {
        var fallbackFilename, cg, carrier, componentVersion, formVersion, updateCarrierOnAlphaDev, filename, fileOverride, res, def;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fallbackFilename = generateAwsFormFileName({
                        application: platform,
                    });
                    cg = carrierGroup.toLowerCase();
                    carrier = carrierGroupCodes.includes(cg) ? cg : 'default';
                    componentVersion = (_a = window.FNOL_COMPONENT_VERSION) !== null && _a !== void 0 ? _a : 'dev';
                    formVersion = definitionFormType !== null && definitionFormType !== void 0 ? definitionFormType : 'latest';
                    updateCarrierOnAlphaDev = function () {
                        carrier = ['fnhc', 'iat', 'imfic', 'sic'].includes(carrier) ? carrier : 'default';
                    };
                    if (definitionFormType === undefined || definitionFormType === '') {
                        if (componentVersion.includes('alpha')) {
                            formVersion = 'alpha';
                            updateCarrierOnAlphaDev();
                        }
                        else if (componentVersion === 'dev') {
                            formVersion = 'dev';
                            updateCarrierOnAlphaDev();
                        }
                    }
                    else if (definitionFormType === 'alpha' || definitionFormType === 'dev') {
                        updateCarrierOnAlphaDev();
                    }
                    filename = generateAwsFormFileName({
                        application: platform,
                        carrier: carrier,
                        formVersion: formVersion,
                    });
                    fileOverride = queryFileNameOverride();
                    if (fileOverride) {
                        filename = fileOverride;
                    }
                    else if (file) {
                        filename = file;
                    }
                    return [4 /*yield*/, fetch(defUrl(location, platform, filename), { cache: 'no-store' })];
                case 1:
                    res = _b.sent();
                    if (!(res.status === 403 || res.status === 404)) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(defUrl(location, platform, fallbackFilename), { cache: 'no-store' })];
                case 2:
                    res = _b.sent();
                    _b.label = 3;
                case 3:
                    if (!res.ok) return [3 /*break*/, 5];
                    return [4 /*yield*/, res.json()];
                case 4:
                    def = _b.sent();
                    // TODO: add some def validation, throw error if failed
                    return [2 /*return*/, def];
                case 5: throw new Error('Unable to load form');
            }
        });
    });
}
/**
 * Walk block tree, calling the callback function at each node.
 */
function walkBlocks(blocks, callback) {
    blocks.forEach(function (block) {
        var show = callback(block);
        if (block.children && show) {
            walkBlocks(block.children, callback);
        }
        else if (assertSlotted(block) && block.slots && show) {
            var children = Object.keys(block.slots).map(function (key) { return block.slots[key]; });
            walkBlocks(children, callback);
        }
    });
}
function queryFileNameOverride() {
    var qs = window.location.search.replace(/^\?/, '');
    if (qs) {
        var query = parse(qs);
        if (query.def && typeof query.def === 'string') {
            return query.def;
        }
    }
    return null;
}
function defUrl(location, platform, filename) {
    return "".concat(location, "/").concat(platform, "/").concat(filename);
}
function assertSlotted(block) {
    return 'slots' in block;
}

var _a;
var TransformFunc;
(function (TransformFunc) {
    TransformFunc["JsonParse"] = "JsonParse";
    TransformFunc["Lowercase"] = "Lowercase";
    TransformFunc["FormatDateString"] = "FormatDateString";
    TransformFunc["FormatDollarString"] = "FormatDollarString";
    TransformFunc["FormatOrigin"] = "FormatOrigin";
    TransformFunc["ProcessDamagedHome"] = "ProcessDamagedHome";
    TransformFunc["ProcessSmokeRemovalRequiredForStructure"] = "ProcessSmokeRemovalRequiredForStructure";
    TransformFunc["ProcessSmokeRemovalRequiredForPersonalProperty"] = "ProcessSmokeRemovalRequiredForPersonalProperty";
})(TransformFunc || (TransformFunc = {}));
var dropSubLossTypesNotInLossType = function (formValues, subLossKey) {
    Object.values(LOSS_SUB_TYPE).forEach(function (value) {
        if (value !== subLossKey) {
            delete formValues[value];
        }
    });
    return formValues;
};
function mapValuesToSubmit(mappings, values, details, obj) {
    var results = obj !== null && obj !== void 0 ? obj : {
        policyId: details.policyId,
        Source: details.source,
        DuplicateOverride: details.allowDuplicate,
        pendingNumber: details.pendingNumber,
        previousDraftFnolId: details.previousDraftFnolId,
        draftFnolNumber: details.draftFnolNumber,
    };
    switch (values["lossType"]) {
        case LOSS_TYPE.Other:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.Other);
            break;
        case LOSS_TYPE.WindHailHurricaneStorm:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.WindHailHurricaneStorm);
            break;
        case LOSS_TYPE.Fire:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.Fire);
            break;
        case LOSS_TYPE.Water:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.Water);
            break;
        case LOSS_TYPE.TheftOrMysteriousDisappearance:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.TheftOrMysteriousDisappearance);
            break;
        case LOSS_TYPE.Freezing:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.Freezing);
            break;
        case LOSS_TYPE.EarthquakeOrGroundMovement:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.EarthquakeOrGroundMovement);
            break;
        case LOSS_TYPE.PhysicalInjury:
            values = dropSubLossTypesNotInLossType(values, LOSS_SUB_TYPE.PhysicalInjury);
            break;
    }
    mappings.forEach(function (m) {
        if ('inputs' in m) {
            // Our input values go through pipeline before being appended to the results object
            var vals = m.inputs
                .map(function (input) { return values[input]; })
                .filter(function (val) {
                if (typeof val === 'string') {
                    return val.length > 0;
                }
                return val != null;
            });
            if (vals.length === 0) {
                return;
            }
            // Optional join if working with multiple values
            // Notice result is put into array so we can keep working with a list
            if (vals.length > 1 && m.join) {
                vals = [vals.join(m.join)];
            }
            // Apply configured transform function to values
            if (m.transform) {
                vals = applyTransform(vals, m.transform);
            }
            // Pipe value (must be a single object left) into child mappings along with results object to be appended to
            if ('pipe' in m && assertFormObject(vals[0]) && assertFormObject(results)) {
                mapValuesToSubmit(m.pipe, __assign(__assign({}, values), vals[0]), details, results);
                return;
            }
            // Map a single array of objects into new array for output to a single key.
            if ('map' in m && Array.isArray(vals[0])) {
                vals = [
                    vals[0].map(function (v) {
                        var _a;
                        // if inputs.length === 0 put v into an object and add key to inputs
                        // if outputs.length === 0 we need to handle that in appendAt
                        // send this all into mapValuesToSubmit
                        var maps = m.map;
                        var inputVal = v;
                        var rawInputKey = '_RAW_VAL_';
                        if (maps.length === 1 &&
                            maps[0].inputs &&
                            maps[0].inputs.length === 0) {
                            maps = [__assign(__assign({}, maps[0]), { inputs: [rawInputKey] })];
                            inputVal = (_a = {}, _a[rawInputKey] = v, _a);
                        }
                        return mapValuesToSubmit(maps, __assign(__assign({}, values), inputVal), details, {});
                    }),
                ];
            }
            // There should only be one value left, append it to results
            if ('output' in m) {
                if (vals.length > 1) {
                    console.error("Attempting to map more than one value to ".concat(m.output));
                }
                results = appendAt(results, m.output, vals[0]);
            }
        }
        else {
            // no input, add empty object
            results = appendAt(results, m.output, {});
        }
    });
    return results;
}
function filterUnusedValues(values, blocks, rules) {
    var output = {};
    walkBlocks(castDraft(blocks), function (block) {
        var render = block.id === 'step-contact-details' ? true : shouldRender(rules[block.id], values);
        if (values[block.id] != null && render) {
            output[block.id] = values[block.id];
        }
        return render;
    });
    // has to be outside since this is not a block
    if (values.csrnotes) {
        output.csrnotes = values.csrnotes;
    }
    return output;
}
/**
 * Appends a value to an object at the provided key path.
 *
 * Example: appendAt({}, ["parent", "child"], true)
 * Result: { parent: { child: true } }
 */
function appendAt(obj, keyPath, value) {
    var first = keyPath[0], rest = keyPath.slice(1);
    // No keys means we should return raw value
    if (!first) {
        return value;
    }
    // create empty object if needed
    if (!obj[first] && rest.length > 0) {
        obj[first] = {};
    }
    // if end of path set value or work remaining segment
    if (rest.length === 0) {
        obj[first] = value;
        return obj;
    }
    else if (assertFormObject(obj[first])) {
        appendAt(obj[first], rest, value);
        return obj;
    }
}
var transforms = (_a = {},
    _a[TransformFunc.JsonParse] = function (values) {
        return values.map(function (v) {
            if (typeof v !== 'string') {
                return v;
            }
            try {
                return JSON.parse(v);
            }
            catch (err) {
                console.error('Could not parse JSON in transform', v);
                return v;
            }
        });
    },
    _a[TransformFunc.Lowercase] = function (values) {
        return values.map(function (v) { return (typeof v === 'string' ? v.toLowerCase() : v); });
    },
    _a[TransformFunc.FormatDateString] = function (values) {
        return values.map(function (v) { return (typeof v === 'string' ? format(new Date(v), DATE_TIME_FORMAT) : v); });
    },
    _a[TransformFunc.FormatDollarString] = function (values) {
        return values.map(function (v) { return (typeof v === 'string' ? formatDollarToApiFormat(v) : v); });
    },
    _a[TransformFunc.FormatOrigin] = function (values) { return values.map(function (v) { return (v ? 'NetClaim' : ''); }); },
    _a[TransformFunc.ProcessDamagedHome] = function (values) {
        /**
         * This transforms 'damagedHome' from a string array to a single string and combines
         * the input if there are 2 inputs.
         * Expected Output:
         * 1) Interior damage
         * 2) Exterior damage
         * 3) Interior and Exterior damage
         * NOTE: DamagedHome comes as an array embedded in an array
         */
        if (values.length < 1) {
            return values;
        }
        var damagedHomeInput = values[0];
        // remove the inner array object and replace with the single string inside of the array
        if (damagedHomeInput.length === 1 && typeof damagedHomeInput[0] === 'string') {
            return [damagedHomeInput[0]];
        }
        /**
         * return the combined value directly because if we wanted to manipulate the input
         * to get the combined string, we would have to directly check for
         * 'Interior'/'Exterior since it could come in any order
         */
        if (damagedHomeInput.length === 2 &&
            typeof damagedHomeInput[0] === 'string' &&
            typeof damagedHomeInput[1] === 'string') {
            return ['Interior and Exterior damage'];
        }
        return values;
    },
    _a[TransformFunc.ProcessSmokeRemovalRequiredForStructure] = function (values) {
        if (values.length < 1) {
            return values;
        }
        var smokeDamageInput = values[0];
        if (smokeDamageInput.find(function (item) { return item === MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_STRUCTURE; })) {
            return [true];
        }
        return [false];
    },
    _a[TransformFunc.ProcessSmokeRemovalRequiredForPersonalProperty] = function (values) {
        if (values.length < 1) {
            return values;
        }
        var smokeDamageInput = values[0];
        if (smokeDamageInput.find(function (item) { return item === MITIGATION_VALUE_SMOKE_REMOVAL_REQUIRED_FOR_PERSONAL_PROPERTY; })) {
            return [true];
        }
        return [false];
    },
    _a);
function applyTransform(values, func) {
    return transforms[func](values);
}
function assertFormObject(obj) {
    return obj === Object(obj) && !Array.isArray(obj);
}

function carrierCheckBody(policyId, source, lossDate) {
    return {
        version: 1,
        flags: { stubs: false },
        fnolBlocked: {
            policyId: policyId,
            source: source,
            lossDate: lossDate,
        },
    };
}
function submitFnolBody(fnolsubmit) {
    return {
        version: 1,
        flags: { stubs: false },
        fnolsubmit: fnolsubmit,
    };
}
// this is a legacy function
// this is kept as a safety if current mappings aren't there
// see submit-map.ts for current mapping
function submitBody(values, policy, source, pendingNumber, allowDuplicate) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    if (allowDuplicate === void 0) { allowDuplicate = false; }
    var DateOfLoss = format(new Date("".concat(values.lossDate, " ").concat((_a = values.lossTime) !== null && _a !== void 0 ? _a : '')), DATE_TIME_FORMAT);
    var LossAtInsuredProperty = values.atInsuredAddress;
    var LocationOfLoss = {};
    if (!LossAtInsuredProperty) {
        LocationOfLoss.Address = values.lossLocationAddress;
        LocationOfLoss.City = values.lossLocationCity;
        LocationOfLoss.State = values.lossLocationState;
        LocationOfLoss.Zip = values.lossLocationZip;
    }
    var ClaimSubmittedByPolicyholder = values.submitByPolicyholder;
    var ClaimSubmittedBy = {};
    if (!ClaimSubmittedByPolicyholder) {
        ClaimSubmittedBy.Name = values.submitByName;
        ClaimSubmittedBy.Relationship = values.submitByRelationship;
        ClaimSubmittedBy.PrimaryPhoneNumber = values.submitByPrimaryPhone;
        ClaimSubmittedBy.PrimaryPhoneNumberType = values.submitByPrimaryPhoneType;
        ClaimSubmittedBy.AlternatePhoneNumber = values.submitByAltPhone;
        ClaimSubmittedBy.AlternatePhoneNumberType = values.submitByAltPhoneType;
    }
    if (values.submitByOtherRelationship) {
        ClaimSubmittedBy.OtherRelationship = values.submitByOtherRelationship;
    }
    var ContactInfo = {
        Name: values.contactName,
        Relationship: values.contactRelationship,
        Email: values.contactEmail,
        PrimaryPhoneNumber: values.contactPrimaryPhone,
        PrimaryPhoneNumberType: values.contactPrimaryPhoneType,
        AlternatePhoneNumber: (_b = values.contactAddPhone) !== null && _b !== void 0 ? _b : '',
        AlternatePhoneNumberType: (_c = values.contactAddPhoneType) !== null && _c !== void 0 ? _c : '',
        WantsToReceiveSMSUpdates: (values.contactPrimaryPhoneType === 'mobile' || values.contactAddPhoneType === 'mobile') &&
            values.contactWantsSms,
    };
    if (values.timeToCall) {
        ContactInfo.TimeToCall = values.timeToCall;
    }
    if (values.contactOtherRelationship) {
        ContactInfo.OtherRelationship = values.contactOtherRelationship;
    }
    var body = {
        version: 1,
        flags: { stubs: false },
        fnolsubmit: {
            policyId: policy.policyId,
            pendingNumber: pendingNumber,
            DateOfLoss: DateOfLoss,
            LossAtInsuredProperty: LossAtInsuredProperty,
            LocationOfLoss: LocationOfLoss,
            TypeOfLoss: values.lossType,
            LossDescription: values.lossDescription,
            ClaimSubmittedByPolicyholder: ClaimSubmittedByPolicyholder,
            ClaimSubmittedBy: ClaimSubmittedBy,
            ContactInfo: ContactInfo,
            Source: source,
            DuplicateOverride: allowDuplicate,
        },
    };
    switch (values.lossType) {
        case 'Earthquake or ground movement':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeEarthquake;
            break;
        case 'Fire':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeFire;
            break;
        case 'Freezing':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeFreezing;
            break;
        case 'Physical injury':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeInjury;
            break;
        case 'Other':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeOther;
            break;
        case 'Wind / Hail / Hurricane / Storm':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeStorm;
            if (values.neighborStormDamage) {
                body.fnolsubmit.StormDamage = {
                    NeighborStormDamage: values.neighborStormDamage,
                };
            }
            break;
        case 'Theft or mysterious disappearance':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeTheft;
            break;
        case 'Water':
            body.fnolsubmit.SubtypeOfLoss = values.lossSubTypeWater;
            break;
    }
    if (values.resultInFire) {
        body.fnolsubmit.LossStartFire = values.resultInFire;
    }
    if (values.lossSubTypeDamagedPropertyOwner) {
        body.fnolsubmit.DamagedPropertyOwner = values.lossSubTypeDamagedPropertyOwner;
    }
    if (values.damaged && values.damaged.length > 0) {
        body.fnolsubmit.Damage = values.damaged;
    }
    if (values.damagedExterior ||
        values.damagedFloors ||
        values.damagedRooms ||
        values.damageInteriorAtHome ||
        values.livingAtHome ||
        values.currencyDamaged ||
        values.propertyScheduled) {
        body.fnolsubmit.HomeDamage = {
            ExteriorDamage: values.damagedExterior || [],
            FloorsDamage: values.damagedFloors || [],
            RoomsDamage: values.damagedRooms || [],
            AtHomeDamage: values.damageInteriorAtHome,
            HomeLocationDamage: (_d = values.damagedHome) !== null && _d !== void 0 ? _d : '',
        };
        if (values.livingAtHome) {
            body.fnolsubmit.HomeDamage.LivingAtLocationDamage = values.livingAtHome;
        }
        if (values.currencyDamaged) {
            body.fnolsubmit.HomeDamage.CurrencyDamage = values.currencyDamaged;
        }
        if (values.propertyScheduled) {
            body.fnolsubmit.HomeDamage.ScheduledPropertyDamage = values.propertyScheduled;
        }
    }
    if (values.stolenPropertyOwner || values.stolenDescription) {
        body.fnolsubmit.Theft = {
            TheftDescription: (_e = values.stolenDescription) !== null && _e !== void 0 ? _e : '',
            StolenPropertyOwner: (_f = values.stolenPropertyOwner) !== null && _f !== void 0 ? _f : '',
        };
    }
    if (values.ownAllStolenProperty) {
        body.fnolsubmit.Theft.OwnAllStolenProperty = values.ownAllStolenProperty;
    }
    if (values.waterDamageSourceLocation || values.waterDamageTimePeriod) {
        body.fnolsubmit.WaterDamage = {
            WaterDamageLocation: (_g = values.waterDamageSourceLocation) !== null && _g !== void 0 ? _g : '',
            WaterDamageType: (_h = values.waterDamageTimePeriod) !== null && _h !== void 0 ? _h : '',
        };
        switch (values.lossSubTypeWater) {
            case 'Water backup or drainage issue':
                body.fnolsubmit.WaterDamage.WaterDamageSource = values.waterDamageSourceBackup;
                break;
            case 'Appliance or fixture malfunction':
                body.fnolsubmit.WaterDamage.WaterDamageSource = values.waterDamageSourceAppliance;
                break;
        }
    }
    if (values.knowFireCause ||
        values.fireSource ||
        values.fireSourceAppliance ||
        values.fireStartLocation) {
        body.fnolsubmit.FireDamage = {
            FireKnownCause: values.knowFireCause,
            FireSource: (_j = values.fireSource) !== null && _j !== void 0 ? _j : '',
            FireSourceAppliance: (_k = values.fireSourceAppliance) !== null && _k !== void 0 ? _k : '',
            FireStartLocation: (_l = values.fireStartLocation) !== null && _l !== void 0 ? _l : '',
            FireFoundBy: (_m = values.fireDiscovery) !== null && _m !== void 0 ? _m : '',
        };
    }
    if (values.injuredPersons || values.injuryProfessional) {
        body.fnolsubmit.Injury = {
            InjuredPersons: [(_o = values.injuredPersons) !== null && _o !== void 0 ? _o : ''],
            InjuredProfessional: values.injuryProfessional,
            ReasonOnPremises: (_p = values.reasonOnPremises) !== null && _p !== void 0 ? _p : '',
        };
        if (values.injuryDogOwner) {
            body.fnolsubmit.Injury.DogOwner = values.injuryDogOwner;
        }
        if (values.dogBreed) {
            body.fnolsubmit.Injury.DogBreed = values.dogBreed;
        }
    }
    if (values.withoutElectricityOrWater ||
        values.habitable ||
        values.standingWater ||
        values.uncoveredHoles ||
        values.debrisRemovalRequired) {
        body.fnolsubmit.Habitability = {
            WithoutElectricityOrWater: values.withoutElectricityOrWater,
            Habitable: values.habitable,
            StandingWater: values.standingWater,
            UncoveredHoles: values.uncoveredHoles,
            DebrisRemovalRequired: values.debrisRemovalRequired,
        };
    }
    if (values.repairOrMitigationProgress) {
        body.fnolsubmit.RepairOrMitigation = {
            RepairOrMitigationProgress: (_q = values.repairOrMitigationProgress) !== null && _q !== void 0 ? _q : '',
            EstimateProvider: (_r = values.estimateProvider) !== null && _r !== void 0 ? _r : '',
            EstimateAmount: values.estimateAmount
                ? formatDollarToApiFormat(values.estimateAmount)
                : '',
            RepairProvider: (_s = values.repairProvider) !== null && _s !== void 0 ? _s : '',
            RepairAmountPaid: values.repairAmountPaid
                ? formatDollarToApiFormat(values.repairAmountPaid)
                : '',
        };
    }
    if (values.policeOrFireDeptContacted) {
        body.fnolsubmit.PoliceOrFireDeptContacted = values.policeOrFireDeptContacted;
        body.fnolsubmit.PoliceOrFireDept = {
            PoliceOrFireDeptName: (_t = values.policeOrFireDeptName) !== null && _t !== void 0 ? _t : '',
            PoliceOrFireReportNum: (_u = values.policeOrFireReportNum) !== null && _u !== void 0 ? _u : '',
        };
    }
    if (values.csrnotes) {
        body.fnolsubmit.CsrNotes = (_v = values.csrnotes) !== null && _v !== void 0 ? _v : '';
    }
    if (values.thirdParty) {
        body.fnolsubmit.ThirdPartyResponsible = values.thirdParty;
        if (values.thirdParty === 'yes') {
            body.fnolsubmit.ThirdPartyName = values.thirdPartyName;
        }
    }
    if (values.anyWitness) {
        body.fnolsubmit.AnyWitness = values.anyWitness;
        if (values.anyWitness === 'yes') {
            body.fnolsubmit.Witnesses = values.witnesses;
        }
    }
    return body;
}
function existsBody(policyId, lossDate) {
    var date = format(new Date(lossDate), DATE_TIME_FORMAT);
    return {
        version: 1,
        flags: { stubs: false },
        fnolexists: {
            insightPolicyId: policyId,
            date: date,
        },
    };
}
function policyTermBody(policyId, lossDate) {
    var date = format(new Date(lossDate), DATE_YEAR_MONTH_DAY_FORMAT);
    return {
        version: 1,
        flags: { stubs: false },
        withinPolicyEffectiveRange: {
            policyId: policyId,
            lossDate: date,
        },
    };
}
function catBody(lossDate, state, lossCarrierType, policyId, lossType) {
    var date = new Date(lossDate);
    var startDate = format(addDays(date, -2), DATE_YEAR_MONTH_DAY_FORMAT);
    var endDate = format(addDays(date, 2), DATE_YEAR_MONTH_DAY_FORMAT);
    return {
        version: 1,
        flags: { stubs: false },
        cat: {
            startDate: startDate,
            endDate: endDate,
            state: state,
            lossCarrierType: lossCarrierType,
            policyId: policyId,
            lossType: lossType !== null && lossType !== void 0 ? lossType : '',
        },
    };
}
function fileUploadCreateBody(file, policy, pendingClaimNumber) {
    var _a, _b;
    return {
        version: 1,
        flags: {
            stub: false,
        },
        attachmentCreate: {
            meta: {
                id: file.id,
                policyId: policy.policyId,
                pendingNumber: pendingClaimNumber,
                filename: file.name,
                description: (_a = file.caption) !== null && _a !== void 0 ? _a : '',
                category: file.category,
                contentType: file.type,
                contentEncodingScheme: file.encodingScheme,
                size: file.size,
                createdBy: policy.fullName,
                createdDate: format(new Date(), DATE_MONTH_DAY_YEAR_FORMAT),
            },
            content: (_b = file.dataUrl) === null || _b === void 0 ? void 0 : _b.toString().replace('data:', '').replace(/^.+,/, ''),
        },
    };
}
function fileUploadDeleteBody(file, policy, pendingClaimNumber) {
    return {
        version: 1,
        flags: {
            stub: false,
        },
        attachmentDelete: {
            id: file.id,
            policyId: policy.policyId,
            pendingNumber: pendingClaimNumber,
        },
    };
}
function getAttachment(attachment) {
    return {
        version: 1,
        attachmentGet: {
            id: attachment.id,
            insightPolicyId: attachment.insightPolicyId,
            pendingNumber: attachment.pendingNumber,
        },
    };
}
function generatePendingFnolBody() {
    return {
        version: 1,
        generatePendingFnol: {},
    };
}
function generateSubmitDraftBody(values, state, exitReasons, user, source, draft) {
    var _a;
    var subLossKey = getLossSubTypeKey(values);
    var subLossType = values[subLossKey] || '';
    var draftFnolJson = mapValuesToSubmit(state.definition.mappings, values, {
        allowDuplicate: state.source !== 'MySageSure.com',
        policyId: state.policy.policyId,
        pendingNumber: state.pendingClaimNumber,
        source: state.source,
    });
    // since InjuredPersons is a repeat field if the person injured field is available
    // and not filled out it, it will have an empty object. Replace with empty array
    if (draftFnolJson.Injury !== undefined &&
        Object.keys((_a = draftFnolJson.Injury) === null || _a === void 0 ? void 0 : _a.InjuredPersons[0]).length === 0) {
        draftFnolJson.Injury.InjuredPersons = [];
    }
    var payload = {
        previousDraftFnolId: (draft === null || draft === void 0 ? void 0 : draft.draftFnolId) || null,
        draftFnolNumber: (draft === null || draft === void 0 ? void 0 : draft.draftFnolNumber) || null,
        policyId: state.policy.policyId,
        insightPolicyId: state.policy.policyId,
        lossDt: draftFnolJson.DateOfLoss,
        lossType: values.lossType,
        lossSubType: subLossType,
        draftSourceCode: source,
        createdUser: user,
        exitReasons: [exitReasons],
        draftFnolJson: draftFnolJson,
    };
    if (source === 'IPC Manager') {
        return {
            version: 1,
            saveFnolDraft: payload,
        };
    }
    else {
        return {
            version: 1,
            saveFnolDraftWithResponse: payload,
        };
    }
}
function consultativeFnolBody(policyId, source) {
    return {
        version: 1,
        consultativeFnolForm: {
            policyId: policyId,
            source: source,
        },
    };
}
function deductiblesBody(policyId, lossDate, lossType, subLossType) {
    return {
        version: 1,
        consultativeFnolPolicy: {
            policyId: policyId,
            dateOfLoss: format(new Date(lossDate), DATE_YEAR_MONTH_DAY_FORMAT),
            typeOfLoss: lossType,
            subtypeOfLoss: subLossType,
        },
    };
}
var lossSubTypeKeys = [
    'lossSubTypeDamagedPropertyOwner',
    'lossSubTypeEarthquake',
    'lossSubTypeFire',
    'lossSubTypeFreezing',
    'lossSubTypeInjury',
    'lossSubTypeOther',
    'lossSubTypeStorm',
    'lossSubTypeTheft',
    'lossSubTypeWater',
];
// All of the loss subtypes are prefixed like: "lossSubTypeWater".
// There is no single variable for the loss sub type.
// This function returns the subloss type key we need to pass the value to the duplicate claim queries.
function getLossSubTypeKey(formValues) {
    var k = '';
    lossSubTypeKeys.forEach(function (subType) {
        if (formValues[subType]) {
            k = subType;
        }
    });
    return k;
}
function mitigationBody(body) {
    return {
        version: 1,
        fnolPreCheck: body,
    };
}

var StyledFormContent = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  ", "\n  align-items: flex-start;\n  justify-content: center;\n  display: flex;\n  flex-flow: row wrap;\n  ", ";\n  min-height: 85vh;\n  width: 100vw;\n  background: ", ";\n\n  p {\n    width: 50vw;\n    margin: 32px 0px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    text-align: left;\n    max-width: 624px;\n  }\n\n  span[class*='ph-error-message__StyledError'] {\n    text-align: left;\n  }\n\n  h4 {\n    margin: 32px 0px;\n    ", ";\n    font-size: 32px;\n    line-height: 42px;\n    text-align: center;\n  }\n\n  @media (max-height: 800px) {\n    min-height: 120vh;\n  }\n\n  @media (max-width: ", ") {\n    min-height: 100vh;\n    padding: 0px;\n    background: ", ";\n    border: none;\n    box-shadow: none;\n    width: 100%;\n\n    p {\n      width: 100%;\n    }\n\n    h4 {\n      font-size: 28px;\n      line-height: 36px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    h4 {\n      font-size: 24px;\n      line-height: 32px;\n    }\n  }\n"], ["\n  ", "\n  align-items: flex-start;\n  justify-content: center;\n  display: flex;\n  flex-flow: row wrap;\n  ", ";\n  min-height: 85vh;\n  width: 100vw;\n  background: ", ";\n\n  p {\n    width: 50vw;\n    margin: 32px 0px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    text-align: left;\n    max-width: 624px;\n  }\n\n  span[class*='ph-error-message__StyledError'] {\n    text-align: left;\n  }\n\n  h4 {\n    margin: 32px 0px;\n    ", ";\n    font-size: 32px;\n    line-height: 42px;\n    text-align: center;\n  }\n\n  @media (max-height: 800px) {\n    min-height: 120vh;\n  }\n\n  @media (max-width: ", ") {\n    min-height: 100vh;\n    padding: 0px;\n    background: ", ";\n    border: none;\n    box-shadow: none;\n    width: 100%;\n\n    p {\n      width: 100%;\n    }\n\n    h4 {\n      font-size: 28px;\n      line-height: 36px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    h4 {\n      font-size: 24px;\n      line-height: 32px;\n    }\n  }\n"])), wrapper, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledFormSectionContainer = styled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  margin-top: 80px;\n  text-align: center;\n\n  @media (max-width: ", ") {\n    margin: 80px 0 auto;\n  }\n  @media (max-width: ", ") {\n    margin-top: 32px;\n  }\n"], ["\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  margin-top: 80px;\n  text-align: center;\n\n  @media (max-width: ", ") {\n    margin: 80px 0 auto;\n  }\n  @media (max-width: ", ") {\n    margin-top: 32px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledFormBlockContainer = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 48px;\n\n  &.preventMarginStyling {\n    margin-bottom: 0px;\n  }\n\n  @media (max-width: ", ") {\n    padding: 0px 24px;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: 0px 24px;\n    margin-bottom: 75px;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: 0px 12px;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 48px;\n\n  &.preventMarginStyling {\n    margin-bottom: 0px;\n  }\n\n  @media (max-width: ", ") {\n    padding: 0px 24px;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: 0px 24px;\n    margin-bottom: 75px;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n    padding: 0px 12px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledHeadingContainer = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  min-width: 624px;\n  display: flex;\n  justify-content: center;\n  text-wrap: pretty;\n\n  .formStepHeader {\n    max-width: 624px;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 42px;\n    margin: 0 0 24px;\n    min-width: 624px;\n    text-align: left;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n    margin: 0 auto;\n    margin-bottom: 32px;\n    max-width: 624px;\n    min-width: unset;\n\n    .formStepHeader {\n      margin: 0 auto;\n      min-width: unset;\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .formStepHeader {\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: min-content;\n    word-break: break-word;\n\n    .formStepHeader {\n      font-size: 24px;\n    }\n  }\n"], ["\n  min-width: 624px;\n  display: flex;\n  justify-content: center;\n  text-wrap: pretty;\n\n  .formStepHeader {\n    max-width: 624px;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 42px;\n    margin: 0 0 24px;\n    min-width: 624px;\n    text-align: left;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n    margin: 0 auto;\n    margin-bottom: 32px;\n    max-width: 624px;\n    min-width: unset;\n\n    .formStepHeader {\n      margin: 0 auto;\n      min-width: unset;\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .formStepHeader {\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: min-content;\n    word-break: break-word;\n\n    .formStepHeader {\n      font-size: 24px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$y, templateObject_2$n, templateObject_3$d, templateObject_4$b;

var StyledMessage = styled.div(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  max-width: 624px;\n  width: 90vw;\n\n  p {\n    margin-top: 0;\n    margin-bottom: 10px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  ul {\n    padding-left: 20px;\n    margin: 0;\n    margin-bottom: 10px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  li {\n    margin-top: 8px;\n  }\n\n  .messageHeader {\n    font-size: 32px;\n    margin: 0 0 24px;\n    font-weight: 500;\n    line-height: 36px;\n    text-align: left;\n    text-wrap: pretty;\n  }\n\n  .messageBody {\n    display: flex;\n    flex-flow: column wrap;\n    max-width: 624px;\n\n    p {\n      text-align: left;\n      margin: 10px 0;\n      max-width: 624px;\n    }\n  }\n\n  .hasAdditionalStyling {\n    background: #f3f5f7;\n    border-radius: 12px;\n    padding: 32px;\n    margin: 0 auto;\n    text-align: left;\n\n    p {\n      font-weight: 500;\n      width: 90vw;\n      max-width: 624px;\n      margin: 0;\n    }\n\n    ul {\n      padding-left: 0 !important;\n    }\n  }\n\n  .isMitigationDeclineText {\n    text-align: left;\n    max-width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    .messageBody {\n      p {\n        width: 90vw !important;\n      }\n    }\n\n    .hasAdditionalStyling {\n      width: 90vw;\n\n      p {\n        width: auto !important;\n        min-width: auto;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    .messageHeader {\n      font-size: 28px;\n      margin: 0 0 32px;\n    }\n    .hasAdditionalStyling {\n      p {\n        width: auto !important;\n        min-width: auto;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    .messageHeader {\n      word-break: break-word;\n      font-size: 24px;\n    }\n\n    .hasAdditionalStyling {\n      width: 90vw;\n      // padding-left: 24px;\n\n      p {\n        word-break: break-word;\n      }\n    }\n  }\n"], ["\n  max-width: 624px;\n  width: 90vw;\n\n  p {\n    margin-top: 0;\n    margin-bottom: 10px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  ul {\n    padding-left: 20px;\n    margin: 0;\n    margin-bottom: 10px;\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  li {\n    margin-top: 8px;\n  }\n\n  .messageHeader {\n    font-size: 32px;\n    margin: 0 0 24px;\n    font-weight: 500;\n    line-height: 36px;\n    text-align: left;\n    text-wrap: pretty;\n  }\n\n  .messageBody {\n    display: flex;\n    flex-flow: column wrap;\n    max-width: 624px;\n\n    p {\n      text-align: left;\n      margin: 10px 0;\n      max-width: 624px;\n    }\n  }\n\n  .hasAdditionalStyling {\n    background: #f3f5f7;\n    border-radius: 12px;\n    padding: 32px;\n    margin: 0 auto;\n    text-align: left;\n\n    p {\n      font-weight: 500;\n      width: 90vw;\n      max-width: 624px;\n      margin: 0;\n    }\n\n    ul {\n      padding-left: 0 !important;\n    }\n  }\n\n  .isMitigationDeclineText {\n    text-align: left;\n    max-width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    .messageBody {\n      p {\n        width: 90vw !important;\n      }\n    }\n\n    .hasAdditionalStyling {\n      width: 90vw;\n\n      p {\n        width: auto !important;\n        min-width: auto;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    .messageHeader {\n      font-size: 28px;\n      margin: 0 0 32px;\n    }\n    .hasAdditionalStyling {\n      p {\n        width: auto !important;\n        min-width: auto;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    .messageHeader {\n      word-break: break-word;\n      font-size: 24px;\n    }\n\n    .hasAdditionalStyling {\n      width: 90vw;\n      // padding-left: 24px;\n\n      p {\n        word-break: break-word;\n      }\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledWarningContainer = styled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  width: 100%;\n  background: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  padding: 8px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 8px;\n  }\n"], ["\n  width: 100%;\n  background: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  padding: 8px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 8px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.warningLight;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.warning;
});
var templateObject_1$x, templateObject_2$m;

var DuplicateClaim = function (_a) {
    var _b;
    var id = _a.id, lossDate = _a.lossDate, policyId = _a.policyId, placeholder = _a.placeholder, duplicatesFound = _a.duplicatesFound, action = _a.action;
    var formik = useFormikContext();
    var _c = useFnolData(), sendPost = _c.sendPost, setQuery = _c.setQuery, queries = _c.queries, location = _c.location;
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), showLoadingIndicator = _e[0], setShowLoadingIndicator = _e[1];
    var query = queries[id];
    var queryDep = (_b = query === null || query === void 0 ? void 0 : query.dependencies) === null || _b === void 0 ? void 0 : _b.lossDate;
    var continueCurrentClaim = function () {
        formik.setFieldValue(id, true);
    };
    useEffect(function () {
        var timeId = setTimeout(function () { return setShowLoadingIndicator(true); }, 500);
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, sendPost(existsBody(policyId, lossDate))];
                    case 1:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[id] = {
                                location: location,
                                dependencies: { lossDate: lossDate },
                                result: res.existingFnols,
                            },
                            _a));
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        // proceed despite server error
                        console.error('Query Error', err_1);
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        action(formik.values);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (queryDep !== lossDate) {
            sendQuery();
        }
        if (query && queryDep === lossDate && !query.result) {
            // No duplicates, proceed
            action(formik.values);
            formik.setFieldValue(id, true);
        }
        else {
            formik.setFieldValue(id, false);
        }
        // We only want this effect to run when loss date changes. Other deps were
        // triggering multiple calls.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lossDate, queryDep]);
    if (loading) {
        return placeholder({ showLoadingIndicator: showLoadingIndicator });
    }
    if (query && query.result && query.result.length > 0) {
        return duplicatesFound({
            duplicates: query.result,
            values: formik.values,
            continueCurrentClaim: continueCurrentClaim,
        });
    }
    return null;
};

var Placeholder$3 = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"])));
var Details = styled.ul(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n\n  ul {\n    padding-left: 0px;\n  }\n\n  > li {\n    margin-bottom: 5px;\n  }\n"], ["\n  list-style-type: none;\n  padding: 0;\n\n  ul {\n    padding-left: 0px;\n  }\n\n  > li {\n    margin-bottom: 5px;\n  }\n"])));
function formatDate$2(input) {
    if (!input || input.length < 10) {
        return '';
    }
    return format(new Date(input.slice(0, 10)), 'MMM d, yyyy');
}
var PHDuplicateClaim = function (_a) {
    var id = _a.id, lossDate = _a.lossDate, policyId = _a.policyId;
    var nextStep = useFnolData().nextStep;
    return (React.createElement(DuplicateClaim, { id: id, lossDate: lossDate, policyId: policyId, placeholder: function (_a) {
            var showLoadingIndicator = _a.showLoadingIndicator;
            return (React.createElement(Placeholder$3, null, showLoadingIndicator && React.createElement(Spinner, null)));
        }, duplicatesFound: function (_a) {
            var duplicates = _a.duplicates;
            return (React.createElement(StyledMessage, { "data-testid": "policy-term" },
                React.createElement(StyledHeadingContainer, null,
                    React.createElement(Heading, { className: "formStepHeader", size: "md" },
                        "We already received a claim for a loss that occurred on",
                        ' ',
                        formatDate$2(duplicates[0].dateOfLoss),
                        ".")),
                React.createElement("div", { className: classNames({
                        messageBody: true,
                        hasAdditionalStyling: true,
                    }) },
                    React.createElement(Details, null,
                        React.createElement(React.Fragment, null, (function () {
                            if (duplicates[0].claimNumber && duplicates[0].claimNumber != '') {
                                return (React.createElement("li", null,
                                    "Claim Number: ",
                                    React.createElement("strong", null, duplicates[0].claimNumber)));
                            }
                            else if (duplicates[0].fnolSubmissionNumber) {
                                return (React.createElement("li", null,
                                    "Submission Number: ",
                                    React.createElement("strong", null, duplicates[0].fnolSubmissionNumber)));
                            }
                        })()),
                        duplicates[0].claimStatus && (React.createElement("li", null,
                            "Claim Status: ",
                            React.createElement("strong", null, duplicates[0].claimStatus))),
                        duplicates[0].submittedBy && (React.createElement("li", null,
                            "Submitted by: ",
                            React.createElement("strong", null, duplicates[0].submittedBy))),
                        React.createElement("li", null,
                            "Submitted on: ",
                            React.createElement("strong", null, formatDate$2(duplicates[0].submittedOn)))),
                    "If the details above are unrelated to the claim you are trying to submit, please contact us at (866) 311-7243 for assistance.")));
        }, action: function (values) { return nextStep(values); } }));
};
var templateObject_1$w, templateObject_2$l;

var PolicyTerm = function (_a) {
    var _b;
    var id = _a.id, lossDate = _a.lossDate, policyId = _a.policyId, placeholder = _a.placeholder, outsidePolicyTermFound = _a.outsidePolicyTermFound, action = _a.action;
    var formik = useFormikContext();
    var _c = useFnolData(), sendPost = _c.sendPost, setQuery = _c.setQuery, queries = _c.queries, location = _c.location;
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), showLoadingIndicator = _e[0], setShowLoadingIndicator = _e[1];
    var query = queries[id];
    var queryDep = (_b = query === null || query === void 0 ? void 0 : query.dependencies) === null || _b === void 0 ? void 0 : _b.lossDate;
    var continueCurrentClaim = function () {
        formik.setFieldValue(id, true);
    };
    useEffect(function () {
        var timeId = setTimeout(function () { return setShowLoadingIndicator(true); }, 500);
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, sendPost(policyTermBody(policyId, lossDate))];
                    case 1:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[id] = {
                                location: location,
                                dependencies: { lossDate: lossDate },
                                result: res,
                            },
                            _a));
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        // proceed despite server error
                        console.error('Query Error', err_1);
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        action(formik.values);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (queryDep !== lossDate) {
            sendQuery();
        }
        if (query && queryDep === lossDate && query.result.withinPolicyEffectiveRange === 'Yes') {
            // With the policy term, proceed
            action(formik.values);
            formik.setFieldValue(id, true);
        }
        else {
            formik.setFieldValue(id, false);
        }
        // We only want this effect to run when loss date changes. Other deps were
        // triggering multiple calls.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lossDate, queryDep]);
    if (loading) {
        return placeholder({ showLoadingIndicator: showLoadingIndicator });
    }
    if (query && query.result && query.result.withinPolicyEffectiveRange === 'No') {
        return outsidePolicyTermFound({
            outsidePolicyTerm: query.result,
            values: formik.values,
            continueCurrentClaim: continueCurrentClaim,
        });
    }
    return null;
};

var Placeholder$2 = styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"])));
var PolicyEffectiveDate = styled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  align-items: left;\n  display: flex;\n  margin-bottom: 24px;\n  text-align: left;\n"], ["\n  align-items: left;\n  display: flex;\n  margin-bottom: 24px;\n  text-align: left;\n"])));
var FooterSection = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  align-items: left;\n  display: flex;\n  margin-top: 24px;\n  text-align: left;\n"], ["\n  align-items: left;\n  display: flex;\n  margin-top: 24px;\n  text-align: left;\n"])));
function formatDate$1(input) {
    if (!input || input.length < 10) {
        return '';
    }
    return format(new Date(input.slice(0, 10)), 'MMM d, yyyy');
}
function formatPolicyDate(input) {
    return format(new Date(input), 'MMM d, yyyy');
}
var PHPolicyTerm = function (_a) {
    var id = _a.id, lossDate = _a.lossDate, policyId = _a.policyId, policyEffectiveDate = _a.policyEffectiveDate, policyExpirationDate = _a.policyExpirationDate;
    var nextStep = useFnolData().nextStep;
    return (React.createElement(PolicyTerm, { id: id, lossDate: lossDate, policyId: policyId, placeholder: function (_a) {
            var showLoadingIndicator = _a.showLoadingIndicator;
            return (React.createElement(Placeholder$2, null, showLoadingIndicator && React.createElement(Spinner, null)));
        }, outsidePolicyTermFound: function () { return (React.createElement(StyledMessage, { "data-testid": "policy-term" },
            React.createElement(StyledHeadingContainer, null,
                React.createElement(Heading, { className: "formStepHeader", size: "md" }, "We're unable to use that policy")),
            React.createElement(PolicyEffectiveDate, null,
                "Policy\u00A0",
                React.createElement(Span, { bold: true }, policyId),
                "\u00A0was not in effect on",
                ' ',
                formatDate$1(lossDate),
                ":"),
            React.createElement("div", { className: classNames({
                    messageBody: true,
                    hasAdditionalStyling: true,
                }) },
                React.createElement(Metric, { label: 'Effective dates', value: "".concat(formatPolicyDate(policyEffectiveDate), " - ").concat(formatPolicyDate(policyExpirationDate)) })),
            React.createElement(FooterSection, null,
                React.createElement(Span, { color: "quiet" },
                    React.createElement(Span, { bold: true }, "Do you have another policy that was in effect on this date?"),
                    " You can switch policies on the",
                    ' ',
                    React.createElement(Link, { href: "https://my.sagesure.com/my/overview" }, "policy overview page"),
                    ". Contact us at\u00A0",
                    React.createElement(Link, { href: 'tel:(866)311-7243' }, "(866) 311-7243"),
                    "\u00A0for assistance.")))); }, action: function (values) { return nextStep(values); } }));
};
var templateObject_1$v, templateObject_2$k, templateObject_3$c;

var Files = styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-flow: row wrap;\n  gap: ", ";\n  justify-content: ", ";\n  margin-bottom: ", ";\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-flow: row wrap;\n  gap: ", ";\n  justify-content: ", ";\n  margin-bottom: ", ";\n  width: 100%;\n"])), function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '8px' : '0');
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? 'flex-start' : 'space-between');
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '24px' : '');
});
var File$1 = styled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  position: relative;\n  height: ", ";\n  width: ", ";\n\n  @media (max-width: ", ") {\n    width: 48%;\n  }\n"], ["\n  position: relative;\n  height: ", ";\n  width: ", ";\n\n  @media (max-width: ", ") {\n    width: 48%;\n  }\n"])), function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '140px' : 'auto');
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '24%' : '48%');
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var PlaceholderFile = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  justify-content: center;\n  flex-direction: column;\n  display: flex;\n\n  position: relative;\n  height: 192px;\n  width: 48%;\n  margin-bottom: 78px;\n\n  @media (max-width: ", ") {\n    width: 48%;\n  }\n"], ["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  justify-content: center;\n  flex-direction: column;\n  display: flex;\n\n  position: relative;\n  height: 192px;\n  width: 48%;\n  margin-bottom: 78px;\n\n  @media (max-width: ", ") {\n    width: 48%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.border.neutralDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var LoadingState = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  text-align: center;\n\n  p {\n    color: ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0px 32px;\n  }\n"], ["\n  text-align: center;\n\n  p {\n    color: ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0px 32px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
});
var Wrap = styled.button(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  border-radius: 4px;\n  border: 1px solid ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  ", "\n  @media (max-width: ", ") {\n    height: 113px;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border-radius: 4px;\n  border: 1px solid ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  ", "\n  @media (max-width: ", ") {\n    height: 113px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.canvas;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.canvas;
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '100px' : '192px');
}, function (_a) {
    var editDisabled = _a.editDisabled, theme = _a.theme;
    return !editDisabled &&
        "\n      &:hover {\n        cursor: pointer;\n\n        &::after {\n          content: \"\";\n          height: 100%;\n          width: 100%;\n          background: ".concat(theme.colors.purpleHaze, ";\n          position: absolute;\n        }\n      }\n  ");
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var DismissBtn = styled.button(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  && {\n    position: static;\n    width: 57px;\n    height: 24px;\n    font-size: 12px;\n    margin: 0px 10px;\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  && {\n    position: static;\n    width: 57px;\n    height: 24px;\n    font-size: 12px;\n    margin: 0px 10px;\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.border.neutralDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
});
var ErrorState = styled.div(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  text-align: center;\n\n  && p {\n    color: ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0px 32px;\n    padding-bottom: 16px;\n  }\n"], ["\n  text-align: center;\n\n  && p {\n    color: ", ";\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0px 32px;\n    padding-bottom: 16px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.danger;
});
var RemoveFile = styled.div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  z-index: 1;\n\n  &:hover {\n    cursor: pointer;\n\n    .remove-icon {\n      fill: ", ";\n    }\n  }\n\n  @media (min-width: ", ") {\n    & > svg {\n      transform: scale(1.35);\n    }\n  }\n"], ["\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  z-index: 1;\n\n  &:hover {\n    cursor: pointer;\n\n    .remove-icon {\n      fill: ", ";\n    }\n  }\n\n  @media (min-width: ", ") {\n    & > svg {\n      transform: scale(1.35);\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.purpleHaze;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var DocumentIcon = styled(Icon)(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  height: 40px;\n  width: 40px;\n"], ["\n  height: 40px;\n  width: 40px;\n"])));
var FileName = styled.div(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  && {\n    background: ", ";\n    height: ", ";\n    bottom: 0px;\n    overflow: hidden;\n    padding: ", ";\n    position: absolute;\n    white-space: nowrap;\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n    p {\n      text-align: left;\n      margin: 0;\n      color: ", ";\n      font-size: ", ";\n      text-overflow: ellipsis;\n      width: 200px;\n      overflow: hidden;\n\n      @media (max-width: ", ") {\n        width: 100px;\n      }\n    }\n\n    span,\n    svg {\n      color: ", ";\n      position: absolute;\n      right: 9px;\n    }\n\n    @media (max-width: ", ") {\n      font-size: 12px;\n      padding: 0 8px;\n    }\n  }\n"], ["\n  && {\n    background: ", ";\n    height: ", ";\n    bottom: 0px;\n    overflow: hidden;\n    padding: ", ";\n    position: absolute;\n    white-space: nowrap;\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n    p {\n      text-align: left;\n      margin: 0;\n      color: ", ";\n      font-size: ", ";\n      text-overflow: ellipsis;\n      width: 200px;\n      overflow: hidden;\n\n      @media (max-width: ", ") {\n        width: 100px;\n      }\n    }\n\n    span,\n    svg {\n      color: ", ";\n      position: absolute;\n      right: 9px;\n    }\n\n    @media (max-width: ", ") {\n      font-size: 12px;\n      padding: 0 8px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grayHaze;
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '27px' : '40px');
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '0 8px' : '8px 16px');
}, function (_a) {
    var theme = _a.theme;
    return theme.text.inverse;
}, function (_a) {
    var editDisabled = _a.editDisabled;
    return (editDisabled ? '12px' : '16px');
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var ViewBtn = styled.span(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  && {\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    width: 42px;\n    height: 24px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 24px;\n  }\n"], ["\n  && {\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    width: 42px;\n    height: 24px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
});
var Image = styled.img(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n"], ["\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n"])));
var FileSelect = function (_a) {
    var editDisabled = _a.editDisabled, file = _a.file, format = _a.format, index = _a.index;
    return (React.createElement(React.Fragment, null, format[0] === 'image' && typeof file.dataUrl === 'string' && !format[1].match('hei(c|f)') ? (React.createElement(Image, { editDisabled: editDisabled, src: file.dataUrl, alt: "Damage documentation ".concat(index + 1) })) : format[1].match('hei(c|f)') ? (React.createElement("div", { style: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(DocumentIcon, { src: "assets/checkmark-icon.svg", label: "icon for image file" }),
        React.createElement("p", { style: { padding: '4px', width: '100%' } }, "Some iPhone photos won't show, but we got it."))) : format[1] === 'pdf' ? (React.createElement(DocumentIcon, { src: "assets/pdf-icon.svg", label: "icon to remove file from list" })) : (React.createElement(DocumentIcon, { src: "assets/document-icon.svg", label: "icon to remove file from list" }))));
};
var FileList = function (_a) {
    var list = _a.list, handleRemove = _a.handleRemove, _b = _a.editDisabled, editDisabled = _b === void 0 ? false : _b, _c = _a.disableModal, disableModal = _c === void 0 ? false : _c, block = _a.block;
    var _d = useState(''), showFileModal = _d[0], setShowFileModal = _d[1];
    var _e = useState(''), showDeleteModal = _e[0], setShowDeleteModal = _e[1];
    var sendPost = useFnolData().sendPost;
    var setFieldValue = useFormikContext().setFieldValue;
    useEffect(function () {
        if (list.every(function (item) { return item.dataUrl === null; })) {
            var withImages = list.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, sendPost(getAttachment(item))];
                        case 1:
                            res = _a.sent();
                            item.dataUrl = "data:".concat(item.type, ";base64,").concat(res.content);
                            return [2 /*return*/, item];
                    }
                });
            }); });
            Promise.all(withImages).then(function (items) { return setFieldValue(block.id, JSON.stringify(items)); });
        }
    }, [block.id, list, sendPost, setFieldValue]);
    return (React.createElement(Files, { editDisabled: editDisabled, className: "files" }, list.map(function (file, index) {
        var format = file.type.split('/');
        var ext = file.name.split('.')[1];
        var fileName = file.name;
        var match = fileName.match(/\w+(?=__\d+\.)/);
        if (match != null) {
            fileName = [match[0], ext].join('.');
        }
        switch (file.saved) {
            case true:
                return (React.createElement(File$1, { key: file.name, editDisabled: editDisabled },
                    !editDisabled && (React.createElement(RemoveFile, { onClick: function () {
                            setShowDeleteModal(file.name);
                        } },
                        React.createElement(Icon, { className: "remove-icon", src: "assets/file-trashcan-icon.svg", label: "icon to remove file from list" }))),
                    React.createElement(Wrap, { type: "button", editDisabled: editDisabled, onClick: function () {
                            if (disableModal) {
                                return;
                            }
                            setShowFileModal(file.name);
                        } },
                        React.createElement(FileSelect, { editDisabled: editDisabled, file: file, format: format, index: index }),
                        React.createElement(FileName, { editDisabled: editDisabled },
                            React.createElement("p", null, fileName),
                            !editDisabled && file.type.match('image/(?!hei(c|f))(w*)') && (React.createElement(ViewBtn, null, "View")))),
                    React.createElement(Modal$2, { heading: fileName, open: showFileModal === file.name, onClose: function () { return setShowFileModal(''); }, noFooter: true },
                        React.createElement(FileSelect, { editDisabled: editDisabled, file: file, format: format, index: index })),
                    React.createElement(Modal$2, { heading: "Are you sure you want to delete the file?", open: showDeleteModal === file.name, onClose: function () { return setShowDeleteModal(''); }, primaryAction: "Delete file", destructive: true, onPrimaryAction: function () {
                            if (!handleRemove) {
                                return;
                            }
                            handleRemove(index);
                            setShowDeleteModal('');
                        } },
                        React.createElement(React.Fragment, null,
                            "You are about to permanently delete the file: ",
                            fileName))));
            case false:
                return (React.createElement(PlaceholderFile, { key: file.name, editDisabled: editDisabled },
                    React.createElement(ErrorState, null,
                        React.createElement("p", null, " File \"".concat(fileName, "\" could not be saved ")),
                        React.createElement(DismissBtn, { type: "button", onClick: function () {
                                if (!handleRemove) {
                                    return;
                                }
                                handleRemove(index);
                            } }, "Dismiss"))));
            default:
                return (React.createElement(PlaceholderFile, { key: file.name, editDisabled: editDisabled }, file.error ? (React.createElement(ErrorState, null,
                    React.createElement("p", null, " File \"".concat(fileName, "\" ").concat(file.error, " ")),
                    React.createElement(DismissBtn, { type: "button", onClick: function () {
                            if (!handleRemove) {
                                return;
                            }
                            handleRemove(index);
                        } }, "Dismiss"))) : (React.createElement(LoadingState, null,
                    React.createElement("p", null, " \"".concat(fileName, "\" "),
                        React.createElement("br", null),
                        "uploading"),
                    React.createElement(Spinner, null)))));
        }
    })));
};
var templateObject_1$u, templateObject_2$j, templateObject_3$b, templateObject_4$a, templateObject_5$a, templateObject_6$7, templateObject_7$6, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$3, templateObject_12$3;

var Container$1 = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row wrap;\n\n  @media (max-width: ", ") {\n    .files {\n      order: 2;\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: row wrap;\n\n  @media (max-width: ", ") {\n    .files {\n      order: 2;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var Dropzone = styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed\n    ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  margin-top: 32px;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed\n    ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  margin-top: 32px;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, isDragActive = _a.isDragActive;
    return isDragActive ? theme.colors.purpleHaze : theme.fill.surface;
}, function (_a) {
    var theme = _a.theme, isDragActive = _a.isDragActive;
    return isDragActive ? theme.border.interactive : theme.border.neutralDark;
}, function (_a) {
    var hasFiles = _a.hasFiles;
    return (hasFiles ? '120px' : '324px');
}, function (_a) {
    var theme = _a.theme, hasFiles = _a.hasFiles;
    return hasFiles &&
        "\n    @media (max-width: ".concat(theme.breakpoints.medium, ") {\n      border: none;\n      height: auto;\n      justify-content: flex-end;\n      margin-top: 0;\n      order: 1;\n      width: 50%;\n    }\n\n  ");
});
var Content$1 = styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n"])));
var Desc = styled.p(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  && {\n    ", ";\n    font-size: 12px;\n    line-height: 16px;\n\n    ", "\n  }\n"], ["\n  && {\n    ", ";\n    font-size: 12px;\n    line-height: 16px;\n\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.book;
}, function (_a) {
    var theme = _a.theme, hasFiles = _a.hasFiles;
    return hasFiles &&
        "\n        @media (max-width: ".concat(theme.breakpoints.medium, ") {\n        display: none;\n    ");
});
var FileCount = styled.p(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  && {\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    width: 100%;\n\n    @media (max-width: ", ") {\n      width: 50%;\n    }\n  }\n"], ["\n  && {\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n    width: 100%;\n\n    @media (max-width: ", ") {\n      width: 50%;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.book;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var Cta = styled.p(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  && {\n    background: transparent;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    ", ";\n    padding: 8px 0;\n    min-width: 162px;\n    text-align: center;\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n\n    ", "\n  }\n"], ["\n  && {\n    background: transparent;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    ", ";\n    padding: 8px 0;\n    min-width: 162px;\n    text-align: center;\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.border.interactive;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.book;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.active;
}, function (_a) {
    var theme = _a.theme, hasFiles = _a.hasFiles;
    return hasFiles &&
        "\n        @media (max-width: ".concat(theme.breakpoints.medium, ") {\n          border: none;\n          color: ").concat(theme.text.interactive, ";\n          padding: 0;\n          min-width: 0;\n          text-decoration: underline;\n\n          &:hover {\n             background: transparent;\n          }\n        }\n    ");
});
var ErrorList = styled.li(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.danger;
});
var FileDrop = function (_a) {
    var _b;
    var block = _a.block, acceptedFileTypes = _a.acceptedFileTypes, error = _a.error, showModal = _a.showModal;
    var formik = useFormikContext();
    var _c = useState(formik.values[block.id] && typeof formik.values[block.id] === 'string'
        ? JSON.parse(formik.values[block.id])
        : []), fileList = _c[0], setFileList = _c[1];
    var _d = useState(), errorList = _d[0], setErrorList = _d[1];
    var _e = useFnolData(), sendPost = _e.sendPost, setQuery = _e.setQuery, pendingClaimNumber = _e.pendingClaimNumber, location = _e.location, policy = _e.policy;
    var fileUploadCreate = useCallback(function (_a) {
        var file = _a.file, acceptedFiles = _a.acceptedFiles;
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedFiles, fileIndex, res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedFiles = acceptedFiles;
                        fileIndex = updatedFiles.findIndex(function (item) { return item.name === file.name; });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendPost(fileUploadCreateBody(file, policy, pendingClaimNumber))];
                    case 2:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[block.id] = {
                                location: location,
                                dependencies: {},
                                result: res.fileUpload,
                            },
                            _a));
                        if (!res.status || res.status === 200) {
                            updatedFiles[fileIndex].saved = true;
                        }
                        else {
                            updatedFiles[fileIndex].saved = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        // proceed despite server error
                        file.saved = false;
                        updatedFiles[fileIndex].saved = false;
                        console.error('Query Error', err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        setFileList(updatedFiles);
                        formik.setFieldValue(block.id, JSON.stringify(updatedFiles));
                        return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
        return null;
    }, [block.id, formik, location, pendingClaimNumber, policy, sendPost, setQuery]);
    var fileUploadDelete = useCallback(function (file) {
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedFiles, fileIndex, res, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedFiles = __spreadArray([], fileList, true);
                        fileIndex = fileList.findIndex(function (item) { return item.name === file.name; });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendPost(fileUploadDeleteBody(file, policy, pendingClaimNumber))];
                    case 2:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[block.id] = {
                                location: location,
                                dependencies: {},
                                result: res.fileUpload,
                            },
                            _a));
                        if (!res.status || res.status === 200) {
                            updatedFiles[fileIndex].saved = true;
                        }
                        else {
                            updatedFiles[fileIndex].saved = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        // proceed despite server error
                        updatedFiles[fileIndex].saved = false;
                        console.error('Query Error', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
        return null;
    }, [block.id, fileList, location, pendingClaimNumber, policy, sendPost, setQuery]);
    var handleValidate = useCallback(function (value) {
        if (block.required && (!value || value.length < 1)) {
            return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
        }
    }, [block.error, block.required]);
    var onDropAccepted = useCallback(function (accepted) {
        formik.setFieldTouched(block.id);
        var acceptedFiles = __spreadArray([], fileList, true);
        var pad = function (n) { return n.toString().padStart(2, '0'); };
        var getTimestamp = function (d) {
            return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), ".").concat(pad(d.getHours()), ".").concat(pad(d.getMinutes()), ".").concat(pad(d.getSeconds()), ".").concat(d.getMilliseconds());
        };
        accepted.forEach(function (file) {
            var reader = new FileReader();
            var errors = [];
            var uploadError;
            reader.onabort = function () {
                uploadError = 'has been aborted';
                errors.push("File \"".concat(file.name, " has been aborted"));
            };
            reader.onerror = function () {
                uploadError = 'upload has failed';
                errors.push("File \"".concat(file.name, " upload has failed"));
            };
            reader.onload = function () {
                var _a;
                var dataUrl = reader.result;
                var fileInfo = {
                    id: Math.random().toString(36).slice(2),
                    dataUrl: dataUrl,
                    encodingScheme: 'Base64',
                    name: file.name.split('.').join("-".concat(getTimestamp(new Date()), ".")),
                    size: file.size,
                    type: file.type,
                    category: block.description ? block.description : block.id,
                    error: uploadError,
                };
                acceptedFiles.push(fileInfo);
                formik.setFieldValue(block.id, JSON.stringify(acceptedFiles));
                setFileList(acceptedFiles);
                fileUploadCreate({
                    id: block.id,
                    file: fileInfo,
                    acceptedFiles: acceptedFiles,
                });
                if (errors.length > 0) {
                    formik.setErrors((_a = {},
                        _a[block.id] = errors,
                        _a));
                }
            };
            reader.readAsDataURL(file);
        });
    }, [fileList, formik, block.id, block.description, fileUploadCreate]);
    var onDropRejected = useCallback(function (rejected) {
        var _a;
        var errors = [];
        rejected.forEach(function (reject) {
            var fileName = reject.file.name;
            reject.errors.forEach(function (error) {
                // NOTE: other error codes we are not handling now too-many-files & file-too-small
                // file size could need to be dyanmic when more carriers are added
                switch (error.code) {
                    case 'file-too-large':
                        return errors.push("File \"".concat(fileName, "\" is larger than 6MB"));
                    case 'file-invalid-type':
                        return errors.push("File \"".concat(fileName, "\" type must be ").concat(acceptedFileTypes));
                }
            });
        });
        setErrorList(errors);
        formik.setErrors((_a = {},
            _a[block.id] = errors,
            _a));
    }, [formik, block.id, acceptedFileTypes]);
    // need to pass acceptedFiles in order for the reset of the errorList to occur when there are only acceptedFiles
    function onDrop(_acceptedFiles, rejectedFiles) {
        if (rejectedFiles.length === 0) {
            setErrorList(undefined);
        }
    }
    var _f = useDropzone({
        onDrop: onDrop,
        onDropAccepted: onDropAccepted,
        onDropRejected: onDropRejected,
        maxSize: 6000000,
        accept: acceptedFileTypes,
    }), getRootProps = _f.getRootProps, getInputProps = _f.getInputProps, isDragActive = _f.isDragActive;
    var handleRemove = useCallback(function (index) {
        fileUploadDelete(fileList[index]);
        var list = fileList;
        list.splice(index, 1);
        formik.setFieldValue(block.id, JSON.stringify(list));
        setFileList(list);
    }, [fileList, formik, block.id, fileUploadDelete]);
    // need to filter out an accepted file that has an error
    var acceptedFilesErrorLength = fileList.filter(function (file) {
        return file.error;
    }).length;
    // length of ALL accepted files
    var allAcceptedFilesLength = fileList.length;
    // actual number of files accepted
    var filesAcceptedLength = allAcceptedFilesLength - acceptedFilesErrorLength;
    return (React.createElement(React.Fragment, null,
        React.createElement(Container$1, null, (_b = block.requirementsRestrictions) === null || _b === void 0 ? void 0 :
            _b.map(function (name) { return (React.createElement("p", { key: name }, name)); }),
            filesAcceptedLength > 0 && (React.createElement(FileCount, null, "".concat(filesAcceptedLength, " file").concat(filesAcceptedLength > 1 ? 's' : '', " added"))),
            filesAcceptedLength > 0 && (React.createElement(FileList, { list: fileList, handleRemove: handleRemove, block: block }, function (modal) { return showModal(modal.isOpen, modal.title, modal.onClose, modal.content); })),
            React.createElement(Dropzone, __assign({}, getRootProps(), { isDragActive: isDragActive, hasFiles: filesAcceptedLength > 0 }),
                React.createElement(Field, { name: block.id, validate: handleValidate }, function () { return React.createElement("input", __assign({}, getInputProps())); }),
                React.createElement(Content$1, null,
                    React.createElement(Cta, { hasFiles: filesAcceptedLength > 0 }, filesAcceptedLength > 0 ? '+ Add more' : "Add ".concat(block.uploadType)),
                    React.createElement(Desc, { hasFiles: filesAcceptedLength > 0 }, "Or drag and drop files here")))),
        error && errorList && (React.createElement("ul", null, errorList.map(function (error) { return (React.createElement(ErrorList, { key: error }, error)); })))));
};
var templateObject_1$t, templateObject_2$i, templateObject_3$a, templateObject_4$9, templateObject_5$9, templateObject_6$6, templateObject_7$5;

var StyledError = styled(Span)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  && {\n    color: ", ";\n    margin-top: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    display: block;\n    text-align: left !important;\n  }\n"], ["\n  && {\n    color: ", ";\n    margin-top: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    display: block;\n    text-align: left !important;\n  }\n"])), theme$1.colors.text.danger);
var PHErrorMessage = function (_a) {
    var blockId = _a.blockId;
    return (React.createElement(StyledError, { size: "sm" },
        React.createElement(ErrorMessage, { name: blockId })));
};
var templateObject_1$s;

var File = function (_a) {
    var block = _a.block;
    return (React.createElement(FileDrop, { block: block, acceptedFileTypes: block.acceptedFileTypes, error: React.createElement(PHErrorMessage, { blockId: block.id }) }));
};

var CatList = function (_a) {
    var _b, _c;
    var id = _a.id, block = _a.block, placeholder = _a.placeholder, catastropheFound = _a.catastropheFound, action = _a.action;
    var formik = useFormikContext();
    var _d = useFnolData(), sendPost = _d.sendPost, setQuery = _d.setQuery, queries = _d.queries, location = _d.location, policy = _d.policy, validate = _d.validate;
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), showLoadingIndicator = _f[0], setShowLoadingIndicator = _f[1];
    var query = queries[id];
    var state = formik.values.atInsuredAddress
        ? policy.state
        : (_b = formik.values.lossLocationState) !== null && _b !== void 0 ? _b : '';
    useEffect(function () {
        var timeId = setTimeout(function () { return setShowLoadingIndicator(true); }, 500);
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, sendPost(catBody(formik.values.lossDate, state, policy.carrierGroup, policy.policyId))];
                    case 1:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[id] = {
                                location: location,
                                dependencies: {
                                    lossDate: formik.values.lossDate,
                                    atInsuredAddress: formik.values.atInsuredAddress,
                                    lossLocationState: formik.values.lossLocationState,
                                },
                                result: res.catastrophes,
                            },
                            _a));
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        if (!(res.catastrophes.length === 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, validate(formik)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, formik.validateForm()];
                    case 3:
                        _b.sent();
                        action(formik.values);
                        formik.setFieldValue(id, '');
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        // proceed despite server error
                        console.error('Query Error', err_1);
                        clearTimeout(timeId);
                        setLoading(false);
                        setShowLoadingIndicator(false);
                        action(formik.values);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        if (hasRequiredValues(formik.values)) {
            sendQuery();
        }
    }, [id, location, state, formik.values.lossDate]);
    if (loading) {
        return placeholder({ showLoadingIndicator: showLoadingIndicator });
    }
    if (((_c = query === null || query === void 0 ? void 0 : query.result) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        var options = __spreadArray([
            {
                label: 'No - This claim is not the result of any of these events',
                value: JSON.stringify(false),
            }
        ], query.result.map(function (cat) {
            var dateRange = "".concat(formatDate(cat.startDate), "-").concat(formatDate(cat.endDate));
            return {
                label: "".concat(cat.description, " (").concat(cat.code, ") \u2014 ").concat(dateRange),
                value: JSON.stringify({
                    pcsCode: cat.code,
                    carrierCatId: cat.carrierCatId,
                }),
            };
        }), true);
        var fakeBlock = {
            type: BlockType.Select,
            id: block.id,
            title: '',
            description: '',
            error: block.error,
            required: block.required,
            help: '',
            options: options,
            selectTitle: '',
            placeholder: 'Select a recent event',
            style: 'standard',
        };
        return catastropheFound({
            fakeBlock: fakeBlock,
        });
    }
    return null;
};
function formatDate(val) {
    return format(new Date("".concat(val, "T12:00:00.000Z")), 'MMM d');
}
function hasRequiredValues(values) {
    return (values.lossDate &&
        (values.atInsuredAddress === true ||
            (values.atInsuredAddress === false && values.lossLocationState)));
}

var SelectBlockWrapper = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  margin: 0 0 20px 0;\n"], ["\n  margin: 0 0 20px 0;\n"])));
function SelectInput(_a) {
    var block = _a.block, data = _a.data;
    var name = data.field.name, _b = data.meta, value = _b.value, error = _b.error, touched = _b.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (selected) {
        form.setFieldValue(block.id, selected);
        form.setFieldTouched(block.id, true);
    }, [block.id, form]);
    return (React.createElement(SelectBlockWrapper, null,
        React.createElement(Select, { id: "field".concat(block.id), name: name, label: block.description, errorMessage: error, isError: !isValid, selectedKey: value, onSelectionChange: function (selected) { return handleChange(selected); }, items: block.options, "data-testid": "select" }, function (item) { return React.createElement(Item, { key: item.value }, item.label); })));
}
var templateObject_1$r;

/**
 * This function takes in a simple form field component and registers it with Formik
 * The output supplies the component with Formik FieldProps to be used within the
 * component to directly interact with the field vs going through Formik context
 */
function withField(WrappedComponent) {
    return function ComponentWithField(props) {
        var block = props.block, handleValidate = props.handleValidate, rest = __rest(props, ["block", "handleValidate"]);
        return (React.createElement(Field, { name: block.id, validate: handleValidate }, function (data) { return React.createElement(WrappedComponent, __assign({ block: block, data: data }, rest)); }));
    };
}

var Placeholder$1 = styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"])));
var SelectField = withField(SelectInput);
var PHCatList = function (_a) {
    var block = _a.block;
    var nextStep = useFnolData().nextStep;
    return (React.createElement(CatList, { id: block.id, block: block, placeholder: function (_a) {
            var showLoadingIndicator = _a.showLoadingIndicator;
            return (React.createElement(Placeholder$1, null, showLoadingIndicator && React.createElement(Spinner, null)));
        }, catastropheFound: function (_a) {
            var fakeBlock = _a.fakeBlock;
            return (React.createElement("div", null,
                block.title && React.createElement("h4", null, block.title),
                React.createElement(SelectField, { block: fakeBlock })));
        }, action: function (values) { return nextStep(values); } }));
};
var templateObject_1$q;

var ModalWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  background: rgba(62, 64, 63, 0.85);\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n"], ["\n  background: rgba(62, 64, 63, 0.85);\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n"])));
var TitleBox = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  background: ", ";\n  position: relative;\n"], ["\n  background: ", ";\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.canvas;
});
// MSS uses #3e403f which is not a color
var ModalTitle = styled(Heading)(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  color: ", ";\n  margin: 28px 60px;\n\n  @media (max-width: ", ") {\n    margin: 12px 20px;\n  }\n"], ["\n  color: ", ";\n  margin: 28px 60px;\n\n  @media (max-width: ", ") {\n    margin: 12px 20px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var CloseButton = styled.button(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 24px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    right: 16px;\n    top: 24px;\n  }\n"], ["\n  background: transparent;\n  border: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 24px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    right: 16px;\n    top: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var ModalContent = styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  border-radius: 5px;\n  display: flex;\n  flex-flow: column nowrap;\n  margin: 25vh auto auto auto;\n\n  @media (min-width: ", ") {\n    margin: auto;\n    max-width: 620px;\n  }\n"], ["\n  border-radius: 5px;\n  display: flex;\n  flex-flow: column nowrap;\n  margin: 25vh auto auto auto;\n\n  @media (min-width: ", ") {\n    margin: auto;\n    max-width: 620px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var ModalChildren = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  background: ", ";\n  padding: 20px 24px;\n"], ["\n  background: ", ";\n  padding: 20px 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
});
styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  padding: 20px;\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  padding: 20px;\n  display: flex;\n  justify-content: flex-end;\n"])));
var Modal$1 = function (_a) {
    var title = _a.title, content = _a.content, isOpen = _a.isOpen, onClose = _a.onClose;
    return (React.createElement(React.Fragment, null, isOpen && (React.createElement(ModalWrapper, null,
        React.createElement(ModalContent, null,
            React.createElement(TitleBox, null,
                React.createElement(ModalTitle, { size: "md" }, title),
                React.createElement(CloseButton, { type: "button", onClick: onClose },
                    React.createElement("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M14.1306 1.41L12.7206 0L7.13062 5.59L1.54062 0L0.130615 1.41L5.72062 7L0.130615 12.59L1.54062 14L7.13062 8.41L12.7206 14L14.1306 12.59L8.54062 7L14.1306 1.41Z", fill: "#330072" })))),
            React.createElement(ModalChildren, null, content))))));
};
var templateObject_1$p, templateObject_2$h, templateObject_3$9, templateObject_4$8, templateObject_5$8, templateObject_6$5, templateObject_7$4;

var CarrierCheck = function (_a) {
    var _b;
    var id = _a.id, policyId = _a.policyId, source = _a.source, isBlocked = _a.isBlocked, action = _a.action;
    var formik = useFormikContext();
    var _c = useFnolData(), sendPost = _c.sendPost, setQuery = _c.setQuery, queries = _c.queries, location = _c.location, sendExit = _c.sendExit;
    var lossDate = formik.values['lossDate'];
    var query = queries[id];
    useEffect(function () {
        if (!isValidDate(lossDate)) {
            return;
        }
        var _lossDate = lossDate.replace(/\//g, '-');
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, sendPost(carrierCheckBody(policyId, source, _lossDate))];
                    case 1:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[id] = {
                                location: location,
                                dependencies: {},
                                result: res,
                            },
                            _a));
                        if (!(res === null || res === void 0 ? void 0 : res.blocked)) {
                            formik.setFieldValue(id, true);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        // proceed despite server error
                        console.error('Query Error', err_1);
                        action(formik.values);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (formik.values && lossDate) {
            sendQuery();
        }
    }, [id, location, lossDate]);
    if ((_b = query === null || query === void 0 ? void 0 : query.result) === null || _b === void 0 ? void 0 : _b.blocked) {
        return isBlocked({
            title: query.result.title,
            reason: query.result.reason,
            handleClose: function () { return sendExit({}); },
        });
    }
    return null;
};

var Container = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  padding: 20px 20px 40px;\n"], ["\n  padding: 20px 20px 40px;\n"])));
var ModalButtons = styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  padding-bottom: 16px;\n\n  button {\n    width: 100%;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  padding-bottom: 16px;\n\n  button {\n    width: 100%;\n  }\n"])));
// Make modal
var BlockingModal = function (_a) {
    var title = _a.title, reason = _a.reason, handleClose = _a.handleClose;
    // Do not pass Go, do not collect $200.
    document.body.classList.add('block');
    return (React.createElement(Modal$1, { title: title, isOpen: true, onClose: handleClose, content: React.createElement("div", null,
            React.createElement(Container, { dangerouslySetInnerHTML: {
                    __html: reason.split('. ').join('.<br/><br/>'),
                } }),
            React.createElement(ModalButtons, null,
                React.createElement(Button, { onClick: handleClose }, "Return to claims"))) }));
};
var PHCarrierCheck = function (_a) {
    var id = _a.id, policyId = _a.policyId, source = _a.source;
    var nextStep = useFnolData().nextStep;
    return (React.createElement(CarrierCheck, { id: id, policyId: policyId, source: source, isBlocked: BlockingModal, action: function (values) { return nextStep(values); } }));
};
var templateObject_1$o, templateObject_2$g;

var PHQuery = function (_a) {
    var block = _a.block;
    var values = useFormikContext().values;
    var _b = useFnolData(), policy = _b.policy, source = _b.source;
    switch (block.queryType) {
        case BlockQueryType.CarrierCheck:
            return React.createElement(PHCarrierCheck, { id: block.id, policyId: policy.policyId, source: source });
        case BlockQueryType.CatastropheList:
            return React.createElement(PHCatList, { block: block });
        case BlockQueryType.DuplicateClaim:
            return (React.createElement(PHDuplicateClaim, { id: block.id, lossDate: values.lossDate, policyId: policy.policyId }));
        case BlockQueryType.Eligibility:
            return null;
        case BlockQueryType.WindHail:
            return null;
        case BlockQueryType.FileUpload:
            return React.createElement(File, { block: block });
        case BlockQueryType.PolicyTerm:
            return (React.createElement(PHPolicyTerm, { id: block.id, lossDate: values.lossDate, policyId: policy.policyId, policyEffectiveDate: policy.policyEffectiveDate, policyExpirationDate: policy.policyExpirationDate }));
    }
};

var Disclaimer = styled.span(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  display: block;\n  font-size: 0.6rem;\n  color: ", ";\n  line-height: 0.7rem;\n  max-width: 60%;\n\n  @media (min-width: ", ") {\n    max-width: 40%;\n  }\n"], ["\n  display: block;\n  font-size: 0.6rem;\n  color: ", ";\n  line-height: 0.7rem;\n  max-width: 60%;\n\n  @media (min-width: ", ") {\n    max-width: 40%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
function CheckboxBool(_a) {
    var block = _a.block, data = _a.data;
    var value = data.meta.value, form = data.form;
    var setValue = function (val) {
        form.setFieldValue(block.id, val);
        form.setFieldTouched(block.id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckboxGroup, { value: value ? ['true'] : [], onChange: function (value) {
                var result = value.length === 1 ? true : false;
                setValue(result);
            } },
            React.createElement(CheckboxGroup.Checkbox, { value: "true" }, block.title)),
        block.description !== '' && React.createElement(Disclaimer, null, block.description)));
}
var templateObject_1$n;

var TextWrapper = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  padding-bottom: 10px;\n  width: 100%;\n\n  textarea {\n    resize: none;\n    height: 12em;\n  }\n"], ["\n  padding-bottom: 10px;\n  width: 100%;\n\n  textarea {\n    resize: none;\n    height: 12em;\n  }\n"])));
styled.p(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  && {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"], ["\n  && {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"])));
var templateObject_1$m, templateObject_2$f;

var Title = styled(Span)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: block !important;\n  margin-bottom: 12px;\n"], ["\n  display: block !important;\n  margin-bottom: 12px;\n"])));
var TextInput = function (_a, ref) {
    var block = _a.block, data = _a.data;
    var _b = data.field, name = _b.name, value = _b.value, _c = data.meta, error = _c.error, touched = _c.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (e) {
        form.setFieldValue(block.id, e.currentTarget.value);
        form.setFieldTouched(block.id, touched);
    }, [block.id, form, touched]);
    var handleBlur = useCallback(function (e) {
        form.handleBlur(e);
    }, [form]);
    return (React.createElement(TextWrapper, null,
        block.id === 'timeToCall' && React.createElement(Title, null, block.title),
        React.createElement(TextInput$2, { ref: ref, id: "field".concat(block.id), name: name, label: block.description, placeholder: block.placeholder, value: value, onChange: handleChange, onBlur: handleBlur, isError: !isValid, errorMessage: error })));
};
var TextInput$1 = forwardRef(TextInput);
var templateObject_1$l;

function TelephoneInput(_a) {
    var block = _a.block, data = _a.data;
    var _b = data.field, name = _b.name, value = _b.value, _c = data.meta, error = _c.error, touched = _c.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (e) {
        var val = e.currentTarget.value;
        // Skip masking if removing characters. A user couldn't backspace past the
        // non-numeric characters
        if (!value || value.length < val.length) {
            val = formatPhoneNum(val);
        }
        form.setFieldValue(block.id, val);
        form.setFieldTouched(block.id, touched);
    }, [block.id, form, touched, value]);
    var handleBlur = useCallback(function (e) {
        form.handleBlur(e);
    }, [form]);
    return (React.createElement(TextWrapper, null,
        React.createElement(TextInput$2, { id: "field".concat(block.id), type: "text", name: name, label: block.description, placeholder: block.placeholder, errorMessage: error, value: value, onChange: handleChange, onBlur: handleBlur, isError: !isValid })));
}

var ComboBoxBlockWrapper = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  margin: 0 0 20px 0;\n"], ["\n  margin: 0 0 20px 0;\n"])));
function ComboBoxInput(_a) {
    var block = _a.block, data = _a.data;
    var name = data.field.name, _b = data.meta, value = _b.value, error = _b.error, touched = _b.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (selected) {
        form.setFieldValue(block.id, selected);
        form.setFieldTouched(block.id, true);
    }, [block.id, form]);
    var onInputChange = useCallback(function () {
        form.setFieldTouched(block.id, true);
    }, [block.id, form]);
    return (React.createElement(ComboBoxBlockWrapper, null,
        React.createElement(ComboBox, { id: "field".concat(block.id), name: name, label: block.description, errorMessage: error, isError: !isValid, selectedKey: value, onSelectionChange: function (selected) { return handleChange(selected); }, defaultItems: block.options, onInputChange: onInputChange }, function (item) { return React.createElement(Item, { key: item.value }, item.label); })));
}
var templateObject_1$k;

var MitigationDeclineReason = function (_a) {
    var block = _a.block, RadioSelect = _a.RadioSelect;
    var state = useFnolData();
    var nextStep = state.nextStep, validate = state.validate, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, setDraftBeingEdited = state.setDraftBeingEdited, sendPost = state.sendPost, mitigationEligibility = state.mitigationServices.mitigationEligibility;
    var formik = useFormikContext();
    var values = formik.values;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var saveDraft = useCallback(function (exitReason) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = generateSubmitDraftBody(formik.values, state, {
                        exitStepNumber: 1,
                        exitReason: exitReason,
                    }, user || '', source, draftBeingEdited || undefined);
                    return [4 /*yield*/, sendPost(payload)];
                case 1:
                    data = (_a.sent()).data;
                    setDraftBeingEdited(data);
                    return [2 /*return*/];
            }
        });
    }); }, [formik.values, state, user, source, draftBeingEdited, sendPost, setDraftBeingEdited]);
    var continueForm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validate(formik)];
                case 1:
                    _a.sent();
                    nextStep(values);
                    saveDraft('MSS: Mitigation Services Decline Reason page');
                    return [2 /*return*/];
            }
        });
    }); }, [validate, formik, nextStep, values, saveDraft]);
    // Skip this step if mitigations aren't offered
    useEffect(function () {
        var mitigationOfferred = isMitigationServicesOffered(mitigationEligibility);
        if (!mitigationOfferred || (mitigationOfferred && isMitigationSelected(values))) {
            continueForm();
        }
        else {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // array intentionally left empty to ensure only fires once
    if (loading) {
        return null;
    }
    return RadioSelect({
        block: block === null || block === void 0 ? void 0 : block.children[0],
        handleValidate: selectFieldValidation(block === null || block === void 0 ? void 0 : block.children[0]),
    });
};

var GooglePlacesAutocomplete = function (_a) {
    var googleMapsKey = _a.googleMapsKey, input = _a.input, block = _a.block;
    var formik = useFormikContext();
    var _b = useState(), autocomplete = _b[0], setAutocomplete = _b[1];
    var _c = useState(false), loaded = _c[0], setLoaded = _c[1];
    var googleMapsRef = useRef(null);
    var handlePlaceSelect = useCallback(function () {
        // Break up results into separate input boxes
        if (autocomplete != null) {
            var address = '';
            for (var _i = 0, _a = autocomplete.getPlace()
                .address_components; _i < _a.length; _i++) {
                var component = _a[_i];
                var componentType = component.types[0];
                switch (componentType) {
                    case 'street_number':
                        address = component.long_name;
                        break;
                    case 'route':
                        address += ' ' + component.short_name;
                        break;
                    case 'locality':
                        formik.setFieldValue(block.slots.city.id, component.long_name);
                        break;
                    case 'postal_code':
                        formik.setFieldValue(block.slots.zip.id, component.long_name);
                        break;
                    case 'administrative_area_level_1':
                        formik.setFieldValue(block.slots.state.id, component.short_name);
                        break;
                }
            }
            formik.setFieldValue(block.slots.street.id, address);
        }
        // don't recompile when formik changes, since switch statement updates formik
        // otherwise causes process to hang
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autocomplete]);
    useEffect(function () {
        if (!loaded) {
            loadGooglePlacesAutocomplete(function () { return setLoaded(true); }, googleMapsKey);
        }
        else {
            setAutocomplete(new window.google.maps.places.Autocomplete(googleMapsRef.current, {
                types: ['address'],
                fields: ['address_components'],
            }));
        }
    }, [loaded, googleMapsKey]);
    useEffect(function () {
        if (autocomplete) {
            autocomplete.addListener('place_changed', handlePlaceSelect);
        }
    }, [autocomplete, handlePlaceSelect]);
    return input({ googleMapsRef: googleMapsRef });
};
var loadGooglePlacesAutocomplete = function (callback, googleMapsKey) {
    var existingScript = document.getElementById('googleMapsPlaces');
    if (!existingScript) {
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(googleMapsKey, "&libraries=places");
        script.id = 'googleMapsPlaces';
        document.body.appendChild(script);
        script.onload = function () {
            callback && callback();
        };
    }
    existingScript && callback && callback();
};

var StyledGroup = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column wrap;\n  width: 90vw;\n  max-width: 624px;\n\n  div {\n    padding: 0;\n    margin-bottom: 0;\n    margin-top: 0;\n    display: flex;\n    flex-flow: row;\n    justify-content: flex-start;\n    max-width: 624px;\n  }\n\n  div[class*='ds__textinput'] {\n    display: flex;\n    flex-direction: column !important;\n    width: 40vw;\n\n    p {\n      margin: 5px !important;\n      width: auto;\n    }\n  }\n\n  div[class*='StyledFormBlockContainer'] {\n    padding: 0;\n  }\n\n  input[class*='emailField'] {\n    display: flex;\n    flex-direction: column !important;\n    width: 610px;\n  }\n\n  div[class*='ds__select'] {\n    display: flex;\n    flex-direction: column !important;\n\n    button {\n      width: 90vw;\n      max-width: 624px;\n    }\n\n    p {\n      margin: 5px !important;\n      width: auto;\n    }\n  }\n\n  div[class*='ds__checkboxgroup '] {\n    max-width: 310px !important;\n    min-width: 310px !important;\n    text-align: left;\n\n    p {\n      margin: 10px !important;\n      display: none;\n    }\n\n    div {\n      justify-content: center !important;\n      align-items: center !important;\n    }\n  }\n\n  p[class*='text-danger'] {\n    text-align: left;\n    margin-top: 5px;\n  }\n\n  button[class*='linkButton'] {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: center;\n    flex-flow: row;\n    text-decoration: none;\n  }\n\n  div[class*='removeButton'] {\n    padding-top: 40px !important;\n  }\n\n  &.isContactPageGroup {\n    div {\n      max-width: 310px !important;\n    }\n\n    button[class*='removeButton'] {\n      transform: translate(20px, 45px) !important;\n    }\n\n    div[class*='ds__select'],\n    div[class*='ds__textinput'] {\n      max-width: min-content;\n\n      button {\n        max-width: 300px;\n        width: 20vw;\n      }\n    }\n\n    input {\n      margin-right: 20px;\n      min-width: 300px;\n      width: 20vw;\n    }\n\n    input[class*='emailField'] {\n      min-width: 624px;\n      margin-right: 0 !important;\n    }\n\n    div[class*='StyledTextContainer'] {\n      width: 90vw;\n      max-width: 310px !important;\n      justify-content: flex-start;\n    }\n\n    #contactAddPhoneLink {\n      width: 624px;\n      margin: 0;\n      margin-top: 24px !important;\n      margin-bottom: 24px !important;\n      display: flex;\n      justify-content: flex-start !important;\n\n      button {\n        justify-content: flex-start;\n        width: 100%;\n      }\n    }\n\n    #contactWantsSms {\n      span {\n        min-width: 310px;\n        width: 90vw;\n        text-align: left !important;\n        padding: 0 10px;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n\n  p {\n    width: auto;\n  }\n\n  label {\n    padding-bottom: 5px;\n    padding-top: 5px;\n    margin-bottom: 0;\n    width: 310px;\n  }\n\n  input,\n  div[class*='ds__select'],\n  div[class*='ds__textinput'] {\n    width: 90vw;\n    max-width: 624px;\n\n    button {\n      width: 90vw;\n      max-width: 624px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    justify-content: flex-start;\n    div {\n      justify-content: flex-start;\n    }\n\n    &.isContactPageGroup {\n      input[class*='emailField'] {\n        width: 90vw;\n      }\n\n      button[class*='removeButton'] {\n        transform: translate(0vw, 45px) !important;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    div {\n      flex-flow: column;\n      justify-content: flex-start;\n      align-content: flex-start;\n      max-width: 624px;\n    }\n\n    div[class*='StyledFormBlockContainer'] {\n      display: flex;\n      justify-content: flex-start;\n      margin: 0 auto;\n      text-align: left !important;\n    }\n\n    button {\n      min-width: 300px;\n    }\n\n    div[class*='ds__select'] {\n      p {\n        margin: 5px !important;\n      }\n    }\n\n    .isContactPageGroup {\n      div[class*='StyledLinkBlockContainer'] {\n        button {\n          margin: 10px 0 !important;\n          justify-content: flex-start;\n        }\n      }\n\n      input {\n        max-width: 310px;\n        min-width: unset;\n      }\n\n      button[class*='removeButton'] {\n        transform: translate(90vw, -90px) !important;\n      }\n\n      #contactWantsSms,\n      #contactAddPhoneLink {\n        min-width: unset !important;\n        max-width: 624px !important;\n        width: 90vw !important;\n        justify-content: flex-start;\n\n        button {\n          min-width: unset !important;\n        }\n\n        span {\n          min-width: unset !important;\n          max-width: 624px !important;\n        }\n      }\n    }\n\n    input {\n      min-width: auto;\n    }\n\n    div[class*='ds__checkboxgroup '],\n    span[class*='checkbox__Disclaimer'] {\n      min-width: 90vw !important;\n      margin: 0 0 10px !important;\n      padding: 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    div[class*='ds__select'],\n    div[class*='select__SelectBlockWrapper'],\n    label,\n    p {\n      width: min-content;\n      max-width: 200px;\n      width: 80vw;\n    }\n\n    div[class*='StyledLinkBlockContainer'] {\n      width: 80vw;\n      justify-content: flex-start !important;\n\n      button {\n        width: 80vw;\n        min-width: auto;\n        white-space: nowrap;\n        text-align: left;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    input {\n      min-width: auto;\n    }\n\n    .isContactPageGroup {\n      button[class*='removeButton'] {\n        transform: translate(85vw, -90px) !important;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: column wrap;\n  width: 90vw;\n  max-width: 624px;\n\n  div {\n    padding: 0;\n    margin-bottom: 0;\n    margin-top: 0;\n    display: flex;\n    flex-flow: row;\n    justify-content: flex-start;\n    max-width: 624px;\n  }\n\n  div[class*='ds__textinput'] {\n    display: flex;\n    flex-direction: column !important;\n    width: 40vw;\n\n    p {\n      margin: 5px !important;\n      width: auto;\n    }\n  }\n\n  div[class*='StyledFormBlockContainer'] {\n    padding: 0;\n  }\n\n  input[class*='emailField'] {\n    display: flex;\n    flex-direction: column !important;\n    width: 610px;\n  }\n\n  div[class*='ds__select'] {\n    display: flex;\n    flex-direction: column !important;\n\n    button {\n      width: 90vw;\n      max-width: 624px;\n    }\n\n    p {\n      margin: 5px !important;\n      width: auto;\n    }\n  }\n\n  div[class*='ds__checkboxgroup '] {\n    max-width: 310px !important;\n    min-width: 310px !important;\n    text-align: left;\n\n    p {\n      margin: 10px !important;\n      display: none;\n    }\n\n    div {\n      justify-content: center !important;\n      align-items: center !important;\n    }\n  }\n\n  p[class*='text-danger'] {\n    text-align: left;\n    margin-top: 5px;\n  }\n\n  button[class*='linkButton'] {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: center;\n    flex-flow: row;\n    text-decoration: none;\n  }\n\n  div[class*='removeButton'] {\n    padding-top: 40px !important;\n  }\n\n  &.isContactPageGroup {\n    div {\n      max-width: 310px !important;\n    }\n\n    button[class*='removeButton'] {\n      transform: translate(20px, 45px) !important;\n    }\n\n    div[class*='ds__select'],\n    div[class*='ds__textinput'] {\n      max-width: min-content;\n\n      button {\n        max-width: 300px;\n        width: 20vw;\n      }\n    }\n\n    input {\n      margin-right: 20px;\n      min-width: 300px;\n      width: 20vw;\n    }\n\n    input[class*='emailField'] {\n      min-width: 624px;\n      margin-right: 0 !important;\n    }\n\n    div[class*='StyledTextContainer'] {\n      width: 90vw;\n      max-width: 310px !important;\n      justify-content: flex-start;\n    }\n\n    #contactAddPhoneLink {\n      width: 624px;\n      margin: 0;\n      margin-top: 24px !important;\n      margin-bottom: 24px !important;\n      display: flex;\n      justify-content: flex-start !important;\n\n      button {\n        justify-content: flex-start;\n        width: 100%;\n      }\n    }\n\n    #contactWantsSms {\n      span {\n        min-width: 310px;\n        width: 90vw;\n        text-align: left !important;\n        padding: 0 10px;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n\n  p {\n    width: auto;\n  }\n\n  label {\n    padding-bottom: 5px;\n    padding-top: 5px;\n    margin-bottom: 0;\n    width: 310px;\n  }\n\n  input,\n  div[class*='ds__select'],\n  div[class*='ds__textinput'] {\n    width: 90vw;\n    max-width: 624px;\n\n    button {\n      width: 90vw;\n      max-width: 624px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    justify-content: flex-start;\n    div {\n      justify-content: flex-start;\n    }\n\n    &.isContactPageGroup {\n      input[class*='emailField'] {\n        width: 90vw;\n      }\n\n      button[class*='removeButton'] {\n        transform: translate(0vw, 45px) !important;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    div {\n      flex-flow: column;\n      justify-content: flex-start;\n      align-content: flex-start;\n      max-width: 624px;\n    }\n\n    div[class*='StyledFormBlockContainer'] {\n      display: flex;\n      justify-content: flex-start;\n      margin: 0 auto;\n      text-align: left !important;\n    }\n\n    button {\n      min-width: 300px;\n    }\n\n    div[class*='ds__select'] {\n      p {\n        margin: 5px !important;\n      }\n    }\n\n    .isContactPageGroup {\n      div[class*='StyledLinkBlockContainer'] {\n        button {\n          margin: 10px 0 !important;\n          justify-content: flex-start;\n        }\n      }\n\n      input {\n        max-width: 310px;\n        min-width: unset;\n      }\n\n      button[class*='removeButton'] {\n        transform: translate(90vw, -90px) !important;\n      }\n\n      #contactWantsSms,\n      #contactAddPhoneLink {\n        min-width: unset !important;\n        max-width: 624px !important;\n        width: 90vw !important;\n        justify-content: flex-start;\n\n        button {\n          min-width: unset !important;\n        }\n\n        span {\n          min-width: unset !important;\n          max-width: 624px !important;\n        }\n      }\n    }\n\n    input {\n      min-width: auto;\n    }\n\n    div[class*='ds__checkboxgroup '],\n    span[class*='checkbox__Disclaimer'] {\n      min-width: 90vw !important;\n      margin: 0 0 10px !important;\n      padding: 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    div[class*='ds__select'],\n    div[class*='select__SelectBlockWrapper'],\n    label,\n    p {\n      width: min-content;\n      max-width: 200px;\n      width: 80vw;\n    }\n\n    div[class*='StyledLinkBlockContainer'] {\n      width: 80vw;\n      justify-content: flex-start !important;\n\n      button {\n        width: 80vw;\n        min-width: auto;\n        white-space: nowrap;\n        text-align: left;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    input {\n      min-width: auto;\n    }\n\n    .isContactPageGroup {\n      button[class*='removeButton'] {\n        transform: translate(85vw, -90px) !important;\n      }\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var BlockWrapper = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start !important;\n  max-width: 624px;\n  align-items: baseline;\n\n  &.isContactPageGroup {\n    div[class*='StyledTextContainer'],\n    input,\n    div[class*='ds__select'],\n    div[class*='ds__textinput'] {\n      width: 100%;\n      max-width: 310px !important;\n      align-self: flex-start;\n\n      button {\n        width: 100%;\n        max-width: 624px;\n      }\n    }\n  }\n\n  &.isEmailField {\n    width: 90vw;\n    max-width: 624px !important;\n\n    div[class*='ds__textinput'] {\n      width: 90vw;\n      max-width: 624px !important;\n\n      div[class*='StyledTextContainer'],\n      input {\n        width: 90vw;\n        max-width: 624px !important;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    &.isContactPageGroup {\n      div[class*='SelectBlockWrapper'],\n      div[class*='ds__select'] {\n        button {\n          min-width: 30vw;\n        }\n      }\n    }\n\n    &.isAlternateField {\n      transform: translate(0px, 0px);\n    }\n  }\n\n  @media (max-width: ", ") {\n    div[class*='ds__textinput'] {\n      div[class*='StyledTextContainer'],\n      input {\n        width: 90vw;\n        max-width: 624px !important;\n      }\n\n      p {\n        min-width: 90vw;\n      }\n    }\n\n    div[class*='ds__select'] {\n      button {\n        min-width: 90vw;\n      }\n    }\n    &.isEmailField {\n      input[class*='emailField'] {\n        min-width: 90vw;\n      }\n    }\n\n    &.isContactPageGroup {\n      div[class*='SelectBlockWrapper'],\n      div[class*='ds__select'] {\n        button {\n          min-width: 90vw;\n        }\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start !important;\n  max-width: 624px;\n  align-items: baseline;\n\n  &.isContactPageGroup {\n    div[class*='StyledTextContainer'],\n    input,\n    div[class*='ds__select'],\n    div[class*='ds__textinput'] {\n      width: 100%;\n      max-width: 310px !important;\n      align-self: flex-start;\n\n      button {\n        width: 100%;\n        max-width: 624px;\n      }\n    }\n  }\n\n  &.isEmailField {\n    width: 90vw;\n    max-width: 624px !important;\n\n    div[class*='ds__textinput'] {\n      width: 90vw;\n      max-width: 624px !important;\n\n      div[class*='StyledTextContainer'],\n      input {\n        width: 90vw;\n        max-width: 624px !important;\n      }\n    }\n  }\n\n  @media (max-width: ", ") {\n    &.isContactPageGroup {\n      div[class*='SelectBlockWrapper'],\n      div[class*='ds__select'] {\n        button {\n          min-width: 30vw;\n        }\n      }\n    }\n\n    &.isAlternateField {\n      transform: translate(0px, 0px);\n    }\n  }\n\n  @media (max-width: ", ") {\n    div[class*='ds__textinput'] {\n      div[class*='StyledTextContainer'],\n      input {\n        width: 90vw;\n        max-width: 624px !important;\n      }\n\n      p {\n        min-width: 90vw;\n      }\n    }\n\n    div[class*='ds__select'] {\n      button {\n        min-width: 90vw;\n      }\n    }\n    &.isEmailField {\n      input[class*='emailField'] {\n        min-width: 90vw;\n      }\n    }\n\n    &.isContactPageGroup {\n      div[class*='SelectBlockWrapper'],\n      div[class*='ds__select'] {\n        button {\n          min-width: 90vw;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var RemoveButton = styled.button(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  background-color: ", ";\n  color: red;\n  width: 20px;\n  height: 20px;\n  border: none;\n  cursor: pointer;\n  &:hover {\n    cursor: pointer !important;\n    path {\n      fill: ", ";\n    }\n  }\n\n  transform: translate(650px, -90px);\n  min-width: auto !important;\n\n  @media (max-width: ", ") {\n    transform: translate(70vw, -90px);\n  }\n\n  @media (max-width: ", ") {\n    transform: translate(90vw, -90px);\n  }\n\n  @media (max-width: ", ") {\n    transform: translate(70vw, -90px);\n  }\n"], ["\n  background-color: ", ";\n  color: red;\n  width: 20px;\n  height: 20px;\n  border: none;\n  cursor: pointer;\n  &:hover {\n    cursor: pointer !important;\n    path {\n      fill: ", ";\n    }\n  }\n\n  transform: translate(650px, -90px);\n  min-width: auto !important;\n\n  @media (max-width: ", ") {\n    transform: translate(70vw, -90px);\n  }\n\n  @media (max-width: ", ") {\n    transform: translate(90vw, -90px);\n  }\n\n  @media (max-width: ", ") {\n    transform: translate(70vw, -90px);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fill.surface;
}, function (_a) {
    var theme = _a.theme;
    return theme.fill.active;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledAddressWrapper = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column wrap;\n  max-width: 624px;\n  width: 90vw;\n\n  p[class*='text-danger'] {\n    text-align: left;\n    margin-top: 5px;\n  }\n\n  div[class*='ds__select'] {\n    button {\n      width: 90vw;\n      max-width: 624px;\n      min-width: unset;\n    }\n\n    p {\n      margin: 10px !important;\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: column wrap;\n  max-width: 624px;\n  width: 90vw;\n\n  p[class*='text-danger'] {\n    text-align: left;\n    margin-top: 5px;\n  }\n\n  div[class*='ds__select'] {\n    button {\n      width: 90vw;\n      max-width: 624px;\n      min-width: unset;\n    }\n\n    p {\n      margin: 10px !important;\n    }\n  }\n"])));
var StyledRepeatBlockWrapper = styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  max-width: 624px;\n  width: 90vw;\n\n  p {\n    width: 40vw !important;\n    margin-top: 10px;\n  }\n\n  div[class*='StyledFormBlockContainer'] {\n    margin-bottom: 5px;\n    padding: 0;\n  }\n\n  div[class*='TextWrapper'] {\n    max-width: 624px;\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      padding: 0 !important;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  max-width: 624px;\n  width: 90vw;\n\n  p {\n    width: 40vw !important;\n    margin-top: 10px;\n  }\n\n  div[class*='StyledFormBlockContainer'] {\n    margin-bottom: 5px;\n    padding: 0;\n  }\n\n  div[class*='TextWrapper'] {\n    max-width: 624px;\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      padding: 0 !important;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledButtonWrapper = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  margin-bottom: 50px;\n\n  button {\n    margin-bottom: 15px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      margin-bottom: 15px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    button {\n      padding: 0 !important;\n    }\n  }\n"], ["\n  margin-bottom: 50px;\n\n  button {\n    margin-bottom: 15px;\n  }\n\n  @media (max-width: ", ") {\n    button {\n      margin-bottom: 15px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    button {\n      padding: 0 !important;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$j, templateObject_2$e, templateObject_3$8, templateObject_4$7, templateObject_5$7, templateObject_6$4;

var AddressBlock = function (_a) {
    var block = _a.block, textField = _a.textField, selectField = _a.selectField;
    var googleMapsKey = useFnolData().googleMapsKey;
    return (React.createElement(StyledAddressWrapper, null,
        googleMapsKey ? (React.createElement(GooglePlacesAutocomplete, { googleMapsKey: googleMapsKey, block: block, input: function (_a) {
                var googleMapsRef = _a.googleMapsRef;
                return textField({
                    block: block.slots.street,
                    handleValidate: textFieldValidations(block.slots.street),
                    ref: googleMapsRef,
                });
            } })) : (textField({
            block: block.slots.street,
            handleValidate: textFieldValidations(block.slots.street),
            key: block.slots.street.id,
        })),
        block.slots.unit &&
            textField({
                block: block.slots.unit,
                handleValidate: textFieldValidations(block.slots.unit),
                key: block.slots.unit.id,
            }),
        textField({
            block: block.slots.city,
            handleValidate: textFieldValidations(block.slots.city),
            key: block.slots.city.id,
        }),
        selectField({
            block: block.slots.state,
            handleValidate: selectFieldValidation(block.slots.state),
            key: block.slots.state.id,
        }),
        textField({
            block: block.slots.zip,
            handleValidate: textFieldValidations(block.slots.zip),
            key: block.slots.zip.id,
        })));
};

var StyledTextContainer = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  padding-bottom: 10px;\n  width: 90vw;\n  max-width: 624px;\n\n  &.textAreaBlock {\n    width: 100%;\n    max-width: 624px;\n  }\n\n  p {\n    width: auto !important;\n    text-align: left !important;\n    margin-top: 5px !important;\n  }\n\n  textarea {\n    resize: none;\n    height: 30vh;\n  }\n"], ["\n  padding-bottom: 10px;\n  width: 90vw;\n  max-width: 624px;\n\n  &.textAreaBlock {\n    width: 100%;\n    max-width: 624px;\n  }\n\n  p {\n    width: auto !important;\n    text-align: left !important;\n    margin-top: 5px !important;\n  }\n\n  textarea {\n    resize: none;\n    height: 30vh;\n  }\n"])));
var StyledCaption = styled.p(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  && {\n    font-size: 12px;\n    line-height: 16px;\n    width: auto;\n    text-align: left;\n    margin-top: -25px !important;\n    margin-bottom: 0 !important;\n  }\n"], ["\n  && {\n    font-size: 12px;\n    line-height: 16px;\n    width: auto;\n    text-align: left;\n    margin-top: -25px !important;\n    margin-bottom: 0 !important;\n  }\n"])));
styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  margin-bottom: 30px !important;\n  margin-top: -30px;\n"], ["\n  margin-bottom: 30px !important;\n  margin-top: -30px;\n"])));
var StyledCurrencyTextInputSubtextContainer = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n"], ["\n  width: 90vw;\n  max-width: 624px;\n"])));
var StyledCurrencyTextInputSubtext = styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  margin-top: 48px;\n  text-align: left;\n\n  .boldText {\n    font-weight: 700;\n  }\n\n  .defaultText {\n    font-weight: 200 !important;\n  }\n\n  .interactiveText {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    width: 80vw;\n  }\n"], ["\n  margin-top: 48px;\n  text-align: left;\n\n  .boldText {\n    font-weight: 700;\n  }\n\n  .defaultText {\n    font-weight: 200 !important;\n  }\n\n  .interactiveText {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    width: 80vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var templateObject_1$i, templateObject_2$d, templateObject_3$7, templateObject_4$6, templateObject_5$6;

var CurrencyTextInput = function (_a) {
    var block = _a.block, data = _a.data;
    var values = useFormikContext().values;
    var setLocation = useFnolData().setLocation;
    var _b = data.field, name = _b.name, value = _b.value, _c = data.meta, error = _c.error, touched = _c.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (e) {
        var val = e.currentTarget.value;
        // Skip masking if removing characters. A user couldn't backspace past the
        // non-numeric characters
        if (!value || value.length < val.length) {
            val = formatDollar(val);
        }
        form.setFieldValue(block.id, val);
        form.setFieldTouched(block.id, true);
    }, [block.id, form, touched]);
    var handleBlur = useCallback(function (e) {
        form.setFieldValue(block.id, formatDollarToRequired(e.target.value));
        form.handleBlur(e);
    }, [form]);
    var handleOnClick = useCallback(function () {
        setLocation({ location: { section: 'sectionLossDetails', step: 'stepDeductibles' }, values: values });
    }, [form]);
    return (React.createElement(StyledTextContainer, null,
        React.createElement(TextInput$2, { id: "field".concat(block.id), type: "text", name: name, label: block.description, placeholder: block.placeholder, errorMessage: error, value: value, onChange: handleChange, onBlur: handleBlur, isError: !isValid, "aria-label": "currency text", className: "currencyText" }),
        React.createElement(StyledCurrencyTextInputSubtextContainer, null,
            React.createElement(StyledCurrencyTextInputSubtext, null,
                React.createElement(Span, { className: "boldText" },
                    "Heads up!",
                    ' ',
                    React.createElement(Span, { className: "defaultText", color: "quiet" },
                        "If your estimate amount is below your deductible you may end up paying for the work.",
                        ' ',
                        React.createElement(Span, { className: "interactiveText", color: "interactive", onClick: handleOnClick }, "Return to deductible info.")))))));
};

var monthMap = {
    January: 'JAN',
    February: 'FEB',
    March: 'MAR',
    April: 'APR',
    May: 'MAY',
    June: 'JUN',
    July: 'JUL',
    August: 'AUG',
    September: 'SEP',
    October: 'OCT',
    November: 'NOV',
    December: 'DEC',
};
var getFormattedDate = function (str) {
    if (!str) {
        return { formattedMonth: 'ERR', day: '00' };
    }
    var _a = str.split(' '), month = _a[0], day = _a[1];
    var formattedMonth = monthMap[month];
    if (!formattedMonth || !day) {
        return { formattedMonth: 'ERR', day: '00' };
    }
    return { formattedMonth: formattedMonth, day: day };
};

var StyledDraftBlockContainer = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n  max-width: 624px;\n  width: 90vw;\n\n  .draftHeader {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 36px;\n  }\n\n  .resume-text {\n    margin: 24px 0;\n  }\n\n  @media (max-width: ", ") {\n    .draftHeader {\n      font-size: 28px;\n    }\n\n    .resume-text {\n      margin: 32px 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .draftHeader {\n      font-size: 24px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n  max-width: 624px;\n  width: 90vw;\n\n  .draftHeader {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 36px;\n  }\n\n  .resume-text {\n    margin: 24px 0;\n  }\n\n  @media (max-width: ", ") {\n    .draftHeader {\n      font-size: 28px;\n    }\n\n    .resume-text {\n      margin: 32px 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .draftHeader {\n      font-size: 24px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledDraftSummaryContainer = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  display: flex;\n  background: #f3f5f7;\n  padding: 24px 32px;\n  border-radius: 12px;\n  width: 624px;\n\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n\n    .StyledCalendar {\n      margin-right: 0 !important;\n    }\n  }\n"], ["\n  display: flex;\n  background: #f3f5f7;\n  padding: 24px 32px;\n  border-radius: 12px;\n  width: 624px;\n\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n\n    .StyledCalendar {\n      margin-right: 0 !important;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledDetails = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n\n  .details {\n    margin-left: 12px;\n    font-size: 24px;\n    letter-spacing: normal;\n    font-weight: 500;\n  }\n\n  @media (max-width: ", ") {\n    .details {\n      font-size: 18px;\n      margin-left: 0;\n      text-align: center;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n\n  .details {\n    margin-left: 12px;\n    font-size: 24px;\n    letter-spacing: normal;\n    font-weight: 500;\n  }\n\n  @media (max-width: ", ") {\n    .details {\n      font-size: 18px;\n      margin-left: 0;\n      text-align: center;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledCalendar = styled.span(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: 24px;\n  max-width: 64px;\n  align-self: center;\n\n  .cal-body {\n    background: linear-gradient(135deg, #f9f9f9 0%, #efe6dd 100%);\n    font-size: 36px;\n    line-height: 42px;\n    border-radius: 0px 0px 12px 12px;\n    padding: 0 10px;\n    font-weight: 400;\n    box-shadow: 0px 1px 3px 0px #00000026;\n  }\n\n  @media (max-width: ", ") {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: 24px;\n  max-width: 64px;\n  align-self: center;\n\n  .cal-body {\n    background: linear-gradient(135deg, #f9f9f9 0%, #efe6dd 100%);\n    font-size: 36px;\n    line-height: 42px;\n    border-radius: 0px 0px 12px 12px;\n    padding: 0 10px;\n    font-weight: 400;\n    box-shadow: 0px 1px 3px 0px #00000026;\n  }\n\n  @media (max-width: ", ") {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledCalHeader = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  background: #409c8b;\n  border-radius: 12px 12px 0px 0px;\n  padding: 2px 12px;\n  box-shadow: 0px 1px 2px 0px #0000001a;\n  display: flex;\n  justify-content: center;\n\n  .cal-header {\n    color: white;\n    font-weight: 500;\n  }\n"], ["\n  background: #409c8b;\n  border-radius: 12px 12px 0px 0px;\n  padding: 2px 12px;\n  box-shadow: 0px 1px 2px 0px #0000001a;\n  display: flex;\n  justify-content: center;\n\n  .cal-header {\n    color: white;\n    font-weight: 500;\n  }\n"])));
var templateObject_1$h, templateObject_2$c, templateObject_3$6, templateObject_4$5, templateObject_5$5;

var DraftBlock = function (_a) {
    var consultativeFnol = _a.consultativeFnol;
    if (!consultativeFnol || !(consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.draftFnols))
        return null;
    var draft = consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.draftFnols[0];
    var _b = getFormattedDate(draft.lossDtString), formattedMonth = _b.formattedMonth, day = _b.day;
    // If icons are added back into design uncomment the following
    // const { iconUrl, label }  = getIconAndLabelFromDraftLossType(draft.lossType);
    return (React.createElement(StyledDraftBlockContainer, null,
        React.createElement(Heading, { size: "md", tag: "h2", "data-testid": "draft-header", className: "draftHeader" }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['get-started-resume-title']),
        React.createElement(Span, { className: "resume-text" }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['get-started-resume-text']),
        React.createElement(StyledDraftSummaryContainer, null,
            React.createElement(StyledCalendar, null,
                React.createElement(StyledCalHeader, null,
                    React.createElement(Span, { className: "cal-header" }, formattedMonth)),
                React.createElement(Span, { className: "cal-body" }, day)),
            React.createElement(StyledDetails, null,
                React.createElement(Span, { className: "details" }, draft === null || draft === void 0 ? void 0 : draft.lossType)))));
};

var IconCalendar = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#134e4a' : _b, _c = _a.height, height = _c === void 0 ? '20' : _c, _d = _a.width, width = _d === void 0 ? '19' : _d;
    return (React.createElement(Svg, { width: width, height: height, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M16.6361 2H15.617V0H13.5787V2H5.42546V0H3.38716V2H2.36801C1.23676 2 0.339903 2.9 0.339903 4L0.329712 18C0.329712 19.1 1.23676 20 2.36801 20H16.6361C17.7572 20 18.6744 19.1 18.6744 18V4C18.6744 2.9 17.7572 2 16.6361 2ZM16.6361 18H2.36801V7H16.6361V18Z", fill: color })));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* DayPicker styles */\n\n.DayPicker {\n  display: inline-block;\n  font-size: 1rem;\n}\n\n.DayPicker-wrapper {\n  position: relative;\n\n  flex-direction: row;\n  padding-bottom: 1em;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-Months {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.DayPicker-Month {\n  display: table;\n  margin: 0 1em;\n  margin-top: 1em;\n  border-spacing: 0;\n  border-collapse: collapse;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-NavBar {\n}\n\n.DayPicker-NavButton {\n  position: absolute;\n  top: 1em;\n  right: 1.5em;\n  left: auto;\n\n  display: inline-block;\n  margin-top: 2px;\n  width: 1.25em;\n  height: 1.25em;\n  background-position: center;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  color: #8B9898;\n  cursor: pointer;\n}\n\n.DayPicker-NavButton:hover {\n  opacity: 0.8;\n}\n\n.DayPicker-NavButton--prev {\n  margin-right: 1.5em;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');\n}\n\n.DayPicker-NavButton--next {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');\n}\n\n.DayPicker-NavButton--interactionDisabled {\n  display: none;\n}\n\n.DayPicker-Caption {\n  display: table-caption;\n  margin-bottom: 0.5em;\n  padding: 0 0.5em;\n  text-align: left;\n}\n\n.DayPicker-Caption > div {\n  font-weight: 500;\n  font-size: 1.15em;\n}\n\n.DayPicker-Weekdays {\n  display: table-header-group;\n  margin-top: 1em;\n}\n\n.DayPicker-WeekdaysRow {\n  display: table-row;\n}\n\n.DayPicker-Weekday {\n  display: table-cell;\n  padding: 0.5em;\n  color: #8B9898;\n  text-align: center;\n  font-size: 0.875em;\n}\n\n.DayPicker-Weekday abbr[title] {\n  border-bottom: none;\n  text-decoration: none;\n}\n\n.DayPicker-Body {\n  display: table-row-group;\n}\n\n.DayPicker-Week {\n  display: table-row;\n}\n\n.DayPicker-Day {\n  display: table-cell;\n  padding: 0.5em;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n\n.DayPicker-WeekNumber {\n  display: table-cell;\n  padding: 0.5em;\n  min-width: 1em;\n  border-right: 1px solid #EAECEC;\n  color: #8B9898;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 0.75em;\n  cursor: pointer;\n}\n\n.DayPicker--interactionDisabled .DayPicker-Day {\n  cursor: default;\n}\n\n.DayPicker-Footer {\n  padding-top: 0.5em;\n}\n\n.DayPicker-TodayButton {\n  border: none;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  color: #4A90E2;\n  font-size: 0.875em;\n  cursor: pointer;\n}\n\n/* Default modifiers */\n\n.DayPicker-Day--today {\n  color: #D0021B;\n  font-weight: 700;\n}\n\n.DayPicker-Day--outside {\n  color: #8B9898;\n  cursor: default;\n}\n\n.DayPicker-Day--disabled {\n  color: #DCE0E0;\n  cursor: default;\n  /* background-color: #eff1f1; */\n}\n\n/* Example modifiers */\n\n.DayPicker-Day--sunday {\n  background-color: #F7F8F8;\n}\n\n.DayPicker-Day--sunday:not(.DayPicker-Day--today) {\n  color: #DCE0E0;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  position: relative;\n\n  background-color: #4A90E2;\n  color: #F0F8FF;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {\n  background-color: #51A0FA;\n}\n\n.DayPicker:not(.DayPicker--interactionDisabled)\n  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n  background-color: #F0F8FF;\n}\n\n/* DayPickerInput */\n\n.DayPickerInput {\n  display: inline-block;\n}\n\n.DayPickerInput-OverlayWrapper {\n  position: relative;\n}\n\n.DayPickerInput-Overlay {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n\n  background: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}\n";
styleInject(css_248z$1);

var HiddenLabel = styled.label(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var StyledDateControlContainer = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: contents;\n\n  .DayPicker-Day--selected {\n    background: #134e4a !important;\n    border-radius: 100%;\n    padding: 0em !important;\n    min-height: 40px !important;\n    min-width: 40px !important;\n  }\n\n  .DayPicker-Day--today {\n    color: #134e4a !important;\n\n    &.DayPicker-Day--selected {\n      color: white !important;\n    }\n  }\n"], ["\n  display: contents;\n\n  .DayPicker-Day--selected {\n    background: #134e4a !important;\n    border-radius: 100%;\n    padding: 0em !important;\n    min-height: 40px !important;\n    min-width: 40px !important;\n  }\n\n  .DayPicker-Day--today {\n    color: #134e4a !important;\n\n    &.DayPicker-Day--selected {\n      color: white !important;\n    }\n  }\n"])));
var DateControl = function (_a) {
    var block = _a.block, placeholder = _a.placeholder, children = _a.children;
    var formik = useFormikContext();
    var handleValidate = useCallback(function (value) {
        if (block.required && !hasRequiredValue(value)) {
            return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
        }
        if (!isValidDate(value)) {
            return 'Invalid date. Please use format mm/dd/yyyy.';
        }
        if (!doesDateExist(value)) {
            return 'Date does not exist. Please select a different day.';
        }
        var now = new Date();
        var input = new Date(value.split('/'));
        if (now < input) {
            return 'Invalid date. Date cannot be in the future.';
        }
    }, [block.error, block.required]);
    return (React.createElement(React.Fragment, null, children &&
        children({
            dateInput: (React.createElement(Field, { name: block.id, block: block.id, blockId: block.id, placeholder: placeholder, component: FormDateComponent, validate: handleValidate, label: block.a11yLabel ? block.a11yLabel : block.description })),
            isValid: formik.touched[block.id] && formik.errors[block.id] ? false : true,
        })));
};
function FormDateComponent(_a) {
    var _this = this;
    var field = _a.field, form = _a.form, props = __rest(_a, ["field", "form"]);
    var handleDayChange = useCallback(function (_day, _modifiers, dayPickerInput) { return __awaiter(_this, void 0, void 0, function () {
        var input;
        return __generator(this, function (_a) {
            input = dayPickerInput.getInput().value.trim();
            if (input != null) {
                form.setFieldValue(field.name, input);
                form.setFieldTouched(field.name);
            }
            return [2 /*return*/];
        });
    }); }, [field.name, form]);
    function parseDate(str, format) {
        var parsed = dateFnsParse(str, format, new Date());
        if (DateUtils.isDate(parsed)) {
            return parsed;
        }
    }
    function formatDate(date, format) {
        return dateFnsFormat(date, format);
    }
    return (React.createElement(StyledDateControlContainer, null,
        React.createElement(HiddenLabel, { id: "datelabel" }, props.label),
        React.createElement(DayPickerInput, { "aria-labelledby": "datelabel", placeholder: props.placeholder, formatDate: formatDate, parseDate: parseDate, format: "MM/dd/yyyy", onDayChange: handleDayChange, value: form.values[props.blockId], dayPickerProps: {
                disabledDays: function (day) {
                    var tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    tomorrow.setHours(0, 0, 0, 0);
                    return day > tomorrow;
                },
            } })));
}
var templateObject_1$g, templateObject_2$b;

var StyledTimeBlockContainer = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  align-items: flex-start;\n  text-wrap: pretty;\n\n  .TimeWrapper {\n      flex-flow: column !important;\n    }\n\n  @media (max-width: ", ") {\n    div[class*='TimeWrapper'] {\n      flex-flow: row wrap;\n    }\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  align-items: flex-start;\n  text-wrap: pretty;\n\n  .TimeWrapper {\n      flex-flow: column !important;\n    }\n\n  @media (max-width: ", ") {\n    div[class*='TimeWrapper'] {\n      flex-flow: row wrap;\n    }\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledTimeTitle = styled.h4(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  margin-top: 0 !important;\n  font-weight: 500 !important;\n  max-width: 624px;\n  text-align: left !important;\n  margin-bottom: 24px !important;\n\n  @media (max-width: ", ") {\n    word-break: break-word;\n  }\n"], ["\n  margin-top: 0 !important;\n  font-weight: 500 !important;\n  max-width: 624px;\n  text-align: left !important;\n  margin-bottom: 24px !important;\n\n  @media (max-width: ", ") {\n    word-break: break-word;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledTimeWrapper = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  width: auto;\n  max-width: 300px;\n  flex-direction: row;\n  justify-content: center;\n\n  .timeInput {\n    max-width: 300px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n    justify-content: center;\n    .timeInput {\n      max-width: 624px;\n      width: 90vw;\n    }\n\n    p {\n      margin: 0 !important;\n      margin-top: 10px !important;\n    }\n  }\n"], ["\n  width: auto;\n  max-width: 300px;\n  flex-direction: row;\n  justify-content: center;\n\n  .timeInput {\n    max-width: 300px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n    justify-content: center;\n    .timeInput {\n      max-width: 624px;\n      width: 90vw;\n    }\n\n    p {\n      margin: 0 !important;\n      margin-top: 10px !important;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledRadioGroupWrapper = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  max-width: 200px;\n\n  label {\n    margin-left: 20px !important;\n  }\n\n  @media (max-width: ", ") {\n    label {\n      margin-left: 10px !important;\n      margin-right: 10px !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    label {\n      margin-left: 5px !important;\n      margin-right: 5px !important;\n    }\n  }\n"], ["\n  max-width: 200px;\n\n  label {\n    margin-left: 20px !important;\n  }\n\n  @media (max-width: ", ") {\n    label {\n      margin-left: 10px !important;\n      margin-right: 10px !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    label {\n      margin-left: 5px !important;\n      margin-right: 5px !important;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledDateBlockContentContainer = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  max-width: 624px;\n\n  .DayPickerInput > input {\n    border: 1px solid ", ";\n    cursor: pointer;\n    border-radius: 8px;\n    max-width: 624px;\n    min-width: 624px;\n\n    &:hover {\n      border: 1px solid ", ";\n    }\n  }\n\n  .DayPicker-Day--selected {\n    background: #134e4a !important;\n    border-radius: 100%;\n    padding: 0em !important;\n    height: 40px;\n    width: 40px;\n  }\n\n  .DayPicker-Day--today {\n    color: #134e4a !important;\n\n    &.DayPicker-Day--selected {\n      color: white !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .DayPickerInput > input {\n      width: 90vw;\n      margin: 0 auto;\n      max-width: 624px;\n      min-width: unset;\n    }\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  max-width: 624px;\n\n  .DayPickerInput > input {\n    border: 1px solid ", ";\n    cursor: pointer;\n    border-radius: 8px;\n    max-width: 624px;\n    min-width: 624px;\n\n    &:hover {\n      border: 1px solid ", ";\n    }\n  }\n\n  .DayPicker-Day--selected {\n    background: #134e4a !important;\n    border-radius: 100%;\n    padding: 0em !important;\n    height: 40px;\n    width: 40px;\n  }\n\n  .DayPicker-Day--today {\n    color: #134e4a !important;\n\n    &.DayPicker-Day--selected {\n      color: white !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .DayPickerInput > input {\n      width: 90vw;\n      margin: 0 auto;\n      max-width: 624px;\n      min-width: unset;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralLight;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralDark;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
});
var StyledDateBlockContainer = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var StyledDate = styled.label(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  position: relative;\n\n  input {\n    padding: 12px 16px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    font-size: 16px;\n    line-height: 24px;\n    color: ", ";\n  }\n\n  svg {\n    position: absolute;\n    right: 0;\n    top: 0;\n    transform: translate(-50%, 0%);\n    height: 100% !important;\n  }\n\n  /* DayPicker styles for calendar - overwriting from DayPicker style.css */\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .DayPicker:not(.DayPicker--interactionDisabled)\n    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(\n      .DayPicker-Day--outside\n    ):hover {\n    background-color: ", ";\n  }\n\n  .DayPicker-Day--today {\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n    input {\n      width: 90vw;\n    }\n  }\n"], ["\n  position: relative;\n\n  input {\n    padding: 12px 16px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    font-size: 16px;\n    line-height: 24px;\n    color: ", ";\n  }\n\n  svg {\n    position: absolute;\n    right: 0;\n    top: 0;\n    transform: translate(-50%, 0%);\n    height: 100% !important;\n  }\n\n  /* DayPicker styles for calendar - overwriting from DayPicker style.css */\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .DayPicker:not(.DayPicker--interactionDisabled)\n    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(\n      .DayPicker-Day--outside\n    ):hover {\n    background-color: ", ";\n  }\n\n  .DayPicker-Day--today {\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n    input {\n      width: 90vw;\n    }\n  }\n"])), function (_a) {
    var _b, _c;
    var valid = _a.valid, theme = _a.theme;
    return (valid ? (_b = theme.border) === null || _b === void 0 ? void 0 : _b.accent : (_c = theme.border) === null || _c === void 0 ? void 0 : _c.danger);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.interactive;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.inverse;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.canvas;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.interactive;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var templateObject_1$f, templateObject_2$a, templateObject_3$5, templateObject_4$4, templateObject_5$4, templateObject_6$3, templateObject_7$3;

var DateBlock = function (_a) {
    var block = _a.block;
    return (React.createElement(DateControl, { block: block, placeholder: "MM/DD/YYYY" }, function (content) { return (React.createElement(StyledDateBlockContentContainer, null,
        React.createElement(StyledDateBlockContainer, null,
            React.createElement(StyledDate, { valid: content.isValid },
                content.dateInput,
                React.createElement(IconCalendar, null))),
        React.createElement(PHErrorMessage, { blockId: block.id }))); }));
};

var DisclosureButton = styled.button(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-weight: 700;\n  text-align: left;\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-weight: 700;\n  text-align: left;\n"])));
var IconWrapper = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n  transform: ", ";\n"], ["\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n  transform: ", ";\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'rotate(180deg)' : 'rotate(0deg)');
});
var DisclosurePanel = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  transition-property: all;\n  transition-timing-function: ease-out;\n  transition-duration: 200ms;\n  max-height: ", ";\n  margin-top: ", ";\n  visibility: ", ";\n  overflow: hidden;\n"], ["\n  transition-property: all;\n  transition-timing-function: ease-out;\n  transition-duration: 200ms;\n  max-height: ", ";\n  margin-top: ", ";\n  visibility: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var open = _a.open, height = _a.height;
    return (open ? height : 0);
}, function (_a) {
    var open = _a.open;
    return (open ? '8px' : 0);
}, function (_a) {
    var open = _a.open;
    return (open ? 'visible' : 'hidden');
});
var TextContent = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  white-space: pre-wrap;\n"], ["\n  white-space: pre-wrap;\n"])));
var NoteContent = styled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  margin-top: 32px;\n  white-space: pre-wrap;\n  font-size: 14px;\n  line-height: 22px;\n  font-style: italic;\n  color: #191919;\n"], ["\n  margin-top: 32px;\n  white-space: pre-wrap;\n  font-size: 14px;\n  line-height: 22px;\n  font-style: italic;\n  color: #191919;\n"])));
function Faqs(_a) {
    var _b;
    var note = _a.note, text = _a.text, title = _a.title;
    var ref = useRef(null);
    var _c = useState(false), open = _c[0], setIsOpen = _c[1];
    var handleClick = function (e) {
        e.preventDefault(); // required: without it was triggering the submission of a form
        setIsOpen(!open);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DisclosureButton, { onClick: handleClick },
            title,
            React.createElement(IconWrapper, { open: open },
                React.createElement(UiIcon, { name: "ArrowDown" }))),
        React.createElement(DisclosurePanel, { ref: ref, open: open, height: ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + 'px' },
            React.createElement(TextContent, { dangerouslySetInnerHTML: { __html: text } }),
            note && React.createElement(NoteContent, { dangerouslySetInnerHTML: { __html: note } })),
        React.createElement(Hr, null)));
}
var templateObject_1$e, templateObject_2$9, templateObject_3$4, templateObject_4$3, templateObject_5$3;

var SpinnerContainer = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 25vh;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 25vh;\n"])));
var LoadingSpinner = function () { return (React.createElement(SpinnerContainer, null,
    React.createElement(Spinner, null))); };
var templateObject_1$d;

var StyledDeductibleBlockContainer = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n  text-align: left;\n\n  .deductiblesHeader {\n    word-break: break-word;\n  }\n"], ["\n  width: 90vw;\n  max-width: 624px;\n  text-align: left;\n\n  .deductiblesHeader {\n    word-break: break-word;\n  }\n"])));
var StyledDeductiblesContainer = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  margin: 32px auto 48px auto;\n  display: flex;\n  flex-flow: row wrap;\n  border-radius: 8px;\n  justify-content: flex-start;\n\n  @media (max-width: ", ") {\n    width: 100%;\n    margin-bottom: 16px;\n  }\n"], ["\n  margin: 32px auto 48px auto;\n  display: flex;\n  flex-flow: row wrap;\n  border-radius: 8px;\n  justify-content: flex-start;\n\n  @media (max-width: ", ") {\n    width: 100%;\n    margin-bottom: 16px;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledDeductibleItem = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column wrap;\n  align-items: center;\n  justify-content: center;\n  color: #58595b;\n  background-color: #F3F5F7;\n  padding: 32px;\n  margin-right: 12px;\n  margin-bottom: 12px;\n  width: 190px;\n  border-radius: 8px;\n\n  @media (max-width: ", ") {\n    max-width: 624px;\n    width: 90vw;\n  }\n"], ["\n  display: flex;\n  flex-flow: column wrap;\n  align-items: center;\n  justify-content: center;\n  color: #58595b;\n  background-color: #F3F5F7;\n  padding: 32px;\n  margin-right: 12px;\n  margin-bottom: 12px;\n  width: 190px;\n  border-radius: 8px;\n\n  @media (max-width: ", ") {\n    max-width: 624px;\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var DLabel = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 32px;\n  text-align: left !important;\n  width: 100%;\n"], ["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 32px;\n  text-align: left !important;\n  width: 100%;\n"])));
var DValues = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  // white-space: nowrap;\n  color: ", ";\n  text-align: left !important;\n  width: 100%;\n\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-left: 8px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  // white-space: nowrap;\n  color: ", ";\n  text-align: left !important;\n  width: 100%;\n\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-left: 8px;\n  }\n"])), function (_a) {
    var error = _a.error;
    return (error ? '#BF2324' : 'black');
});
var ValueLabel = styled.span(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\nfont-size: 24px;\nline-height: 32px;\nfont-weight: 500;\n"], ["\nfont-size: 24px;\nline-height: 32px;\nfont-weight: 500;\n"])));
var FaqContainer = styled.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var HaveQuestions = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  margin-top: 48px;\n"], ["\n  margin-top: 48px;\n"])));
var StyledAgentContainer = styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  margin-top: 24px;\n  margin-bottom: 56px;\n  display: flex;\n  flex-direction: column;\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  padding: 32px;\n\n  .agentInfo {\n    display: flex;\n    font-weight: 700;\n    margin-bottom: 4px;\n\n    > svg {\n        margin-right: 10px;\n        min-width: 20px;\n    }\n  }\n\n  > a {\n    margin-top: 12px;\n    width: max-content;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n\n  @media (max-width: ", ") {\n    padding: 24px;\n\n    > a {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: auto;\n    }\n  }\n"], ["\n  margin-top: 24px;\n  margin-bottom: 56px;\n  display: flex;\n  flex-direction: column;\n  background-color: #F3F5F7;\n  border-radius: 8px;\n  padding: 32px;\n\n  .agentInfo {\n    display: flex;\n    font-weight: 700;\n    margin-bottom: 4px;\n\n    > svg {\n        margin-right: 10px;\n        min-width: 20px;\n    }\n  }\n\n  > a {\n    margin-top: 12px;\n    width: max-content;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n\n  @media (max-width: ", ") {\n    padding: 24px;\n\n    > a {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: auto;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledContentContainer$1 = styled.div(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n"])));
var StyledAlertContainer = styled.div(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  margin: 0 0 48px;\n  text-align: left;\n\n  @media (max-width: ", ") {\n    margin: 0 0 24px 0;\n  }\n"], ["\n  margin: 0 0 48px;\n  text-align: left;\n\n  @media (max-width: ", ") {\n    margin: 0 0 24px 0;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledAlertDescription = styled.span(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  overflow-wrap: anywhere !important;\n"], ["\n  overflow-wrap: anywhere !important;\n"])));
var templateObject_1$c, templateObject_2$8, templateObject_3$3, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$2, templateObject_12$2;

var DeductiblesBlock = function (_a) {
    var loading = _a.loading, deductibles = _a.deductibles, consultativeFnol = _a.consultativeFnol;
    var renderDeductibles = function () {
        if (!deductibles || !(deductibles === null || deductibles === void 0 ? void 0 : deductibles.deductibles.length)) {
            return React.createElement(Span, null, "No deductibles found");
        }
        return deductibles === null || deductibles === void 0 ? void 0 : deductibles.deductibles.map(function (item, i) { return (React.createElement(StyledDeductibleItem, { key: i },
            React.createElement(DLabel, null, item.deductibleTypeLabel),
            React.createElement(DValues, { error: item.error },
                React.createElement(ValueLabel, null, item.valueLabel),
                item.detail && (React.createElement(Tooltip, { content: item.detail },
                    React.createElement(UiIcon, { size: "xs", name: "".concat(item.error ? 'Danger' : 'InformationSubtle') })))))); });
    };
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(StyledDeductibleBlockContainer, null,
        React.createElement(StyledAlertContainer, null,
            React.createElement(Alert, { appearance: "warning", title: "Heads up!", description: React.createElement(StyledAlertDescription, null, "You might decide not to proceed if you know that your repair/replacement costs are below your deductible. If you aren\u2019t sure, we suggest calling your insurance rep to help you make the best decision. Their contact info is displayed below.") })),
        React.createElement(Heading, { size: "lg", tag: "h2", className: 'deductiblesHeader' }, "Here are your deductibles"),
        React.createElement(StyledDeductiblesContainer, null, renderDeductibles()),
        React.createElement(StyledContentContainer$1, null,
            React.createElement(FaqContainer, null,
                React.createElement(Heading, { size: "md", tag: "h3", className: 'deductiblesHeader' }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['deductibles-faq-main-title']),
                React.createElement(Hr, null),
                (consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants.faqs).map(function (faq, i) { return (React.createElement(Faqs, __assign({ key: i }, faq))); })),
            React.createElement(HaveQuestions, null, "Questions? We encourage you to reach out to your insurance representative for questions related to your policy coverage and deductibles prior to filing:"),
            React.createElement(StyledAgentContainer, null,
                React.createElement("div", { className: "agentInfo" },
                    React.createElement(SpotIcon, { name: "Building", size: "xs" }), consultativeFnol === null || consultativeFnol === void 0 ? void 0 :
                    consultativeFnol.agent.agencyName),
                React.createElement(Link, { leadingIcon: "Envelope", href: "mailto:".concat(consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.agent.email) }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.agent.email),
                React.createElement(Link, { leadingIcon: "Phone", href: "tel:".concat(consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.agent.phone) }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.agent.phone)))));
};

var DeductiblesBlockWrapper = function () {
    var _a = useState(), subLossType = _a[0], setLossSubType = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var state = useFnolData();
    var consultativeFnol = state.consultativeFnol, policyId = state.policy.policyId, sendPost = state.sendPost, setDeductibles = state.setDeductibles, deductibles = state.deductibles, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, setDraftBeingEdited = state.setDraftBeingEdited, hydratingDraft = state.hydratingDraft;
    var formik = useFormikContext();
    var values = formik.values;
    var lossDate = values.lossDate, lossType = values.lossType;
    // TODO: this code was copied and trimmed down a bit but still room to improve:
    // explore reducing the multiple useEffects to cut down on re-renders
    useEffect(function () {
        var subLossKey = getLossSubTypeKey(values);
        if (subLossKey) {
            // @ts-ignore type issue with FormFields
            setLossSubType(values[subLossKey]);
        }
    }, [values]);
    var saveDraft = useCallback(function (exitReason) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = generateSubmitDraftBody(formik.values, state, {
                        exitStepNumber: 1,
                        exitReason: exitReason,
                    }, user || '', source, draftBeingEdited || undefined);
                    return [4 /*yield*/, sendPost(payload)];
                case 1:
                    data = (_a.sent()).data;
                    setDraftBeingEdited(data);
                    return [2 /*return*/];
            }
        });
    }); }, [formik.values, state, user, source, draftBeingEdited, sendPost, setDraftBeingEdited]);
    useEffect(function () {
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, sendPost(deductiblesBody(policyId, lossDate, lossType, subLossType))];
                    case 1:
                        data = (_a.sent()).data;
                        setDeductibles(data);
                        setLoading(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.warn('Query Error', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
    }, []);
    useEffect(function () {
        if (!loading && !hydratingDraft && !formik.values.deductiblesShownToCustomer) {
            formik.setFieldValue('deductiblesShownToCustomer', true);
            saveDraft('MSS: Deductibles shown to customer');
        }
    }, [loading, hydratingDraft]);
    return (React.createElement(DeductiblesBlock, { loading: loading, 
        //   @ts-ignore -- readonly issue between prop types here
        consultativeFnol: consultativeFnol, 
        //   @ts-ignore -- readonly issue between prop types here
        deductibles: deductibles }));
};

var IconClear = function (_a) {
    var className = _a.className, _b = _a.height, height = _b === void 0 ? '16' : _b, _c = _a.width, width = _c === void 0 ? '16' : _c;
    return (React.createElement(Svg, { className: className, height: height, viewBox: "0 0 16 16", width: width, stroke: 'currentColor', xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "iconTitle" }, "Remove Item"),
        React.createElement("desc", { id: "iconDesc" }, "An icon to represent a clear or delete button."),
        React.createElement("path", { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "2.667", d: "M.5 8c0 4.1 3.4 7.5 7.5 7.5s7.5-3.4 7.5-7.5c0 0 0 0 0 0C15.5 3.9 12.1.5 8 .5S.5 3.9.5 8c0 0 0 0 0 0zM5 11l6-6m0 6L5 5" })));
};

var GroupBlock = function (_a) {
    var _b;
    var block = _a.block;
    var formik = useFormikContext();
    var isContactPageGroup = block.id === 'groupContact';
    var isAlternateField = block.id === 'groupContactAddPhone';
    var handleRemove = function () {
        var _a;
        (_a = block.resetOnRemove) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
            formik.setFieldValue(field, '');
        });
    };
    return (React.createElement(StyledGroup, { id: block.id, className: classNames({ isContactPageGroup: isContactPageGroup }) },
        block.title && React.createElement("h4", null, block.title),
        block.description && React.createElement("p", null, block.description),
        block.children &&
            ((_b = block.children) === null || _b === void 0 ? void 0 : _b.map(function (child) {
                var isEmailField = child.id === 'contactEmail';
                return (React.createElement(BlockWrapper, { key: child.id, className: classNames({ isContactPageGroup: isContactPageGroup, isEmailField: isEmailField, isAlternateField: isAlternateField }) },
                    React.createElement(FormBlock, { block: child, key: child.id })));
            })),
        block.removable && (React.createElement(RemoveButton, { onClick: handleRemove, className: classNames({ isContactPageGroup: isContactPageGroup, removeButton: true }), "data-testid": "removeButton" },
            React.createElement(IconClear, { className: "omit-hover", height: "20", width: "20" })))));
};

var StyledLinkBlockContainer = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n  margin-bottom: 100px;\n\n  button {\n    display: flex;\n    text-align: left;\n  }\n"], ["\n  width: 90vw;\n  max-width: 624px;\n  margin-bottom: 100px;\n\n  button {\n    display: flex;\n    text-align: left;\n  }\n"])));
var templateObject_1$b;

var LinkBlock = function (_a) {
    var block = _a.block, form = _a.data.form;
    var setValue = function (val) {
        form.setFieldValue(block.id, val);
        form.setFieldTouched(block.id);
    };
    var handleOnClick = function (e) {
        e.preventDefault();
        setValue(true);
    };
    return (React.createElement(StyledLinkBlockContainer, { "data-testid": "link-block" },
        React.createElement(Button, { appearance: "link", onClick: handleOnClick, leadingIcon: "AddCircle" }, block.description)));
};

var MessageControl = function (_a) {
    var block = _a.block, children = _a.children;
    var policy = useFnolData().policy;
    var content = block.content || "";
    var message = Mustache.render(content, policy);
    var sanitizedContent = dompurify.sanitize(message);
    var formik = useFormikContext();
    var isFutureClaim = block.id === 'futureClaim';
    useEffect(function () {
        if (isFutureClaim) {
            formik.touched.lossTime = true;
            formik.errors.lossTime = ' ';
        }
        return function () {
            if (isFutureClaim) {
                formik.touched.lossTime = false;
                delete formik.errors.lossTime;
            }
        };
    }, [isFutureClaim]);
    return React.createElement("div", null, children && children(sanitizedContent));
};

var IconWarningCircle = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? '#FF8200' : _b, _c = _a.height, height = _c === void 0 ? '16' : _c, _d = _a.width, width = _d === void 0 ? '16' : _d;
    return (React.createElement(Svg, { className: className, fill: "none", height: height, viewBox: "0 0 16 16", width: width, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "iconTitle" }, "Icon Warning"),
        React.createElement("desc", { id: "iconDesc" }, "An icon to show a warning message"),
        React.createElement("path", { d: "M7.2 10.4H8.8V12H7.2V10.4ZM7.2 4H8.8V8.8H7.2V4ZM7.992 0C3.576 0 0 3.584 0 8C0 12.416 3.576 16 7.992 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 7.992 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z", fill: color })));
};

var CUSTOM_STYLE_BLOCKS = ['msgLossAddress', 'msgPolicyholderInfo', 'lossDateAgeCheck'];

// TODO: update src/form-def-transforms.json for step title
// Block ID's for this component: policyVerificationMessage, honestyMessage, message-intro
var MessageBlock = function (_a) {
    var block = _a.block;
    if (block.id === 'policyVerificationMessage') {
        return React.createElement(PolicyCard, null);
    }
    var hasAdditionalStyling = CUSTOM_STYLE_BLOCKS.includes(block.id);
    var isMitigationDeclineText = block.id === 'message-mitigation-decline-confirmation';
    var falseContent = '<p><b></b><br><b></b></p>';
    return (React.createElement(MessageControl, { block: block }, function (sanitizedContent) { return (React.createElement(StyledMessage, { "data-testid": "message-block" },
        block.warning && (React.createElement(StyledWarningContainer, null,
            React.createElement(IconWarningCircle, null),
            block.warning)),
        block.title && (React.createElement(Heading, { tag: "h4", size: "md", className: "messageHeader" }, block.title)),
        sanitizedContent && sanitizedContent !== falseContent && React.createElement("div", { className: classNames({
                messageBody: true,
                hasAdditionalStyling: hasAdditionalStyling,
                isMitigationDeclineText: isMitigationDeclineText,
            }), dangerouslySetInnerHTML: { __html: sanitizedContent } }))); }));
};

var formatMitigationServiceOptions = function (eligibleServices, mitigationServices) {
    if (!(eligibleServices === null || eligibleServices === void 0 ? void 0 : eligibleServices.length) || !mitigationServices)
        return [];
    return eligibleServices.map(function (service) {
        var _a;
        var recommendedEligibleService = (_a = mitigationServices.constants) === null || _a === void 0 ? void 0 : _a.recommendedServices[service.apiKey];
        return {
            title: recommendedEligibleService.serviceName,
            value: service.id,
            description: recommendedEligibleService.copy,
        };
    });
};

var mitigations = [
    MITIGATION_FIELD_DEBRIS_REMOVAL,
    MITIGATION_FIELD_REJECT_ALL,
    MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY,
    MITIGATION_FIELD_SMOKE_FOR_STRUCTURE,
    MITIGATION_FIELD_TARPING,
    MITIGATION_FIELD_WATER,
];
var MitigationServiceCard = function (_a) {
    var block = _a.block, eligibleServices = _a.eligibleServices, data = _a.data, loading = _a.loading;
    var name = data.field.name, _b = data.form, setFieldValue = _b.setFieldValue, validateField = _b.validateField, values = _b.values;
    var truthyFormMitigations = mitigations.filter(function (key) { return values[key]; });
    var _c = useState(truthyFormMitigations), selectedValues = _c[0], setSelectedValues = _c[1];
    var mitigationServices = useFnolData().mitigationServices;
    var mitigationEligibility = mitigationServices.mitigationEligibility;
    var updateMitigationValuesFromForm = function () {
        setSelectedValues(truthyFormMitigations);
    };
    var updateFormValues = function (selection) {
        // loop through all mitigations
        // if the form value is true + the key is in the selection array then do nothing
        // if the form value is false + the key is not the selection array then do nothing
        for (var _i = 0, mitigations_1 = mitigations; _i < mitigations_1.length; _i++) {
            var key = mitigations_1[_i];
            // if the form value is true + the key is not the selection array then set it in form to false
            if ((values === null || values === void 0 ? void 0 : values[key]) && !(selection === null || selection === void 0 ? void 0 : selection.includes(key))) {
                setFieldValue(key, false);
            }
            // if the form value is false + the key is in the selection array then set it in form to true
            if (!(values === null || values === void 0 ? void 0 : values[key]) && (selection === null || selection === void 0 ? void 0 : selection.includes(key))) {
                setFieldValue(key, true);
            }
        }
    };
    useEffect(function () {
        updateMitigationValuesFromForm();
    }, [loading, values]);
    var handleChange = function (selection) {
        setSelectedValues(selection);
        updateFormValues(selection);
    };
    var handleOnCardClick = function (blockId) {
        if (MITIGATION_FIELD_DEBRIS_REMOVAL !== blockId &&
            mitigationEligibility.debrisRemoval &&
            !(values === null || values === void 0 ? void 0 : values[MITIGATION_FIELD_DEBRIS_REMOVAL])) {
            setFieldValue(MITIGATION_FIELD_DEBRIS_REMOVAL, false);
        }
        if (MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY !== blockId &&
            mitigationEligibility.smokeForPersonalProperty &&
            !(values === null || values === void 0 ? void 0 : values[MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY])) {
            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY, false);
        }
        if (MITIGATION_FIELD_SMOKE_FOR_STRUCTURE !== blockId &&
            mitigationEligibility.smokeForStructure &&
            !(values === null || values === void 0 ? void 0 : values[MITIGATION_FIELD_SMOKE_FOR_STRUCTURE])) {
            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_STRUCTURE, false);
        }
        if (MITIGATION_FIELD_TARPING !== blockId &&
            mitigationEligibility.tarping &&
            !(values === null || values === void 0 ? void 0 : values[MITIGATION_FIELD_TARPING])) {
            setFieldValue(MITIGATION_FIELD_TARPING, false);
        }
        if (MITIGATION_FIELD_WATER !== blockId &&
            mitigationEligibility.waterMitigation &&
            !(values === null || values === void 0 ? void 0 : values[MITIGATION_FIELD_WATER])) {
            setFieldValue(MITIGATION_FIELD_WATER, false);
        }
        // This is done to ensure formik values are updated in time and we dont use stale inputs
        setTimeout(function () {
            validateField(MITIGATION_FIELD_REJECT_ALL);
        }, 100);
    };
    var options = formatMitigationServiceOptions(eligibleServices, mitigationServices);
    return (React.createElement(CheckboxGroup, { id: "field".concat(block.id), name: name, value: selectedValues, onChange: handleChange, "aria-label": "mitigation selection" }, options.map(function (opt) { return (React.createElement("div", { onClick: function () { return handleOnCardClick(opt.value); }, key: opt.value },
        React.createElement(CheckboxGroup.Card, __assign({}, opt, { className: "option" })))); })));
};

var StyledBlockContainer = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n\n  .mitigationHeader {\n    margin: 0px auto 32px !important;\n    font-weight: 500;\n    text-align: left;\n    font-size: 32px;\n  }\n\n  @media (max-width: ", ") {\n    .mitigationHeader {\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .mitigationHeader {\n      font-size: 24px;\n    }\n  }\n"], ["\n  width: 90vw;\n  max-width: 624px;\n\n  .mitigationHeader {\n    margin: 0px auto 32px !important;\n    font-weight: 500;\n    text-align: left;\n    font-size: 32px;\n  }\n\n  @media (max-width: ", ") {\n    .mitigationHeader {\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .mitigationHeader {\n      font-size: 24px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledContentContainer = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  text-align: left;\n  width: 90vw;\n  max-width: 624px;\n\n  .subHeaderSpan {\n    margin-bottom: 32px;\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  text-align: left;\n  width: 90vw;\n  max-width: 624px;\n\n  .subHeaderSpan {\n    margin-bottom: 32px;\n  }\n"])));
var templateObject_1$a, templateObject_2$7;

var MitigationBlock = function (_a) {
    var loading = _a.loading, eligibleServices = _a.eligibleServices, block = _a.block;
    var renderMitigationServiceCards = function () {
        return withField(MitigationServiceCard)({ eligibleServices: eligibleServices, block: block, loading: loading });
    };
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(StyledBlockContainer, null,
        React.createElement(Heading, { tag: "h4", size: "md", className: 'mitigationHeader' }, "Let's get you some help right away"),
        React.createElement(StyledContentContainer, null,
            React.createElement(Span, { className: 'subHeaderSpan' }, "The information you shared indicates that you may need some help to prevent any further damages. SageSure has a network of licensed service providers that we can connect you with. Please note, your deductible will apply to these services and only covered losses will be paid. If your loss is not covered under your policy, you will be responsible for paying the entire cost of these services"),
            renderMitigationServiceCards())));
};

var MitigationWrapper = function (_a) {
    var block = _a.block;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var state = useFnolData();
    var policyId = state.policy.policyId, sendPost = state.sendPost, mitigationServices = state.mitigationServices, setMitigationServices = state.setMitigationServices, nextStep = state.nextStep, validate = state.validate, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, setDraftBeingEdited = state.setDraftBeingEdited, editingDraft = state.editingDraft, pendingClaimNumber = state.pendingClaimNumber, definition = state.definition, setShowMitigation = state.setShowMitigation;
    var eligibleServices = block.children.filter(function (item) { return mitigationServices.mitigationEligibility[item.apiKey]; });
    var formik = useFormikContext();
    var saveDraft = useCallback(function (exitReason) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = generateSubmitDraftBody(formik.values, state, {
                        exitStepNumber: 1,
                        exitReason: exitReason,
                    }, user || '', source, draftBeingEdited || undefined);
                    return [4 /*yield*/, sendPost(payload)];
                case 1:
                    data = (_a.sent()).data;
                    setDraftBeingEdited(data);
                    return [2 /*return*/];
            }
        });
    }); }, [formik.values, state, user, source, draftBeingEdited, sendPost, setDraftBeingEdited]);
    var continueForm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((formik.values.customerRequestsDebrisRemoval ||
                        formik.values.customerRequestsSmokeMitigationForPersonalProperty ||
                        formik.values.customerRequestsSmokeMitigationForStructure ||
                        formik.values.customerRequestsTarping ||
                        formik.values.customerRequestsWaterMitigation) &&
                        formik.values.mitigationRejectAll) {
                        formik.setFieldValue(MITIGATION_FIELD_REJECT_ALL, false);
                    }
                    return [4 /*yield*/, validate(formik)];
                case 1:
                    _a.sent();
                    nextStep(formik.values);
                    saveDraft('MSS: Mitigation Services page');
                    return [2 /*return*/];
            }
        });
    }); }, [validate, formik, nextStep, saveDraft]);
    useEffect(function () {
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var filteredVals, body, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setShowMitigation(false);
                        filteredVals = filterUnusedValues(formik.values, definition.blocks, definition.rules);
                        body = mapValuesToSubmit(definition.mappings, filteredVals, {
                            allowDuplicate: true,
                            policyId: policyId,
                            pendingNumber: pendingClaimNumber,
                            previousDraftFnolId: editingDraft ? draftBeingEdited === null || draftBeingEdited === void 0 ? void 0 : draftBeingEdited.draftFnolId : null,
                            draftFnolNumber: editingDraft ? draftBeingEdited === null || draftBeingEdited === void 0 ? void 0 : draftBeingEdited.draftFnolNumber : null,
                            source: source,
                        });
                        return [4 /*yield*/, sendPost(mitigationBody(body))];
                    case 1:
                        data = (_a.sent()).data;
                        setMitigationServices(data);
                        if (Object.values(data.mitigationEligibility).some(function (item) { return item === true; })) {
                            setShowMitigation(true);
                            setLoading(false);
                        }
                        else {
                            continueForm();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.warn('Query Error', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
    }, []); // array intentionally left empty to ensure only fires once
    return (React.createElement(MitigationBlock, { loading: loading, eligibleServices: eligibleServices, 
        // @ts-ignore -- fix types with mitigationServices
        mitigationServices: mitigationServices, block: block }));
};

var MitigationDecline = function (_a) {
    var block = _a.block;
    var state = useFnolData();
    var nextStep = state.nextStep, validate = state.validate, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, setDraftBeingEdited = state.setDraftBeingEdited, sendPost = state.sendPost, mitigationEligibility = state.mitigationServices.mitigationEligibility;
    var formik = useFormikContext();
    var values = formik.values, setFieldValue = formik.setFieldValue;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var saveDraft = useCallback(function (exitReason) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = generateSubmitDraftBody(formik.values, state, {
                        exitStepNumber: 1,
                        exitReason: exitReason,
                    }, user || '', source, draftBeingEdited || undefined);
                    return [4 /*yield*/, sendPost(payload)];
                case 1:
                    data = (_a.sent()).data;
                    setDraftBeingEdited(data);
                    return [2 /*return*/];
            }
        });
    }); }, [formik.values, state, user, source, draftBeingEdited, sendPost, setDraftBeingEdited]);
    var continueForm = useCallback(function (declineMitigations) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (declineMitigations) {
                        if (mitigationEligibility.debrisRemoval) {
                            setFieldValue(MITIGATION_FIELD_DEBRIS_REMOVAL, false);
                        }
                        if (mitigationEligibility.smokeForPersonalProperty) {
                            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_PERSONAL_PROPERTY, false);
                        }
                        if (mitigationEligibility.smokeForStructure) {
                            setFieldValue(MITIGATION_FIELD_SMOKE_FOR_STRUCTURE, false);
                        }
                        if (mitigationEligibility.tarping) {
                            setFieldValue(MITIGATION_FIELD_TARPING, false);
                        }
                        if (mitigationEligibility.waterMitigation) {
                            setFieldValue(MITIGATION_FIELD_WATER, false);
                        }
                        setFieldValue(MITIGATION_FIELD_REJECT_ALL, true);
                    }
                    return [4 /*yield*/, validate(formik)];
                case 1:
                    _a.sent();
                    nextStep(values);
                    if (declineMitigations) {
                        saveDraft('MSS: Mitigation Services Decline page');
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        validate,
        formik,
        nextStep,
        values,
        mitigationEligibility.debrisRemoval,
        mitigationEligibility.smokeForPersonalProperty,
        mitigationEligibility.smokeForStructure,
        mitigationEligibility.tarping,
        mitigationEligibility.waterMitigation,
        setFieldValue,
        saveDraft,
    ]);
    // Skip this step if
    useEffect(function () {
        var mitigationOfferred = isMitigationServicesOffered(mitigationEligibility);
        if (!mitigationOfferred || (mitigationOfferred && isMitigationSelected(values))) {
            continueForm(false);
        }
        else {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // array intentionally left empty to ensure only fires once
    if (loading) {
        return null;
    }
    return React.createElement(MessageBlock, { block: block });
};

var formatBlockOptions = function (block) {
    if (!block || !block.type)
        return [];
    if (block.type === BlockType.Bool) {
        return [
            { title: 'Yes', value: true },
            { title: 'No', value: false },
        ];
    }
    return block.options.map(function (opt) {
        return { title: opt.label, value: opt.value };
    });
};

var MultiSelectWrapper = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  max-width: 624px;\n  width: 90vw;\n  margin-bottom: 20px;\n\n  .option {\n    margin: 0px auto 16px auto;\n    text-align: left;\n  }\n\n  @media (max-width: ", ") {\n    .option {\n      margin: 0px 0px 16px 0px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .option {\n      max-width: 351px;\n      font-size: 12px;\n    }\n  }\n"], ["\n  max-width: 624px;\n  width: 90vw;\n  margin-bottom: 20px;\n\n  .option {\n    margin: 0px auto 16px auto;\n    text-align: left;\n  }\n\n  @media (max-width: ", ") {\n    .option {\n      margin: 0px 0px 16px 0px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .option {\n      max-width: 351px;\n      font-size: 12px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$9;

var MultiSelectBlock = function (_a) {
    var block = _a.block, data = _a.data;
    var name = data.field.name, _b = data.meta, value = _b.value, error = _b.error, touched = _b.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (updatedValue) {
        form.setFieldValue(block.id, updatedValue);
        form.setFieldTouched(block.id, touched);
    }, [block.id, form, touched]);
    var options = formatBlockOptions(block);
    return (React.createElement(MultiSelectWrapper, null,
        React.createElement(CheckboxGroup, { id: "field".concat(block.id), name: name, label: block.description, value: __spreadArray([], value, true), onChange: handleChange, isError: !isValid, errorMessage: error, "aria-label": "step selection" }, options.map(function (opt) { return (React.createElement(CheckboxGroup.Card, __assign({}, opt, { className: "option", key: opt.value, isInvalid: !isValid }))); }))));
};

var RadioWrapper = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n\n  .radioOption {\n    max-width: 624px;\n    margin: 0px auto 16px auto;\n    text-align: left;\n\n    .font-medium:not(.ds__heading) {\n      letter-spacing: 0.5px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .radioOption {\n      margin: 0px 0px 16px 0px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .radioOption {\n      max-width: 351px;\n      font-size: 12px;\n\n      > span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n"], ["\n  width: 90vw;\n  max-width: 624px;\n\n  .radioOption {\n    max-width: 624px;\n    margin: 0px auto 16px auto;\n    text-align: left;\n\n    .font-medium:not(.ds__heading) {\n      letter-spacing: 0.5px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .radioOption {\n      margin: 0px 0px 16px 0px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .radioOption {\n      max-width: 351px;\n      font-size: 12px;\n\n      > span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  max-width: 300px;\n  background: pink;\n  display: flex;\n  flex-flow: column;\n\n  .inlineRadioOption {\n    width: 20px !important;\n  }\n\n  @media (max-width: ", ") {\n    width: 80vw;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  max-width: 300px;\n  background: pink;\n  display: flex;\n  flex-flow: column;\n\n  .inlineRadioOption {\n    width: 20px !important;\n  }\n\n  @media (max-width: ", ") {\n    width: 80vw;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$8, templateObject_2$6;

var RadioBlock = function (_a) {
    var block = _a.block, data = _a.data;
    var name = data.field.name, _b = data.meta, value = _b.value, error = _b.error, touched = _b.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var setValue = function (val) {
        form.setFieldValue(block.id, val);
        form.setFieldTouched(block.id);
    };
    var options = formatBlockOptions(block);
    return (React.createElement(RadioWrapper, null,
        React.createElement(RadioGroup, { id: "field".concat(block.id), name: name, label: block.description, value: value, onChange: setValue, errorMessage: error, isError: !isValid, "aria-label": "step selection" }, options.map(function (opt) { return (React.createElement(RadioGroup.Card, __assign({}, opt, { className: "radioOption", key: opt.title, isError: !isValid }))); }))));
};

var active = css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  background: ", ";\n  border: 2px solid #4197cb;\n  cursor: pointer;\n\n  path {\n    fill: ", ";\n  }\n"], ["\n  background: ", ";\n  border: 2px solid #4197cb;\n  cursor: pointer;\n\n  path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.interactiveDarkened;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
});
var StyledTileContainer = styled.button(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  background-color: ", " !important;\n  border-radius: 8px;\n  border: 2px solid\n    ", ";\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    align-items: center;\n    display: flex;\n    flex-flow: column;\n    margin: auto;\n    width: 30px;\n    height: 30px;\n  }\n\n  label {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  path {\n    fill: ", ";\n  }\n\n  ", ";\n\n  &:hover {\n    ", "\n    background: ", ";\n    ", ";\n    label {\n      color: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  &:focus {\n    background: ", ";\n    label {\n      color: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  @media (max-width: ", ") {\n    flex-flow: row;\n    justify-content: flex-start;\n    min-width: 300px;\n    max-width: 624px;\n    width: 90vw;\n\n    label {\n      text-align: left;\n    }\n\n    svg {\n      margin: 0 15px 0 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: unset;\n  }\n\n  @media (max-width: ", ") {\n    label {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-size: 12px;\n    }\n  }\n"], ["\n  background-color: ", " !important;\n  border-radius: 8px;\n  border: 2px solid\n    ", ";\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    align-items: center;\n    display: flex;\n    flex-flow: column;\n    margin: auto;\n    width: 30px;\n    height: 30px;\n  }\n\n  label {\n    color: ", ";\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  path {\n    fill: ", ";\n  }\n\n  ", ";\n\n  &:hover {\n    ", "\n    background: ", ";\n    ", ";\n    label {\n      color: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  &:focus {\n    background: ", ";\n    label {\n      color: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  @media (max-width: ", ") {\n    flex-flow: row;\n    justify-content: flex-start;\n    min-width: 300px;\n    max-width: 624px;\n    width: 90vw;\n\n    label {\n      text-align: left;\n    }\n\n    svg {\n      margin: 0 15px 0 0;\n    }\n  }\n\n  @media (max-width: ", ") {\n    min-width: unset;\n  }\n\n  @media (max-width: ", ") {\n    label {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-size: 12px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var selected = _a.selected, theme = _a.theme;
    return selected ? (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.interactiveDarkened : 'white';
}, function (_a) {
    var _b;
    var valid = _a.valid, theme = _a.theme;
    return (valid ? (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralLight : theme.border.danger);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var selected = _a.selected;
    return selected && active;
}, active, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.interactiveDarkened;
}, function (_a) {
    var _b;
    var valid = _a.valid, theme = _a.theme;
    return (valid ? (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralLight : theme.border.danger);
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.interactiveDarkened;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.default;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var StyledIconContainer = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n"], ["\n  margin-bottom: 5px;\n"])));
var templateObject_1$7, templateObject_2$5, templateObject_3$2;

var Tile = function (_a) {
    var option = _a.option, data = _a.data, handleSetValue = _a.handleSetValue;
    var _b = data.meta, value = _b.value, error = _b.error, touched = _b.touched;
    var label = option.label, optionValue = option.value, iconUrl = option.iconUrl;
    return (React.createElement(StyledTileContainer, { type: "button", onClick: function () { return handleSetValue(optionValue); }, selected: optionValue === value, valid: touched && error ? false : true, className: "item" },
        React.createElement(StyledIconContainer, { "data-testid": "svg" },
            React.createElement(Icon, { src: "assets/loss-types/".concat(iconUrl), label: typeof label === 'string' ? label : '' })),
        React.createElement("label", null, label)));
};

var StyledSelectBlockContainer = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap; /*  allow items to wrap  */\n  justify-content: flex-start;\n  max-width: 624px;\n\n  .item {\n    padding: 16px;\n    margin: 5px;\n    height: 136px;\n    width: 197px;\n  }\n\n  @media (max-width: ", ") {\n    .item {\n      padding: 12px;\n      height: 72px;\n      min-width: 300px;\n      max-width: 624px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .item {\n      width: 90vw;\n      margin-right: 0;\n      min-width: unset;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap; /*  allow items to wrap  */\n  justify-content: flex-start;\n  max-width: 624px;\n\n  .item {\n    padding: 16px;\n    margin: 5px;\n    height: 136px;\n    width: 197px;\n  }\n\n  @media (max-width: ", ") {\n    .item {\n      padding: 12px;\n      height: 72px;\n      min-width: 300px;\n      max-width: 624px;\n    }\n  }\n\n  @media (max-width: ", ") {\n    .item {\n      width: 90vw;\n      margin-right: 0;\n      min-width: unset;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledSelectBlockContentContainer = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n"])));
var templateObject_1$6, templateObject_2$4;

var SelectBlock = function (_a) {
    var block = _a.block, data = _a.data;
    var touched = data.meta.touched, form = data.form;
    var SelectTile = withField(Tile);
    var handleSetValue = useCallback(function (updatedValue) {
        form.setFieldValue(block.id, updatedValue);
        form.setFieldTouched(block.id);
    }, [block.id, form, touched]);
    return (React.createElement(StyledSelectBlockContentContainer, null,
        React.createElement(StyledSelectBlockContainer, null, block.options.map(function (option, index) { return (React.createElement(Fragment, { key: index }, SelectTile({
            block: block,
            handleValidate: selectFieldValidation(block),
            option: option,
            handleSetValue: handleSetValue,
        }))); })),
        React.createElement(PHErrorMessage, { blockId: block.id })));
};

var StyledSidebarBlockContainer = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  text-align: left;\n  margin-bottom: 100px;\n  max-width: 624px;\n\n  p {\n    margin: 10px 0 !important;\n    text-align: left !important;\n  }\n\n  .sidebarTitle {\n    font-weight: 500;\n    color: #58595B !important;\n  }\n\n  .sidebarDescription {\n    font-weight: 400;\n    color: #58595B !important;\n  }\n\n  @media (max-width: ", ") {\n    width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    margin-top: -30px;\n\n    p {\n      width: 80vw !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  text-align: left;\n  margin-bottom: 100px;\n  max-width: 624px;\n\n  p {\n    margin: 10px 0 !important;\n    text-align: left !important;\n  }\n\n  .sidebarTitle {\n    font-weight: 500;\n    color: #58595B !important;\n  }\n\n  .sidebarDescription {\n    font-weight: 400;\n    color: #58595B !important;\n  }\n\n  @media (max-width: ", ") {\n    width: 624px;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n\n  @media (max-width: ", ") {\n    margin-top: -30px;\n\n    p {\n      width: 80vw !important;\n    }\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.xlarge;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.large;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$5;

var SidebarBlock = function (_a) {
    var block = _a.block;
    if (!block) {
        return null;
    }
    var title = block.title, description = block.description;
    var sanitized = description ? dompurify.sanitize(description) : '';
    return (React.createElement(StyledSidebarBlockContainer, { "data-testid": "sidebar-block" },
        React.createElement(Span, { className: "sidebarTitle" },
            title,
            " ",
            React.createElement(Span, { className: "sidebarDescription" }, sanitized))));
};

var TextAreaBlock = function (_a) {
    var _b;
    var block = _a.block, data = _a.data;
    var _c = data.field, name = _c.name, value = _c.value, _d = data.meta, error = _d.error, touched = _d.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var charRemain = ((_b = block.charLimit) !== null && _b !== void 0 ? _b : 2000) - value.length;
    var handleChange = useCallback(function (e) {
        form.setFieldValue(block.id, e.currentTarget.value);
        form.setFieldTouched(block.id, touched);
    }, [block.id, form, touched]);
    var handleBlur = useCallback(function (e) {
        form.handleBlur(e);
    }, [form]);
    return (React.createElement(StyledTextContainer, { className: "textAreaBlock" },
        React.createElement(Textarea, { id: "field".concat(block.id), name: name, onChange: handleChange, onBlur: handleBlur, value: value, placeholder: block.placeholder, isError: !isValid, errorMessage: error, maxLength: block.charLimit, "aria-label": "loss description textarea" }),
        block.charLimit ? React.createElement(StyledCaption, null,
            charRemain,
            " characters left") : null));
};

var TextBlock = function (_a) {
    var block = _a.block, data = _a.data;
    var _b = data.field, name = _b.name, value = _b.value, _c = data.meta, error = _c.error, touched = _c.touched, form = data.form;
    var isValid = error && touched ? false : true;
    var handleChange = useCallback(function (e) {
        form.setFieldValue(block.id, e.currentTarget.value);
        form.setFieldTouched(block.id, touched);
    }, [block.id, form, touched]);
    var handleBlur = useCallback(function (e) {
        form.handleBlur(e);
    }, [form]);
    // new design has this input removed
    if (block.id === 'timeToCall') {
        return null;
    }
    return (React.createElement(StyledTextContainer, null,
        React.createElement(TextInput$2, { id: "field".concat(block.id), name: name, label: block.description, placeholder: block.placeholder, value: value, onChange: handleChange, onBlur: handleBlur, isError: !isValid, errorMessage: error, "aria-label": "field".concat(block.id), className: classNames({ emailField: block.dataType === 'email' }) })));
};

var TimeWrapper = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n"], ["\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n"])));
var TimeControl = function (_a) {
    var block = _a.block, timeInput = _a.timeInput, periodInput = _a.periodInput, platform = _a.platform;
    var formik = useFormikContext();
    var handleValidate = useCallback(function (value) {
        if (block.required && !hasRequiredValue(value)) {
            return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
        }
        else if (value && !isValidTime(value)) {
            return 'Invalid time format. Please use the format XX:XX.';
        }
    }, [block.required, block.error]);
    return (React.createElement(Field, { component: FormTimeComponent, name: block.id, validate: handleValidate, timeInput: timeInput, periodInput: periodInput, isValid: formik.touched[block.id] && formik.errors[block.id] ? false : true, platform: platform }));
};
var FormTimeComponent = function (_a) {
    var field = _a.field, form = _a.form, props = __rest(_a, ["field", "form"]);
    var _b = useState(''), time = _b[0], setTime = _b[1];
    var _c = useState('AM'), period = _c[0], setPeriod = _c[1];
    var definitionLocation = useFnolData().definitionLocation;
    useEffect(function () {
        if (field && field.value) {
            var savedTime = field.value.split(' ');
            setTime(savedTime[0]);
            setPeriod(savedTime[1]);
        }
    }, [field]);
    var onTimeChange = function (input) {
        if (input === '' || isValidHourAndMinute(input)) {
            var formattedTime = formatTime(input, form.values[field.name]);
            setTime(formattedTime);
            setFormValues(formattedTime, period);
        }
    };
    var setFormValues = function (iTime, iPeriod) {
        if (iTime) {
            form.setFieldValue(field.name, iTime + ' ' + iPeriod, false);
        }
        else {
            form.setFieldValue(field.name, '');
        }
    };
    return (React.createElement(TimeWrapper, null,
        props.timeInput({
            isValid: props.isValid,
            value: time,
            onChange: function (value) {
                onTimeChange(value);
            },
            onBlur: function (value) {
                var formattedTime = formatTimeToRequired(value);
                setTime(formattedTime);
                setFormValues(formattedTime, period);
            },
        }),
        props.periodInput({
            isValid: props.isValid,
            value: period,
            onBlur: function () { },
            onChange: function (value) {
                setPeriod(value);
                setFormValues(time, value);
            },
            caret: "".concat(definitionLocation, "/assets/").concat(props.platform, "/").concat(props.platform, "-caret.svg"),
        })));
};
var templateObject_1$4;

var TimeBlock = function (_a) {
    var block = _a.block;
    return (React.createElement(StyledTimeBlockContainer, null,
        block.description && React.createElement(StyledTimeTitle, null, block.description),
        React.createElement(TimeControl, { block: block, platform: "policyholder", timeInput: function (_a) {
                var value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur;
                return (React.createElement(StyledTimeWrapper, null,
                    React.createElement(TextInput$2, { placeholder: "HH:MM", type: "text", value: value, onChange: function (e) {
                            onChange(e.currentTarget.value);
                        }, onBlur: function (e) {
                            onBlur(e.currentTarget.value);
                        }, "aria-label": "Time input", className: "timeInput", "data-testid": "time-text" })));
            }, periodInput: function (_a) {
                var isValid = _a.isValid, value = _a.value, onChange = _a.onChange;
                return (React.createElement(StyledRadioGroupWrapper, null,
                    React.createElement(RadioGroup, { value: value, onChange: function (value) {
                            onChange(value);
                        }, isError: !isValid, "aria-label": "Time of day", inline: true },
                        React.createElement(Radio, { value: "AM" }, "AM"),
                        React.createElement(Radio, { value: "PM" }, "PM"))));
            } }),
        React.createElement(PHErrorMessage, { blockId: block.id })));
};

var StyledUploadWrapperContainer = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  width: 90vw;\n  max-width: 624px;\n\n  .uploadError {\n    width: 50vw;\n    text-align: left;\n    margin: 0 auto;\n  }\n\n  @media (max-width: ", ") {\n    .uploadError {\n      width: 90vw;\n      word-break: break-word;\n    }\n  }\n"], ["\n  width: 90vw;\n  max-width: 624px;\n\n  .uploadError {\n    width: 50vw;\n    text-align: left;\n    margin: 0 auto;\n  }\n\n  @media (max-width: ", ") {\n    .uploadError {\n      width: 90vw;\n      word-break: break-word;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledUploadWrapperContentContainer = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var StyledUploadWrapperErrorListItem = styled.li(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.default;
});
var StyledImageContainer = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  min-width: 135px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 10px;\n  margin-left: 0;\n\n  &:hover {\n    background: ", ";\n    cursor: pointer;\n  }\n"], ["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  min-width: 135px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 10px;\n  margin-left: 0;\n\n  &:hover {\n    background: ", ";\n    cursor: pointer;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.active;
});
var StyledFileUploadContainer = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  width: 90vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-flow: column nowrap;\n  padding: 48px;\n  max-width: 624px;\n\n  &:hover {\n    background: ", ";\n    cursor: pointer;\n  }\n\n  .fileDropzoneHeader {\n    line-height: 24px;\n    margin: 10px 0 5px;\n  }\n\n  .fileDropzoneSubtext {\n    line-height: 24px;\n    color: ", ";\n  }\n\n  .chooseFilesButton {\n    margin: 24px 0 48px;\n    padding: 15px;\n    border: 1px solid black;\n    border-radius: 8px;\n  }\n\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  width: 90vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-flow: column nowrap;\n  padding: 48px;\n  max-width: 624px;\n\n  &:hover {\n    background: ", ";\n    cursor: pointer;\n  }\n\n  .fileDropzoneHeader {\n    line-height: 24px;\n    margin: 10px 0 5px;\n  }\n\n  .fileDropzoneSubtext {\n    line-height: 24px;\n    color: ", ";\n  }\n\n  .chooseFilesButton {\n    margin: 24px 0 48px;\n    padding: 15px;\n    border: 1px solid black;\n    border-radius: 8px;\n  }\n\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.active;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var StyledFileContainer = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledImageUploaderContainer = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start;\n  width: 100%;\n"])));
// FIX
var StyledSavedImageContainer = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  position: relative;\n  margin: 10px;\n  margin-left: 0;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n"], ["\n  position: relative;\n  margin: 10px;\n  margin-left: 0;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n"])));
var StyledPlaceholder = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  justify-content: center;\n  flex-direction: column;\n  display: flex;\n  margin: 10px;\n  margin-left: 0;\n\n  position: relative;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n"], ["\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  justify-content: center;\n  flex-direction: column;\n  display: flex;\n  margin: 10px;\n  margin-left: 0;\n\n  position: relative;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.border) === null || _b === void 0 ? void 0 : _b.neutralDark;
});
var StyledHiddenOverlay = styled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  background: #004438;\n  padding: 10px;\n  border-radius: 8px;\n"], ["\n  background: #004438;\n  padding: 10px;\n  border-radius: 8px;\n"])));
var StyledImageViewWrapper = styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  justify-content: center;\n  padding: 0;\n  position: relative;\n  z-index: 0;\n\n  .hiddenOverlay {\n    display: none;\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .hiddenOverlay {\n      display: flex;\n      position: absolute;\n      z-index: 9;\n      color: white;\n    }\n\n    &::after {\n      content: \"\";\n      height: 100%;\n      width: 100%;\n      background: ", ");\n      position: absolute;\n    }\n  }\n"], ["\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  justify-content: center;\n  padding: 0;\n  position: relative;\n  z-index: 0;\n\n  .hiddenOverlay {\n    display: none;\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .hiddenOverlay {\n      display: flex;\n      position: absolute;\n      z-index: 9;\n      color: white;\n    }\n\n    &::after {\n      content: \"\";\n      height: 100%;\n      width: 100%;\n      background: ", ");\n      position: absolute;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.purpleHaze;
});
var StyledDismissContainer = styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  position: absolute;\n  border-radius: 50px;\n  color: ", ";\n  right: 2px;\n  top: 2px;\n  z-index: 1;\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  position: absolute;\n  border-radius: 50px;\n  color: ", ";\n  right: 2px;\n  top: 2px;\n  z-index: 1;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.danger;
});
var StyledErrorContainer = styled.div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  text-align: center;\n  display: flex;\n\n  && p {\n    color: ", ";\n    width: auto;\n    padding: 10px;\n    font-size: 12px;\n    line-height: 24px;\n    height: 100px;\n    margin: 0px;\n    white-space: break-spaces;\n    overflow: scroll;\n  }\n"], ["\n  text-align: center;\n  display: flex;\n\n  && p {\n    color: ", ";\n    width: auto;\n    padding: 10px;\n    font-size: 12px;\n    line-height: 24px;\n    height: 100px;\n    margin: 0px;\n    white-space: break-spaces;\n    overflow: scroll;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.danger;
});
var StyledImage = styled.img(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  object-fit: scale-down;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n"], ["\n  object-fit: scale-down;\n  height: 144px;\n  width: 90vw;\n  max-width: 144px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
});
var StyledModalImage = styled.img(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  object-fit: scale-down;\n  height: 250px;\n  width: 250px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n  margin: 0 auto;\n"], ["\n  object-fit: scale-down;\n  height: 250px;\n  width: 250px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n  margin: 0 auto;\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
});
var StyledImagePlaceholderContainer = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    border-radius: 8px;\n    height: 144px;\n    width: 90vw;\n    max-width: 144px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n  }\n"], ["\n    border-radius: 8px;\n    height: 144px;\n    width: 90vw;\n    max-width: 144px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.fill) === null || _b === void 0 ? void 0 : _b.active;
});
var FileUploadContainer = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  align-items: flex-start;\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  width: 100%;\n  height: auto;\n  max-width: 624px;\n\n\n  .handleText {\n    text-align: left;\n    margin: 0 auto;\n    width: 90vw;\n    font-size: 14px;\n    max-width: 624px;\n    color: ", "\n  }\n\n  @media (max-width: ", ") {\n    height: auto;\n    .handleText {\n      width: 90vw;\n    }\n  }\n"], ["\n  align-items: flex-start;\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  width: 100%;\n  height: auto;\n  max-width: 624px;\n\n\n  .handleText {\n    text-align: left;\n    margin: 0 auto;\n    width: 90vw;\n    font-size: 14px;\n    max-width: 624px;\n    color: ", "\n  }\n\n  @media (max-width: ", ") {\n    height: auto;\n    .handleText {\n      width: 90vw;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.text) === null || _b === void 0 ? void 0 : _b.quiet;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.medium;
});
var FileUploadContentContainer = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  margin: 24px 0;\n"], ["\n  margin: 24px 0;\n"])));
var StyledFileContentContainer = styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  z-index: 1;\n  width: 90vw;\n  max-width: 624px;\n\n  &:hover {\n    cursor: default;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"], ["\n  z-index: 1;\n  width: 90vw;\n  max-width: 624px;\n\n  &:hover {\n    cursor: default;\n  }\n\n  @media (max-width: ", ") {\n    width: 90vw;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var StyledFileContent = styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  border-radius: 8px;\n  border: 1px solid ", ";\n  margin: 16px 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n"], ["\n  border-radius: 8px;\n  border: 1px solid ", ";\n  margin: 16px 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.quiet;
});
var StyledFilenameContainer = styled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  margin-left: 10px;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 500px;\n\n  @media (max-width: ", ") {\n    max-width: 400px;\n  }\n\n  @media (max-width: ", ") {\n    max-width: 250px;\n  }\n\n  @media (max-width: ", ") {\n    max-width: 50px;\n  }\n"], ["\n  margin-left: 10px;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 500px;\n\n  @media (max-width: ", ") {\n    max-width: 400px;\n  }\n\n  @media (max-width: ", ") {\n    max-width: 250px;\n  }\n\n  @media (max-width: ", ") {\n    max-width: 50px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.large;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.small;
});
var templateObject_1$3, templateObject_2$3, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;

var ImageDropzone = function (_a) {
    var fileList = _a.fileList, onDrop = _a.onDrop, onDropAccepted = _a.onDropAccepted, onDropRejected = _a.onDropRejected, acceptedFileTypes = _a.acceptedFileTypes, block = _a.block, handleValidate = _a.handleValidate;
    var _b = useDropzone({
        onDrop: onDrop,
        onDropAccepted: onDropAccepted,
        onDropRejected: onDropRejected,
        maxSize: 6000000,
        accept: acceptedFileTypes,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    // need to filter out an accepted file that has an error
    var acceptedFilesErrorLength = fileList.filter(function (file) {
        return file.error;
    }).length;
    // length of ALL accepted files
    var allAcceptedFilesLength = fileList.length;
    // actual number of files accepted
    var filesAcceptedLength = allAcceptedFilesLength - acceptedFilesErrorLength;
    return (React.createElement(StyledImageContainer, __assign({}, getRootProps(), { isDragActive: isDragActive, hasFiles: filesAcceptedLength > 0, "data-testid": "image-dropzone" }),
        React.createElement(Field, { name: block.id, validate: handleValidate }, function () { return React.createElement("input", __assign({}, getInputProps())); }),
        React.createElement(UiIcon, { name: "Add" })));
};

var ImageUploader = function (_a) {
    var list = _a.list, handleRemove = _a.handleRemove, block = _a.block, onDrop = _a.onDrop, onDropAccepted = _a.onDropAccepted, onDropRejected = _a.onDropRejected, acceptedFileTypes = _a.acceptedFileTypes, handleValidate = _a.handleValidate;
    var _b = useState(''), showFileModal = _b[0], setShowFileModal = _b[1];
    var _c = useState(''), showDeleteModal = _c[0], setShowDeleteModal = _c[1];
    var sendPost = useFnolData().sendPost;
    var setFieldValue = useFormikContext().setFieldValue;
    var listToDisplay = __spreadArray(__spreadArray([], list, true), [{ addButton: true }], false);
    useEffect(function () {
        if (list.every(function (item) { return item.dataUrl === null; })) {
            var withImages = list.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, sendPost(getAttachment(item))];
                        case 1:
                            res = _a.sent();
                            item.dataUrl = "data:".concat(item.type, ";base64,").concat(res.content);
                            return [2 /*return*/, item];
                    }
                });
            }); });
            Promise.all(withImages).then(function (items) { return setFieldValue(block.id, JSON.stringify(items)); });
        }
    }, [block.id, list, sendPost, setFieldValue]);
    return (React.createElement(StyledImageUploaderContainer, { className: "files", "data-testid": "image-uploader" }, listToDisplay.map(function (file, index) {
        // @ts-ignore -- ignoring no `addButton` on StyledSavedImageContainer type
        if (file === null || file === void 0 ? void 0 : file.addButton) {
            return (React.createElement(ImageDropzone, { fileList: list, onDrop: onDrop, onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, acceptedFileTypes: acceptedFileTypes, block: block, handleValidate: handleValidate }));
        }
        var ext = file.name.split('.')[1];
        var fileName = file.name;
        var match = fileName.match(/\w+(?=__\d+\.)/);
        if (match != null) {
            fileName = [match[0], ext].join('.');
        }
        switch (file.saved) {
            case true:
                return (React.createElement(StyledSavedImageContainer, { key: file.name },
                    React.createElement(StyledDismissContainer, { onClick: function () {
                            setShowDeleteModal(file.name);
                        } },
                        React.createElement(UiIcon, { name: "Clear" })),
                    React.createElement(StyledImageViewWrapper, { onClick: function () { return setShowFileModal(file.name); } },
                        React.createElement(StyledImage, { src: file.dataUrl, alt: "Damage documentation ".concat(index + 1) }),
                        React.createElement(StyledHiddenOverlay, { className: "hiddenOverlay" },
                            React.createElement(UiIcon, { name: "View" }))),
                    React.createElement(Modal$2, { heading: fileName, open: showFileModal === file.name, onClose: function () { return setShowFileModal(''); }, noFooter: true },
                        React.createElement(StyledModalImage, { src: file.dataUrl, alt: "Damage documentation ".concat(index + 1) })),
                    React.createElement(Modal$2, { heading: "Are you sure?", open: showDeleteModal === file.name, onClose: function () { return setShowDeleteModal(''); }, primaryAction: "Delete file", destructive: true, onPrimaryAction: function () {
                            if (!handleRemove) {
                                return;
                            }
                            handleRemove(index);
                            setShowDeleteModal('');
                        } },
                        React.createElement(React.Fragment, null,
                            "You are about to permanently delete the file: ",
                            fileName))));
            case false:
                return (React.createElement(StyledPlaceholder, { key: file.name },
                    React.createElement(StyledErrorContainer, null,
                        React.createElement("p", null, " File \"".concat(fileName, "\" could not be saved ")),
                        React.createElement(StyledDismissContainer, { onClick: function () {
                                if (!handleRemove) {
                                    return;
                                }
                                handleRemove(index);
                            } },
                            React.createElement(UiIcon, { name: "Clear" })))));
            default:
                return (React.createElement(StyledPlaceholder, { key: file.name }, file.error ? (React.createElement(StyledErrorContainer, null,
                    React.createElement("p", null, " File \"".concat(fileName, "\" ").concat(file.error, " ")),
                    React.createElement(StyledDismissContainer, { onClick: function () {
                            if (!handleRemove) {
                                return;
                            }
                            handleRemove(index);
                        } },
                        React.createElement(UiIcon, { name: "Clear" })))) : (React.createElement(StyledImagePlaceholderContainer, null,
                    React.createElement(Spinner, null)))));
        }
    })));
};

var FileDropzone = function (_a) {
    var fileList = _a.fileList, onDrop = _a.onDrop, onDropAccepted = _a.onDropAccepted, onDropRejected = _a.onDropRejected, acceptedFileTypes = _a.acceptedFileTypes, block = _a.block, handleValidate = _a.handleValidate;
    var _b = useDropzone({
        onDrop: onDrop,
        onDropAccepted: onDropAccepted,
        onDropRejected: onDropRejected,
        maxSize: 6000000,
        accept: acceptedFileTypes,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    // need to filter out an accepted file that has an error
    var acceptedFilesErrorLength = fileList.filter(function (file) {
        return file.error;
    }).length;
    // length of ALL accepted files
    var allAcceptedFilesLength = fileList.length;
    // actual number of files accepted
    var filesAcceptedLength = allAcceptedFilesLength - acceptedFilesErrorLength;
    return (React.createElement(StyledFileUploadContainer, __assign({}, getRootProps(), { isDragActive: isDragActive, hasFiles: filesAcceptedLength > 0, "data-testid": "file-dropzone" }),
        React.createElement(Field, { name: block.id, validate: handleValidate }, function () { return React.createElement("input", __assign({}, getInputProps())); }),
        React.createElement(SpotIcon, { name: "Upload" }),
        React.createElement(Span, { bold: true, size: "md", className: "fileDropzoneHeader" }, "Drag your files here"),
        React.createElement(Span, { className: "fileDropzoneSubtext" }, "Up to 6MB each"),
        React.createElement(Span, { bold: true, className: "chooseFilesButton" }, "Choose files")));
};

var getIconNameFromFileType = function (format) {
    if (!format || !format[1]) {
        return 'Question';
    }
    switch (format[1]) {
        case 'jpg':
            return 'FileJpg';
        case 'png':
            return 'FilePng';
        case 'pdf':
            return 'FilePdf';
        default:
            return 'Question';
    }
};

var StyledFile = function (_a) {
    var format = _a.format, index = _a.index, fileName = _a.fileName, loading = _a.loading;
    var iconName = getIconNameFromFileType(format);
    return (React.createElement(StyledFileContent, { index: index },
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement(UiIcon, { name: iconName }),
            React.createElement(StyledFilenameContainer, null, fileName)),
        React.createElement("div", { style: { display: 'flex', cursor: 'pointer' } }, loading ? React.createElement(Spinner, null) : React.createElement(UiIcon, { name: "Delete" }))));
};
var FileUploader = function (_a) {
    var list = _a.list, handleRemove = _a.handleRemove, block = _a.block, onDrop = _a.onDrop, onDropAccepted = _a.onDropAccepted, onDropRejected = _a.onDropRejected, acceptedFileTypes = _a.acceptedFileTypes, handleValidate = _a.handleValidate;
    var _b = useState(''), showDeleteModal = _b[0], setShowDeleteModal = _b[1];
    var sendPost = useFnolData().sendPost;
    var setFieldValue = useFormikContext().setFieldValue;
    useEffect(function () {
        if (list.every(function (item) { return item.dataUrl === null; })) {
            var withImages = list.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, sendPost(getAttachment(item))];
                        case 1:
                            res = _a.sent();
                            item.dataUrl = "data:".concat(item.type, ";base64,").concat(res.content);
                            return [2 /*return*/, item];
                    }
                });
            }); });
            Promise.all(withImages).then(function (items) { return setFieldValue(block.id, JSON.stringify(items)); });
        }
    }, [block.id, list, sendPost, setFieldValue]);
    return (React.createElement(FileUploadContainer, { className: "files", "data-testid": "file-uploader" },
        React.createElement(FileDropzone, { fileList: list, onDrop: onDrop, onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, acceptedFileTypes: acceptedFileTypes, block: block, handleValidate: handleValidate }),
        React.createElement(Span, { className: "handleText" }, "We can handle: PDF, JPG, PNG"),
        React.createElement(FileUploadContentContainer, null, list.map(function (file, index) {
            var format = file.type.split('/');
            var ext = file.name.split('.')[1];
            var fileName = file.name;
            var match = fileName.match(/\w+(?=__\d+\.)/);
            if (match != null) {
                fileName = [match[0], ext].join('.');
            }
            switch (file.saved) {
                case true:
                    return (React.createElement(StyledFileContainer, { key: file.name },
                        React.createElement(StyledFileContentContainer, { onClick: function () {
                                setShowDeleteModal(file.name);
                            } },
                            React.createElement(StyledFile, { format: format, index: index, fileName: fileName })),
                        React.createElement(Modal$2, { heading: "Are you sure?", open: showDeleteModal === file.name, onClose: function () { return setShowDeleteModal(''); }, primaryAction: "Delete file", destructive: true, onPrimaryAction: function () {
                                if (!handleRemove) {
                                    return;
                                }
                                handleRemove(index);
                                setShowDeleteModal('');
                            } },
                            React.createElement(React.Fragment, null,
                                "You are about to permanently delete the file: ",
                                fileName))));
                case false:
                    return (React.createElement(StyledFileContainer, { key: file.name },
                        React.createElement(StyledErrorContainer, null,
                            React.createElement("p", null, " File \"".concat(fileName, "\" could not be saved ")),
                            React.createElement(StyledFileContentContainer, { onClick: function () {
                                    if (!handleRemove) {
                                        return;
                                    }
                                    handleRemove(index);
                                } },
                                React.createElement(UiIcon, { name: "Clear" })))));
                default:
                    return (React.createElement(StyledFileContainer, { key: file.name }, file.error ? (React.createElement(StyledErrorContainer, null,
                        React.createElement("p", null, " File \"".concat(fileName, "\" ").concat(file.error, " ")),
                        React.createElement(StyledFileContentContainer, { onClick: function () {
                                if (!handleRemove) {
                                    return;
                                }
                                handleRemove(index);
                            } },
                            React.createElement(UiIcon, { name: "Clear" })))) : (React.createElement(StyledFileContainer, { key: file.name },
                        React.createElement(StyledFileContentContainer, null,
                            React.createElement(StyledFile, { format: format, index: index, fileName: fileName, loading: true }))))));
            }
        }))));
};

var UploadWrapper = function (_a) {
    var block = _a.block, acceptedFileTypes = _a.acceptedFileTypes, error = _a.error;
    var formik = useFormikContext();
    var _b = useState(formik.values[block.id] && typeof formik.values[block.id] === 'string'
        ? JSON.parse(formik.values[block.id])
        : []), fileList = _b[0], setFileList = _b[1];
    var _c = useState(), errorList = _c[0], setErrorList = _c[1];
    var _d = useFnolData(), sendPost = _d.sendPost, setQuery = _d.setQuery, pendingClaimNumber = _d.pendingClaimNumber, location = _d.location, policy = _d.policy;
    var fileUploadCreate = useCallback(function (_a) {
        var file = _a.file, acceptedFiles = _a.acceptedFiles;
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedFiles, fileIndex, res, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedFiles = acceptedFiles;
                        fileIndex = updatedFiles.findIndex(function (item) { return item.name === file.name; });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendPost(fileUploadCreateBody(file, policy, pendingClaimNumber))];
                    case 2:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[block.id] = {
                                location: location,
                                dependencies: {},
                                result: res.fileUpload,
                            },
                            _a));
                        if (!res.status || res.status === 200) {
                            updatedFiles[fileIndex].saved = true;
                        }
                        else {
                            updatedFiles[fileIndex].saved = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        // proceed despite server error
                        file.saved = false;
                        updatedFiles[fileIndex].saved = false;
                        console.error('Query Error', err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        setFileList(updatedFiles);
                        formik.setFieldValue(block.id, JSON.stringify(updatedFiles));
                        return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
        return null;
    }, [block.id, formik, location, pendingClaimNumber, policy, sendPost, setQuery]);
    var fileUploadDelete = useCallback(function (file) {
        var sendQuery = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedFiles, fileIndex, res, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedFiles = __spreadArray([], fileList, true);
                        fileIndex = fileList.findIndex(function (item) { return item.name === file.name; });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, sendPost(fileUploadDeleteBody(file, policy, pendingClaimNumber))];
                    case 2:
                        res = _b.sent();
                        setQuery((_a = {},
                            _a[block.id] = {
                                location: location,
                                dependencies: {},
                                result: res.fileUpload,
                            },
                            _a));
                        if (!res.status || res.status === 200) {
                            updatedFiles[fileIndex].saved = true;
                        }
                        else {
                            updatedFiles[fileIndex].saved = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        // proceed despite server error
                        updatedFiles[fileIndex].saved = false;
                        console.error('Query Error', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        sendQuery();
        return null;
    }, [block.id, fileList, location, pendingClaimNumber, policy, sendPost, setQuery]);
    var handleValidate = useCallback(function (value) {
        if (block.required && (!value || value.length < 1)) {
            return block.error && block.error !== '' ? block.error : REQUIRED_ERROR_MESSAGE;
        }
    }, [block.error, block.required]);
    var onDropAccepted = useCallback(function (accepted) {
        formik.setFieldTouched(block.id);
        var acceptedFiles = __spreadArray([], fileList, true);
        var pad = function (n) { return n.toString().padStart(2, '0'); };
        var getTimestamp = function (d) {
            return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), ".").concat(pad(d.getHours()), ".").concat(pad(d.getMinutes()), ".").concat(pad(d.getSeconds()), ".").concat(d.getMilliseconds());
        };
        accepted.forEach(function (file) {
            var reader = new FileReader();
            var errors = [];
            var uploadError;
            reader.onabort = function () {
                uploadError = 'has been aborted';
                errors.push("File \"".concat(file.name, " has been aborted"));
            };
            reader.onerror = function () {
                uploadError = 'upload has failed';
                errors.push("File \"".concat(file.name, " upload has failed"));
            };
            reader.onload = function () {
                var _a;
                var dataUrl = reader.result;
                var fileInfo = {
                    id: Math.random().toString(36).slice(2),
                    dataUrl: dataUrl,
                    encodingScheme: 'Base64',
                    name: file.name.split('.').join("-".concat(getTimestamp(new Date()), ".")),
                    size: file.size,
                    type: file.type,
                    category: block.description ? block.description : block.id,
                    error: uploadError,
                };
                acceptedFiles.push(fileInfo);
                formik.setFieldValue(block.id, JSON.stringify(acceptedFiles));
                setFileList(acceptedFiles);
                fileUploadCreate({
                    id: block.id,
                    file: fileInfo,
                    acceptedFiles: acceptedFiles,
                });
                if (errors.length > 0) {
                    formik.setErrors((_a = {},
                        _a[block.id] = errors,
                        _a));
                }
            };
            reader.readAsDataURL(file);
        });
    }, [fileList, formik, block.id, block.description, fileUploadCreate]);
    var onDropRejected = useCallback(function (rejected) {
        var _a;
        var errors = [];
        rejected.forEach(function (reject) {
            var fileName = reject.file.name;
            reject.errors.forEach(function (error) {
                // NOTE: other error codes we are not handling now too-many-files & file-too-small
                // file size could need to be dyanmic when more carriers are added
                switch (error.code) {
                    case 'file-too-large':
                        return errors.push("File \"".concat(fileName, "\" is larger than 6MB"));
                    case 'file-invalid-type':
                        return errors.push("File \"".concat(fileName, "\" type must be ").concat(acceptedFileTypes));
                }
            });
        });
        setErrorList(errors);
        formik.setErrors((_a = {},
            _a[block.id] = errors,
            _a));
    }, [formik, block.id, acceptedFileTypes]);
    // need to pass acceptedFiles in order for the reset of the errorList to occur when there are only acceptedFiles
    function onDrop(_acceptedFiles, rejectedFiles) {
        if (rejectedFiles.length === 0) {
            setErrorList(undefined);
        }
    }
    var handleRemove = useCallback(function (index) {
        fileUploadDelete(fileList[index]);
        var list = fileList;
        list.splice(index, 1);
        formik.setFieldValue(block.id, JSON.stringify(list));
        setFileList(list);
    }, [fileList, formik, block.id, fileUploadDelete]);
    var renderError = function () {
        if (error && errorList) {
            return (React.createElement(Alert, { className: "uploadError", title: "Something went wrong while uploading the following images:", appearance: "danger", description: errorList.map(function (error) { return (React.createElement(StyledUploadWrapperErrorListItem, { key: error }, error)); }) }));
        }
    };
    var renderUploadContent = function () {
        if (block.id === 'fileUploadDamagePhotos') {
            return (React.createElement(ImageUploader, { list: fileList, handleRemove: handleRemove, block: block, onDrop: onDrop, onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, acceptedFileTypes: acceptedFileTypes, handleValidate: handleValidate }));
        }
        return (React.createElement(FileUploader, { list: fileList, handleRemove: handleRemove, block: block, onDrop: onDrop, onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, acceptedFileTypes: acceptedFileTypes, handleValidate: handleValidate }));
    };
    return (React.createElement(StyledUploadWrapperContainer, null,
        renderError(),
        React.createElement(StyledUploadWrapperContentContainer, null, renderUploadContent())));
};

// TODO: add validation and return FormFields type
var getInitValues = function (blocks, policy, defaultValues) {
    blocks.forEach(function (block) {
        var val = initValue(block, policy);
        if (val != null) {
            defaultValues[block.id] = val;
        }
        if (block.children && block.type !== BlockType.Repeat) {
            getInitValues(block.children, policy, defaultValues);
        }
    });
    return defaultValues;
};
function initRepeatingChildValue(block, policy) {
    return getInitValues(block.children, policy, {});
}
function initValue(block, policy) {
    if (block.type === BlockType.Text) {
        var bt = block;
        var val = bt.defaultValue ? Mustache.render(bt.defaultValue, policy) : '';
        if (bt.dataType === 'tel') {
            val = phoneNumPreFillCompatible(val) ? formatPhoneNum(val) : '';
        }
        return val;
    }
    else if (block.type === BlockType.Select && block.defaultValue) {
        return block.defaultValue;
    }
    else if (block.type === BlockType.Bool && block.defaultValue != null) {
        return block.defaultValue;
    }
    else if (block.type === BlockType.Repeat) {
        return [initRepeatingChildValue(block, policy)];
    }
    else if (block.id === 'hasDrafts') {
        return block.defaultValue;
    }
    else if (![
        BlockType.Section,
        BlockType.Step,
        BlockType.Group,
        BlockType.Message,
        BlockType.Sidebar,
        BlockType.Repeat,
    ].includes(block.type)) {
        // all fields that could change need a default value
        return '';
    }
}

/**
 * This file was copied (and slightly cleaned up) from src/components/common/repeat.tsx
 * No functionality was changed -- all changes are stylistic
 *
 *
 * The repeater is a special kind of group that creates an array of inputs and
 * values based on the single set of children. As an example, let's say we have
 * a repeat block with the id `nameList` and it has two text block children
 * with the IDs `firstName` and `lastName`. In our form values `nameList`
 * would have an array of objects with the two fields, and our UI would have
 * the expected repeating groups of inputs up to the configurable maximum.
 *
 * Formik's FieldArray and array helpers makes this pretty easy. By copying and
 * modifying the blocks with specialized IDs Formik is able to wrangle the
 * values for us.
 */
var RepeatBlock = function (_a) {
    var block = _a.block, addButton = _a.addButton, removeButton = _a.removeButton;
    var policy = useFnolData().policy;
    var values = useFormikContext().values;
    var _b = useState([]), indexedBlocks = _b[0], setIndexedBlocks = _b[1];
    var vals = values[block.id];
    useEffect(function () {
        if (Array.isArray(vals)) {
            // Here's where we're copying the repeat blocks children, and modifying them to
            // work with FieldArray.
            setIndexedBlocks(vals.map(function (_, idx) {
                var copy = JSON.parse(JSON.stringify(block.children));
                walkBlocks(copy, function (b) {
                    b.id = "".concat(block.id, ".").concat(idx, ".").concat(b.id);
                    return true;
                });
                return copy;
            }));
        }
    }, [vals, block.children, block.id]);
    // Map the modified blocks to a set of inputs
    var inputs = function (arrayHelpers) {
        return indexedBlocks.map(function (iBlock, idx) {
            return (React.createElement(StyledRepeatBlockWrapper, { key: idx },
                iBlock.map(function (child) {
                    return React.createElement(FormBlock, { block: child, key: child.id });
                }),
                idx > 0 &&
                    removeButton &&
                    removeButton({
                        label: 'Remove this item',
                        onClick: function () { return arrayHelpers.remove(idx); },
                    })));
        });
    };
    return (React.createElement("div", { "data-testid": "repeat-block" },
        React.createElement(FieldArray, { name: block.id, render: function (arrayHelpers) {
                var _a;
                return (React.createElement(StyledButtonWrapper, null,
                    inputs(arrayHelpers),
                    inputs(arrayHelpers).length < block.max &&
                        addButton({
                            label: (_a = block.actionLabel) !== null && _a !== void 0 ? _a : 'Add',
                            onClick: function () { return arrayHelpers.push(initRepeatingChildValue(block, policy)); },
                        })));
            } })));
};

var FormBlock = function (_a) {
    var block = _a.block;
    var values = useFormikContext().values;
    var _b = useFnolData(), definition = _b.definition, consultativeFnol = _b.consultativeFnol;
    var noRender = definition.rules[block.id] &&
        definition.rules[block.id].length > 0 &&
        !shouldRender(definition.rules[block.id], values);
    if (noRender) {
        return null;
    }
    var renderBlock = function () {
        switch (block.type) {
            case BlockType.MitigationDeclineReason:
                return (React.createElement(MitigationDeclineReason, { block: block, RadioSelect: withField(RadioBlock) }));
            case BlockType.MitigationDecline:
                return React.createElement(MitigationDecline, { block: block });
            case BlockType.Mitigation:
                return React.createElement(MitigationWrapper, { block: block });
            case BlockType.HasDrafts:
                return React.createElement(DraftBlock, { consultativeFnol: consultativeFnol });
            case BlockType.Deductibles:
                return React.createElement(DeductiblesBlockWrapper, null);
            case BlockType.Group:
                return React.createElement(GroupBlock, { block: block });
            case BlockType.Message:
                return React.createElement(MessageBlock, { block: block });
            case BlockType.Text:
                var textBlock = block;
                if (textBlock.dataType === 'tel') {
                    return withField(TelephoneInput)({
                        block: textBlock,
                        handleValidate: telephoneFieldValidation(textBlock),
                    });
                }
                if (textBlock.dataType === 'email') {
                    return withField(TextBlock)({
                        block: textBlock,
                        handleValidate: emailFieldValidation(textBlock),
                    });
                }
                if (textBlock.dataType === 'dollar') {
                    return withField(CurrencyTextInput)({
                        block: textBlock,
                        handleValidate: currencyFieldValidation(textBlock),
                    });
                }
                if (textBlock.dataType === 'text' && (textBlock === null || textBlock === void 0 ? void 0 : textBlock.multiline)) {
                    return withField(TextAreaBlock)({
                        block: textBlock,
                        handleValidate: textFieldValidations(textBlock),
                    });
                }
                return withField(TextBlock)({
                    block: textBlock,
                    handleValidate: textFieldValidations(textBlock),
                });
            case BlockType.Bool:
                var boolBlock = block;
                if (boolBlock.checkbox === false && boolBlock.style !== 'link') {
                    return withField(RadioBlock)({
                        block: boolBlock,
                        handleValidate: boolValidation(boolBlock),
                    });
                }
                if (boolBlock.checkbox) {
                    return withField(CheckboxBool)({
                        block: boolBlock,
                        handleValidate: boolValidation(boolBlock),
                    });
                }
                if (boolBlock.style === 'link') {
                    return withField(LinkBlock)({
                        block: boolBlock,
                        handleValidate: boolValidation(boolBlock),
                    });
                }
                return null;
            case BlockType.Select:
                var selectBlock = block;
                var style = selectBlock.style;
                if (block.id === 'lossType') {
                    return withField(SelectBlock)({
                        block: selectBlock,
                        handleValidate: selectFieldValidation(selectBlock),
                    });
                }
                if (block.id.includes('lossSubType') || block.id.includes('Damage')) {
                    return withField(RadioBlock)({
                        block: selectBlock,
                        handleValidate: selectFieldValidation(selectBlock),
                    });
                }
                // TODO: fix GroupBlock to use this instead of normal select dropdown
                // if (block.id.includes('contactPrimaryPhoneType')) {
                //   return withField(InlineRadioBlock)({ block: selectBlock });
                // }
                if (style === 'standard' || style === 'select') {
                    return withField(SelectInput)({
                        block: selectBlock,
                        handleValidate: selectFieldValidation(selectBlock),
                    });
                }
                if (style === 'combobox') {
                    return withField(ComboBoxInput)({ block: selectBlock });
                }
                if (style === 'radio') {
                    return withField(RadioBlock)({
                        block: block,
                        handleValidate: selectFieldValidation(selectBlock),
                    });
                }
                if (style === 'multi') {
                    return withField(MultiSelectBlock)({
                        block: selectBlock,
                        handleValidate: selectFieldValidation(selectBlock),
                    });
                }
                return null;
            case BlockType.Date:
                return React.createElement(DateBlock, { block: block });
            case BlockType.Time:
                return React.createElement(TimeBlock, { block: block });
            case BlockType.Query:
                var queryBlock = block;
                if (queryBlock.queryType === BlockQueryType.FileUpload) {
                    return (React.createElement(UploadWrapper, { block: queryBlock, acceptedFileTypes: queryBlock.acceptedFileTypes, error: React.createElement(PHErrorMessage, { blockId: block.id }) }));
                }
                return React.createElement(PHQuery, { block: block });
            case BlockType.Repeat:
                return (React.createElement(RepeatBlock, { block: block, addButton: function (_a) {
                        var label = _a.label, onClick = _a.onClick;
                        return (React.createElement(Button, { appearance: "link", onClick: onClick, leadingIcon: "AddCircle" }, label));
                    }, removeButton: function (_a) {
                        var label = _a.label, onClick = _a.onClick;
                        return (React.createElement(Button, { appearance: "link", type: "button", onClick: onClick, leadingIcon: "Clear" }, label));
                    } }));
            case BlockType.Address:
                return (React.createElement(AddressBlock, { block: block, textField: withField(TextInput$1), selectField: withField(SelectInput) }));
            case BlockType.Sidebar:
                return React.createElement(SidebarBlock, { block: block });
            default:
                return null;
        }
    };
    var preventMarginStyling = block.id === "mitigationRejectAll" || block.id === "carrierCheck";
    return React.createElement(StyledFormBlockContainer, { className: classNames({ preventMarginStyling: preventMarginStyling }), id: block.id }, renderBlock());
};

var FormStep = function (_a) {
    var _b;
    var block = _a.block;
    return (React.createElement("div", { id: block.id },
        block.title && block.id !== 'stepMitigationServices' && (React.createElement(StyledHeadingContainer, null,
            React.createElement(Heading, { tag: "h4", size: "md", className: 'formStepHeader' }, block.title))), (_b = block.children) === null || _b === void 0 ? void 0 :
        _b.map(function (child) {
            return React.createElement(FormBlock, { block: child, key: child.id });
        })));
};

var StyledFooterContainer = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  background: ", ";\n  box-shadow: 0px 1px 5px 0px #00000059;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  padding: 1em;\n"], ["\n  background: ", ";\n  box-shadow: 0px 1px 5px 0px #00000059;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  padding: 1em;\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.fill) === null || _b === void 0 ? void 0 : _b.surface;
});
var StyledFooterContentContainer = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  display: flex;\n  width: 624px;\n  justify-content: center;\n\n  button {\n    width: 100% !important;\n    flex-grow: 1;\n    span {\n      margin: 0 !important;\n    }\n  }\n\n  &.isDeductiblesStep {\n    button {\n      width: fit-content !important;\n    }\n  }\n\n  .secondaryButton {\n    margin-right: 16px;\n    width: 100% !important;\n    max-width: 50px !important;\n  }\n\n  .secondaryButtonDraftStep {\n    max-width: 400px !important;\n  }\n\n  .tertiaryButton {\n    max-width: 160px !important;\n    margin: 0 15px;\n  }\n\n  @media (max-width: ", ") {\n    &.isDeductiblesStep,\n    &.isDraftStep {\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n      .secondaryButton {\n        margin-right: 0;\n        margin-bottom: 5px;\n      }\n    }\n\n    .tertiaryButton {\n      white-space: nowrap;\n      text-align: left;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 25px !important;\n      margin: 0 10px 0 0 !important;\n    }\n\n    .secondaryButtonDraftStep {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: auto;\n      margin-bottom: 10px;\n      font-size: 14px;\n    }\n  }\n"], ["\n  display: flex;\n  width: 624px;\n  justify-content: center;\n\n  button {\n    width: 100% !important;\n    flex-grow: 1;\n    span {\n      margin: 0 !important;\n    }\n  }\n\n  &.isDeductiblesStep {\n    button {\n      width: fit-content !important;\n    }\n  }\n\n  .secondaryButton {\n    margin-right: 16px;\n    width: 100% !important;\n    max-width: 50px !important;\n  }\n\n  .secondaryButtonDraftStep {\n    max-width: 400px !important;\n  }\n\n  .tertiaryButton {\n    max-width: 160px !important;\n    margin: 0 15px;\n  }\n\n  @media (max-width: ", ") {\n    &.isDeductiblesStep,\n    &.isDraftStep {\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n      .secondaryButton {\n        margin-right: 0;\n        margin-bottom: 5px;\n      }\n    }\n\n    .tertiaryButton {\n      white-space: nowrap;\n      text-align: left;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 25px !important;\n      margin: 0 10px 0 0 !important;\n    }\n\n    .secondaryButtonDraftStep {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: auto;\n      margin-bottom: 10px;\n      font-size: 14px;\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.small;
});
var templateObject_1$2, templateObject_2$2;

var PREVENT_FWD_NAV_STEPS = [
    'stepDuplicateClaimCheck',
    'stepLossDateOverSixMonths',
    'stepPolicyTermCheck',
];

var StickyFooter = function (_a) {
    var hideBackButton = _a.hideBackButton, currentStepBlock = _a.currentStepBlock, handleOnNext = _a.handleOnNext, handleOnPrevious = _a.handleOnPrevious, handleResumeDraft = _a.handleResumeDraft;
    var sendExit = useFnolData().sendExit;
    var formik = useFormikContext();
    var isPolicyVerificationStep = currentStepBlock.id === 'stepPolicyVerification';
    var isDraftStep = currentStepBlock.id === 'drafts';
    var isDeductiblesStep = currentStepBlock.id === 'stepDeductibles';
    var isContactStep = currentStepBlock.id === 'step-contact-details';
    var isStepPreventingFwdProgress = PREVENT_FWD_NAV_STEPS.includes(currentStepBlock.id);
    var handlePrimaryClick = function () {
        if (isDraftStep) {
            handleResumeDraft();
        }
        else {
            handleOnNext();
        }
        var element = document.getElementById('headerComponent');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    // wait 500ms to accept another click so end-user can't speed through forms
    var debouncedHandlePrimaryClick = debounce(handlePrimaryClick, 500);
    var handleSecondaryClick = function () {
        if (isDraftStep) {
            handleOnNext();
        }
        else {
            handleOnPrevious();
        }
        var element = document.getElementById('headerComponent');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    var handleTertiaryClick = function () {
        sendExit(formik.values);
    };
    var renderPrimaryLabel = function () {
        var nextButtonLabel = 'Next';
        if (currentStepBlock && currentStepBlock.nextLabel) {
            nextButtonLabel = currentStepBlock.nextLabel;
        }
        if (currentStepBlock && currentStepBlock.dynamicNextLabel) {
            var hasValue = formik.values[currentStepBlock.children[0].id] !== '' &&
                formik.values[currentStepBlock.children[0].id] !== '[]';
            nextButtonLabel = hasValue ? 'Next' : currentStepBlock.dynamicNextLabel;
        }
        if (isPolicyVerificationStep) {
            nextButtonLabel = 'Yes, use this one';
        }
        if (isDraftStep) {
            nextButtonLabel = 'Resume';
        }
        if (isDeductiblesStep) {
            nextButtonLabel = 'Continue';
        }
        if (isContactStep) {
            nextButtonLabel = 'Review';
        }
        return nextButtonLabel;
    };
    var renderTertiaryButton = function () {
        return (React.createElement(Button, { appearance: "tertiary", onPress: handleTertiaryClick, className: "tertiaryButton" }, "Save & exit"));
    };
    return (React.createElement(StyledFooterContainer, null,
        React.createElement(StyledFooterContentContainer, { className: classNames({ isDraftStep: isDraftStep, isDeductiblesStep: isDeductiblesStep }) },
            !hideBackButton && (React.createElement(Button, { appearance: "secondary", onPress: handleSecondaryClick, className: classNames({ secondaryButton: true, secondaryButtonDraftStep: isDraftStep }), icon: isDraftStep ? undefined : 'Back' }, isDraftStep ? 'Start new claim' : null)),
            isDeductiblesStep && renderTertiaryButton(),
            !isStepPreventingFwdProgress && (React.createElement(Button, { onPress: debouncedHandlePrimaryClick }, renderPrimaryLabel())))));
};

var FormSection = function (_a) {
    var blockSection = _a.blockSection;
    var state = useFnolData();
    var location = state.location, validate = state.validate, nextStep = state.nextStep, sendEvent = state.sendEvent, definition = state.definition, mappings = state.definition.mappings, sendPost = state.sendPost, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, setDraftBeingEdited = state.setDraftBeingEdited, setHydratingDraft = state.setHydratingDraft, setPendingNumber = state.setPendingNumber, setEditingDraft = state.setEditingDraft, policy = state.policy, consultativeFnol = state.consultativeFnol, prevStep = state.prevStep;
    var formik = useFormikContext();
    var values = formik.values, setValues = formik.setValues, resetForm = formik.resetForm;
    var draft = consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.draftFnols[0];
    var isOnFirstSection = definition.blocks.length != 0 && definition.blocks[0].id === blockSection.id;
    var currentStepBlock = blockSection.children.find(function (child) { return child.id === location.step && child.type === BlockType.Step; });
    var saveDraft = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            setHydratingDraft(true);
            payload = generateSubmitDraftBody(formik.values, state, {
                exitStepNumber: 1,
                exitReason: "MSS: ".concat((currentStepBlock === null || currentStepBlock === void 0 ? void 0 : currentStepBlock.title) === '' ? currentStepBlock.id : currentStepBlock === null || currentStepBlock === void 0 ? void 0 : currentStepBlock.title),
            }, user || '', source, draftBeingEdited || undefined);
            if (formik.values.lossDate && formik.values.lossType) {
                sendPost(payload).then(function (_a) {
                    var data = _a.data;
                    setDraftBeingEdited(data);
                    setHydratingDraft(false);
                });
            }
            return [2 /*return*/];
        });
    }); }, [
        draftBeingEdited,
        formik.values,
        sendPost,
        setDraftBeingEdited,
        setHydratingDraft,
        source,
        state,
        user,
    ]);
    var handleOnNext = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validate(formik)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, formik.validateForm()];
                case 2:
                    results = _a.sent();
                    Object.keys(results).forEach(function (error) { return formik.setFieldTouched(error); });
                    nextStep(formik.values);
                    saveDraft();
                    return [2 /*return*/];
            }
        });
    }); }, [validate, formik, nextStep, saveDraft]);
    var handleOnPrevious = function () {
        prevStep(formik.values);
    };
    var handleResumeDraft = function () {
        setHydratingDraft(true);
        resetForm();
        // @ts-ignore
        var mapped = mapDraftToFnol(mappings, draft === null || draft === void 0 ? void 0 : draft.draftFnolJson, draft === null || draft === void 0 ? void 0 : draft.attachmentMetas);
        setValues(mapped);
        setPendingNumber(draft === null || draft === void 0 ? void 0 : draft.draftFnolJson.pendingNumber);
        formik.setFieldValue('isCommercialProperty', policy.policyType === 'BOP');
        setEditingDraft(true);
        setDraftBeingEdited(draft);
        nextStep(values);
        setTimeout(function () {
            setHydratingDraft(false);
        }, 1000);
    };
    // TODO: 3 useEffects here are causing tons of re-renders
    // investgate why so many and reduce calls
    // Check if page loaded
    useEffect(function () {
        if (location.section && location.step && formik.values) {
            sendEvent({
                name: AnalyticsEventNames.PageLoaded,
                section: location.section,
                step: location.step,
                lossType: formik.values.lossType,
            });
        }
    }, [location.section, location.step, formik.values, sendEvent]);
    // Check validation errors
    useEffect(function () {
        if (location.section && location.step && formik.values) {
            for (var _i = 0, _a = Object.keys(formik.errors); _i < _a.length; _i++) {
                var key = _a[_i];
                if (key in formik.touched) {
                    sendEvent({
                        name: AnalyticsEventNames.ValidationError,
                        section: location.section,
                        step: location.step,
                        lossType: formik.values.lossType,
                        errorMessage: key + ' - ' + formik.errors[key],
                    });
                }
            }
        }
    }, [formik.errors, formik.touched, location.section, location.step, formik.values, sendEvent]);
    useEffect(function () {
        var handleKeypress = function (e) {
            if (e.key === 'Enter' &&
                e.target &&
                e.target instanceof Node &&
                e.target.nodeName == 'BODY' &&
                !document.body.classList.contains('block')) {
                handleOnNext();
            }
            return function () {
                if (document.body.classList.contains('block')) {
                    document.body.classList.remove('block');
                }
            };
        };
        document.addEventListener('keydown', handleKeypress);
        return function () {
            document.removeEventListener('keydown', handleKeypress);
        };
    }, [nextStep, handleOnNext]);
    return (React.createElement(StyledFormSectionContainer, { id: blockSection.id },
        blockSection.children.map(function (child) {
            if (child.type === BlockType.Step) {
                return location.step === child.id && React.createElement(FormStep, { block: child, key: child.id });
            }
            else {
                return React.createElement(FormBlock, { key: child.id, block: child });
            }
        }),
        React.createElement(StickyFooter, { hideBackButton: isOnFirstSection && currentStepBlock.id !== 'drafts', handleOnNext: handleOnNext, handleOnPrevious: handleOnPrevious, handleResumeDraft: handleResumeDraft, currentStepBlock: currentStepBlock })));
};

var FormContent = function () {
    var _a = useFnolData(), definition = _a.definition, location = _a.location, submit = _a.submit;
    var _b = useFormikContext(), values = _b.values, isSubmitting = _b.isSubmitting;
    var renderBlock = function () {
        if ((location === null || location === void 0 ? void 0 : location.section) === REVIEW_ID) {
            return React.createElement(ReviewBlock, { values: values, submitted: submit.success, submissionError: submit.error, isSubmitting: isSubmitting });
        }
        var sectionBlocks = definition.blocks.filter(function (block) {
            return block.type === BlockType.Section && shouldRender(definition.rules[block.id], values);
        });
        var blockSection = sectionBlocks
            .filter(function (block) { return block.id === location.section; })
            .map(function (block) { return React.createElement(FormSection, { blockSection: block, key: block.id }); });
        return blockSection;
    };
    return (React.createElement(StyledFormContent, null,
        React.createElement(Form, null,
            React.createElement(MitigationValueUpdater, null),
            renderBlock())));
};
// tests:
// it should render with form from formik
// it should render with MitigationValueUpdater
// it should render with section block
// it should render with PolicyholderReview if section is REVIEW_ID

function handleSubmit(platform, dispatch, sendSubmit, sendEvent) {
    var _this = this;
    return function (values) { return __awaiter(_this, void 0, void 0, function () {
        var result, date, msg, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    sendEvent({
                        name: AnalyticsEventNames.Submitted,
                        lossType: values.lossType,
                    });
                    return [4 /*yield*/, sendSubmit(values)];
                case 1:
                    result = _b.sent();
                    if (result.submissionNumber || result.claimNumber) {
                        dispatch(submitClaimSuccess(result.submissionNumber, result.claimNumber));
                    }
                    else if (result.status === 400) {
                        // 400 = DateOfLoss happened too long ago (> 6 months)
                        dispatch(submitClaimError('This loss occurred more than 6 months ago. Please contact us at (866) 311-7243 for assistance.'));
                    }
                    else if (result.status === 480) {
                        date = format(new Date("".concat(values.lossDate, " ").concat((_a = values.lossTime) !== null && _a !== void 0 ? _a : '')), 'MMM d, yyyy');
                        dispatch(submitClaimError("We already received a claim for a loss that occurred on ".concat(date, ". Please contact us at (866) 311-7243 for assistance.")));
                    }
                    else {
                        msg = platform === 'policyholder'
                            ? 'Your claim could not be submitted. Please try again in a minute. If you continue to have problems, please contact us at (866) 311-7243.'
                            : 'The claim could not be submitted. Please try again in a minute. If you continue to have problems, please contact support.';
                        dispatch(submitClaimError(msg));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    console.error(err_1);
                    dispatch(submitClaimError());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}

/* eslint-disable react-hooks/exhaustive-deps */
enableES5();
/**
 * Loads and parses the form definition file, rendering children when ready. The
 * definition, policy data, section state, and formik hooks will be available to
 * to all of the children of this component.
 */
var FnolDataProvider = function (_a) {
    var definitionFile = _a.definitionFile, definitionLocation = _a.definitionLocation, definitionFormType = _a.definitionFormType, platform = _a.platform, source = _a.source, policy = _a.policy, children = _a.children, onSubmit = _a.onSubmit, loadError = _a.loadError, loadPlaceholder = _a.loadPlaceholder, googleMapsKey = _a.googleMapsKey, onEvent = _a.onEvent, onExit = _a.onExit, onPost = _a.onPost, user = _a.user;
    var formikRef = useRef(null);
    var _b = useState(), error = _b[0], setError = _b[1];
    var _c = useImmerReducer(reducer, DEFAULT_STATE), state = _c[0], dispatch = _c[1];
    var initFormValues = useRef();
    useEffect(function () {
        // Load form def and set initial location
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, def, sections, location_1, steps, result, err_1, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, sendPost(consultativeFnolBody(policy.policyId, source))];
                    case 1:
                        data = ((_b.sent()) || {}).data;
                        return [4 /*yield*/, loadFormDef(definitionLocation, platform, policy.carrierGroup, definitionFile, definitionFormType)];
                    case 2:
                        def = _b.sent();
                        initFormValues.current = getInitValues(def.blocks, policy, {});
                        initFormValues.current.isCommercialProperty = policy.policyType === 'BOP' ? true : false;
                        initFormValues.current.hasDrafts = ((_a = data === null || data === void 0 ? void 0 : data.draftFnols) === null || _a === void 0 ? void 0 : _a.length) !== 0;
                        dispatch(setConsultativeFnol(data));
                        dispatch(setDefinition(def));
                        dispatch(setDefLocation(definitionLocation));
                        dispatch(setPolicy(policy));
                        dispatch(setSource(source));
                        dispatch(setUser(user));
                        sections = selectSections(def);
                        if (sections[0]) {
                            location_1 = { section: sections[0].id };
                            steps = selectFilteredSteps(sections[0].children, def.rules, initFormValues.current);
                            if (steps[0]) {
                                location_1.step = steps[0].id;
                            }
                            dispatch(setLocation(location_1, initFormValues.current, sendExit));
                        }
                        if (!(state.pendingClaimNumber === '')) return [3 /*break*/, 6];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, sendPost(generatePendingFnolBody())];
                    case 4:
                        result = _b.sent();
                        dispatch(setPendingClaimNumber(result === null || result === void 0 ? void 0 : result.pendingNumber));
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        console.error('Pending claim number error', err_1);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _b.sent();
                        console.error(err_2);
                        setError('Unable to load form.');
                        sendEvent({
                            name: AnalyticsEventNames.FormLoadError,
                            errorMessage: err_2,
                        });
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); })();
        googleMapsKey && dispatch(setGoogleMapsKey(googleMapsKey));
        // Setup popstate handler to update location for browser history changes
        window.onpopstate = function () {
            var location = history.state;
            location.browser = true;
            if (formikRef.current) {
                dispatch(setLocation(location, formikRef.current.values, sendExit));
            }
        };
        // No deps needed here, only want this effect on initial mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        // Update browser history as user moves through sections and steps
        if (!state.location.browser && !isQueryStep(state.location, state.definition)) {
            history.pushState({ section: state.location.section, step: state.location.step }, '');
        }
    }, [state.location, state.definition]);
    useEffect(function () {
        var _a;
        // Add state snapshots to window object for debugging
        window.FNOL_STATE = {
            definitionFile: definitionFile,
            definitionLocation: definitionLocation,
            definitionFormType: definitionFormType,
            platform: platform,
            policy: policy,
            state: state,
            source: source,
            values: (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.values,
        };
    });
    var sendEvent = useCallback(function (event) {
        onEvent(event);
    }, []);
    var sendOnSubmit = useCallback(function (values) {
        var _a, _b, _c, _d, _e;
        var body = {};
        if (state.definition.mappings) {
            var drafts = state.consultativeFnol !== undefined ? (_a = state.consultativeFnol) === null || _a === void 0 ? void 0 : _a.draftFnols : [];
            // IPCM has to select to edit a draft so we check for editingDraft === true
            var ipcmPreviousDraftFnolId = drafts.length > 0 && state.editingDraft ? (_b = state.draftBeingEdited) === null || _b === void 0 ? void 0 : _b.draftFnolId : null;
            var ipcmDraftFnolNumber = drafts.length > 0 && state.editingDraft ? (_c = state.draftBeingEdited) === null || _c === void 0 ? void 0 : _c.draftFnolNumber : null;
            // MSS & AP always saving & editing draft so check source
            var previousDraftFnolId = state.source === 'IPC Manager'
                ? ipcmPreviousDraftFnolId
                : (_d = state.draftBeingEdited) === null || _d === void 0 ? void 0 : _d.draftFnolId;
            var draftFnolNumber = state.source === 'IPC Manager'
                ? ipcmDraftFnolNumber
                : (_e = state.draftBeingEdited) === null || _e === void 0 ? void 0 : _e.draftFnolNumber;
            // new mappings api
            var filteredVals = filterUnusedValues(values, state.definition.blocks, state.definition.rules);
            // Special Mitigation case
            if (values.mitigationRejectAll === false) {
                delete filteredVals['mitigationDeclineReason'];
                delete filteredVals['mitigationDeclineReasonOther'];
            }
            body = submitFnolBody(mapValuesToSubmit(state.definition.mappings, filteredVals, {
                allowDuplicate: source !== 'MySageSure.com',
                policyId: state.policy.policyId,
                pendingNumber: state.pendingClaimNumber,
                previousDraftFnolId: previousDraftFnolId,
                draftFnolNumber: draftFnolNumber,
                source: source,
            }));
        }
        else {
            // legacy losses api
            body = submitBody(values, state.policy, source, state.pendingClaimNumber, source !== 'MySageSure.com');
        }
        return onSubmit(body);
    }, [state.pendingClaimNumber, state.editingDraft, state.consultativeFnol, state.draftBeingEdited]);
    var sendPost = useCallback(onPost, []);
    var sendExit = useCallback(function (lossType) {
        sendEvent({
            name: AnalyticsEventNames.ExitForm,
            section: state.location.section,
            step: state.location.step,
            lossType: lossType,
        });
        onExit();
    }, [state.location.section, state.location.step]);
    if (error) {
        return React.createElement("div", null, loadError);
    }
    if (state.definition.blocks.length === 0 || !state.location.section) {
        return React.createElement(React.Fragment, null, loadPlaceholder);
    }
    return (React.createElement(DesignSystemProvider, null,
        React.createElement(Formik, { initialValues: initFormValues.current, innerRef: formikRef, onSubmit: handleSubmit(platform, dispatch, sendOnSubmit, sendEvent), validateOnBlur: false, validateOnChange: true },
            React.createElement(FnolDataContext.Provider, { value: state },
                React.createElement(FnolDataDispatcher.Provider, { value: {
                        dispatch: dispatch,
                        sendEvent: sendEvent,
                        sendPost: sendPost,
                        sendExit: sendExit,
                    } }, children)))));
};

var css_248z = ".styles-module_backdropenter__rkX8Y {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n\n.styles-module_backdropenterFrom__J7Pw7 {\n  opacity: 0;\n}\n\n.styles-module_backdropenterTo__gvoDh {\n  opacity: 1;\n}\n\n.styles-module_backdropleave__Nt06J {\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  transition-duration: 200ms;\n}\n\n.styles-module_backdropleaveFrom__htrLg {\n  opacity: 1;\n}\n\n.styles-module_backdropleaveTo__yWfAL {\n  opacity: 0;\n}\n\n.styles-module_modalenter__U8ZJx {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  transition-duration: 300ms;\n}\n\n.styles-module_modalenterFrom__MWQI7 {\n  opacity: 0;\n  transform: scale(0.9);\n}\n\n.styles-module_modalenterTo__jyBQv {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.styles-module_modalleave__KOKMV {\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  transition-duration: 200ms;\n}\n\n.styles-module_modalleaveFrom__4a7MY {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.styles-module_modalleaveTo__LRRtp {\n  opacity: 0;\n  transform: scale(0.9);\n}\n";
var styles = {"backdropenter":"styles-module_backdropenter__rkX8Y","backdropenterFrom":"styles-module_backdropenterFrom__J7Pw7","backdropenterTo":"styles-module_backdropenterTo__gvoDh","backdropleave":"styles-module_backdropleave__Nt06J","backdropleaveFrom":"styles-module_backdropleaveFrom__htrLg","backdropleaveTo":"styles-module_backdropleaveTo__yWfAL","modalenter":"styles-module_modalenter__U8ZJx","modalenterFrom":"styles-module_modalenterFrom__MWQI7","modalenterTo":"styles-module_modalenterTo__jyBQv","modalleave":"styles-module_modalleave__KOKMV","modalleaveFrom":"styles-module_modalleaveFrom__4a7MY","modalleaveTo":"styles-module_modalleaveTo__LRRtp"};
styleInject(css_248z);

var StyledDialog = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 10;\n"], ["\n  position: relative;\n  z-index: 10;\n"])));
var Panel = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  border-radius: 4px;\n  position: relative;\n  width: 488px;\n  border: 1px;\n  border-color: rgb(196 196 196);\n  background-color: white;\n  padding: 24px;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n\n  @media (max-width: ", ") {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    inset: 0;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n  }\n"], ["\n  border-radius: 4px;\n  position: relative;\n  width: 488px;\n  border: 1px;\n  border-color: rgb(196 196 196);\n  background-color: white;\n  padding: 24px;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n\n  @media (max-width: ", ") {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    inset: 0;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var ContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    padding: 0 30px;\n  }\n"], ["\n  @media (max-width: ", ") {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    padding: 0 30px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var Backdrop = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: fixed;\n  inset: 0;\n  background-color: rgba(62, 64, 63, 0.85);\n"], ["\n  position: fixed;\n  inset: 0;\n  background-color: rgba(62, 64, 63, 0.85);\n"])));
var ModalOutside = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: fixed;\n  inset: 0;\n  overflow-y: auto;\n"], ["\n  position: fixed;\n  inset: 0;\n  overflow-y: auto;\n"])));
var ModalInside = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  min-height: 100%;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  min-height: 100%;\n  align-items: center;\n  justify-content: center;\n"])));
styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 28px;\n  right: 28px;\n"], ["\n  position: absolute;\n  top: 28px;\n  right: 28px;\n"])));
var DialogTitle = styled.h3(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 500;\n"], ["\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 500;\n"])));
var TitleWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-bottom: 16px;\n  width: 100%;\n"], ["\n  margin-bottom: 16px;\n  width: 100%;\n"])));
var Content = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"])));
var ButtonWrapper = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-top: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  button {\n    white-space: nowrap;\n  }\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-left: 16px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    width: 100%;\n\n    & > :not([hidden]) ~ :not([hidden]) {\n      margin-left: 0;\n      margin-bottom: 24px;\n    }\n  }\n"], ["\n  margin-top: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  button {\n    white-space: nowrap;\n  }\n\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-left: 16px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    width: 100%;\n\n    & > :not([hidden]) ~ :not([hidden]) {\n      margin-left: 0;\n      margin-bottom: 24px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-style: italic;\n"], ["\n  font-style: italic;\n"])));
styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  margin-left: 24px;\n\n  & > div > textarea {\n    resize: none;\n    background-color: white !important;\n  }\n"], ["\n  margin-left: 24px;\n\n  & > div > textarea {\n    resize: none;\n    background-color: white !important;\n  }\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

function Modal(_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, saveDraft = _a.saveDraft;
    var consultativeFnol = useFnolData().consultativeFnol;
    return (React.createElement(Transition, { appear: true, show: isOpen, as: Fragment },
        React.createElement(Dialog, { as: StyledDialog, onClose: setIsOpen },
            React.createElement(Transition.Child, { as: Fragment, enter: styles.backdropenter, enterFrom: styles.backdropenterFrom, enterTo: styles.backdropenterTo, leave: styles.backdropleave, leaveFrom: styles.backdropleaveFrom, leaveTo: styles.backdropleaveTo },
                React.createElement(Backdrop, null)),
            React.createElement(ModalOutside, null,
                React.createElement(ModalInside, null,
                    React.createElement(Transition.Child, { as: Fragment, enter: styles.modalenter, enterFrom: styles.modalenterFrom, enterTo: styles.modalenterTo, leave: styles.modalleave, leaveFrom: styles.modalleaveFrom, leaveTo: styles.modalleaveTo },
                        React.createElement(Dialog.Panel, { as: Panel },
                            React.createElement(ContentWrapper, null,
                                React.createElement(TitleWrapper, null,
                                    React.createElement(Dialog.Title, { as: DialogTitle }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['exit-title'])),
                                React.createElement(Content, null, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['exit-text-1'])),
                            React.createElement(ButtonWrapper, null,
                                React.createElement(Button, { appearance: "tertiary", onClick: setIsOpen, fluid: true }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['exit-continue-button-text']),
                                React.createElement(Button, { onClick: saveDraft, fluid: true }, consultativeFnol === null || consultativeFnol === void 0 ? void 0 : consultativeFnol.constants['exit-return-button-text'])))))))));
}

// create toggle context
var ModalContext = createContext({
    saveDraft: function () {
        throw new Error(FUNCTION_NOT_IMPLEMENTED_ERROR_MESSAGE);
    },
    canSaveDraft: false,
    setCanSaveDraft: function () {
        throw new Error(FUNCTION_NOT_IMPLEMENTED_ERROR_MESSAGE);
    },
    showExitModal: false,
    setShowExitModal: function () {
        throw new Error(FUNCTION_NOT_IMPLEMENTED_ERROR_MESSAGE);
    },
});
var ModalProvider = function (_a) {
    var children = _a.children;
    var state = useFnolData();
    var sendExit = state.sendExit, sendPost = state.sendPost, user = state.user, source = state.source, draftBeingEdited = state.draftBeingEdited, location = state.location;
    var values = useFormikContext().values;
    var _b = useState(false), canSaveDraft = _b[0], setCanSaveDraft = _b[1];
    var _c = useState(false), subLossProvided = _c[0], setSubLossProvided = _c[1];
    var _d = useState(), subLossType = _d[0], setLossSubType = _d[1];
    var _e = useState(false), showExitModal = _e[0], setShowExitModal = _e[1];
    var label = source === 'Agent Portal' ? 'AP' : 'MSS';
    var exitReason = location.step === 'stepDeductibles' ? 'Deductible' : "".concat(label, ": ").concat(location.step);
    var saveDraft = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = generateSubmitDraftBody(values, state, {
                        exitStepNumber: 1,
                        exitReason: exitReason,
                    }, user || '', source, draftBeingEdited || undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendPost(payload)];
                case 2:
                    data = (_a.sent()).data;
                    if (data.draftFnolId) {
                        sendExit(values);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error('Query Error', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ensure subloss type provided for lossType's that require it
    useEffect(function () {
        var subLossKey = getLossSubTypeKey(values);
        if (subLossKey) {
            setLossSubType(values[subLossKey]);
        }
        LOSS_TYPES_WITH_SUBVALUE.includes(values.lossType)
            ? setSubLossProvided(Boolean(subLossType))
            : setSubLossProvided(true);
    }, [subLossType, values]);
    useEffect(function () {
        setCanSaveDraft(values.lossType !== '' && subLossProvided);
    }, [subLossProvided, values.lossType]);
    return (React.createElement(ModalContext.Provider, { value: {
            saveDraft: saveDraft,
            canSaveDraft: canSaveDraft,
            setCanSaveDraft: setCanSaveDraft,
            showExitModal: showExitModal,
            setShowExitModal: setShowExitModal,
        } },
        React.createElement(React.Fragment, null,
            children,
            React.createElement(Modal, { isOpen: showExitModal, setIsOpen: function () { return setShowExitModal(false); }, saveDraft: function () { return saveDraft(); } }))));
};

var Layout = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    bottom: 0;\n    height: 100%;\n    position: absolute;\n    width: 100%;\n  }\n"], ["\n  @media (max-width: ", ") {\n    bottom: 0;\n    height: 100%;\n    position: absolute;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.medium;
});
var Placeholder = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n"])));
var PolicyholderFnol = function (_a) {
    var definitionFile = _a.definitionFile, definitionLocation = _a.definitionLocation, definitionFormType = _a.definitionFormType, policy = _a.policy, user = _a.user, googleMapsKey = _a.googleMapsKey, onPost = _a.onPost, _b = _a.onExit, onExit = _b === void 0 ? function () { } : _b, _c = _a.onEvent, onEvent = _c === void 0 ? function () { } : _c;
    return (React.createElement(FnolDataProvider, { definitionFile: definitionFile, definitionLocation: definitionLocation, definitionFormType: definitionFormType, platform: "policyholder", source: "MySageSure.com", policy: policy, user: user, loadError: React.createElement(FormLoadError, { onReturnClick: onExit }), loadPlaceholder: React.createElement(Placeholder, null,
            React.createElement(Spinner, null)), googleMapsKey: googleMapsKey, onSubmit: onPost, onEvent: onEvent, onExit: onExit, onPost: onPost },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(ModalProvider, null,
                React.createElement(Layout, null,
                    React.createElement(Header, { handleOnExit: onExit }),
                    React.createElement(FormContent, null))))));
};
var templateObject_1, templateObject_2;

export { PolicyholderFnol as default };
//# sourceMappingURL=index.js.map
